export var iconAdd = {
  "id": "icon--add",
  "name": "icon--add",
  "tags": "icon--add",
  "styles": "",
  "viewBox": "0 0 10 10",
  "width": "10",
  "height": "10",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6 4h4v2H6v4H4V6H0V4h4V0h2v4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAddGlyph = {
  "id": "icon--add--glyph",
  "name": "icon--add--glyph",
  "tags": "icon--add--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 9H9v3H7V9H4V7h3V4h2v3h3v2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAddOutline = {
  "id": "icon--add--outline",
  "name": "icon--add--outline",
  "tags": "icon--add--outline",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 14.5c3.6 0 6.5-2.9 6.5-6.5S11.6 1.5 8 1.5 1.5 4.4 1.5 8s2.9 6.5 6.5 6.5zM8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
    }, {
      "d": "M7 7V4h2v3h3v2H9v3H7V9H4V7h3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAppServices = {
  "id": "icon--app-services",
  "name": "icon--app-services",
  "tags": "icon--app-services",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 1.2l10.5 5.7L12 12.8 1.5 7.1 12 1.2zM12 0c-.2 0-.4.1-.6.2L.4 6.3c-.6.4-.6 1.2 0 1.5l11 6c.2.1.4.1.5.1.2 0 .4-.1.6-.2l11-6.1c.6-.4.6-1.2 0-1.6l-11-6H12z"
    }, {
      "d": "M12.1 18.9c-.3 0-.5-.1-.8-.2L.7 12.8c-.5-.2-.7-.7-.7-1.1 0-.5.2-.9.7-1.2l.6-.4c.2-.2.5-.1.7.1.2.2.1.5-.1.7l-.6.4c-.3.1-.3.3-.3.4 0 .1 0 .2.2.3l10.6 5.9c.2.1.4.1.6 0l10.5-6c.2-.1.2-.3.2-.3 0-.1 0-.2-.2-.3l-.6-.3c-.2-.1-.4-.4-.2-.7.1-.2.4-.3.7-.2l.5.3c.5.3.7.7.7 1.2s-.2.9-.7 1.2l-10.5 6c-.2 0-.5.1-.7.1z"
    }, {
      "d": "M12.1 24c-.3 0-.5-.1-.8-.2L.7 17.9c-.5-.2-.7-.7-.7-1.2s.2-.9.7-1.2l.6-.4c.2-.2.5-.1.7.1.1.3 0 .6-.2.8l-.6.4c-.2.1-.2.3-.2.3 0 .1 0 .2.2.3l10.6 5.9c.2.1.4.1.6 0l10.5-6c.2-.1.2-.3.2-.3 0-.1 0-.2-.2-.3l-.6-.3c-.2-.1-.4-.4-.2-.7.1-.2.4-.3.7-.2l.5.3c.5.3.7.7.7 1.2s-.2.9-.7 1.2l-10.5 6c-.2.1-.5.2-.7.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconApps = {
  "id": "icon--apps",
  "name": "icon--apps",
  "tags": "icon--apps",
  "styles": "",
  "viewBox": "0 0 23 23",
  "width": "23",
  "height": "23",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5.8 1.2v4.7H1.2V1.2h4.6zM7 0H0v7h7V0zm6.8 1.2v4.7H9.2V1.2h4.6zM15 0H8v7h7V0zm6.8 1.2v4.7h-4.7V1.2h4.7zM23 0h-7v7h7V0zM5.8 9.2v4.7H1.2V9.2h4.6zM7 8H0v7h7V8zm6.8 1.2v4.7H9.2V9.2h4.6zM15 8H8v7h7V8zm6.8 1.2v4.7h-4.7V9.2h4.7zM23 8h-7v7h7V8zM5.8 17.2v4.7H1.2v-4.7h4.6zM7 16H0v7h7v-7zm6.8 1.2v4.7H9.2v-4.7h4.6zM15 16H8v7h7v-7zm6.8 1.2v4.7h-4.7v-4.7h4.7zM23 16h-7v7h7v-7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconArrowDown = {
  "id": "icon--arrow--down",
  "name": "icon--arrow--down",
  "tags": "icon--arrow--down",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 11.953l3.905-4.09 1.453 1.374L7 16 .635 9.238l1.452-1.376L6 11.954V0h2v11.953z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconArrowLeft = {
  "id": "icon--arrow--left",
  "name": "icon--arrow--left",
  "tags": "icon--arrow--left",
  "styles": "",
  "viewBox": "0 0 16 14",
  "width": "16",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconArrowRight = {
  "id": "icon--arrow--right",
  "name": "icon--arrow--right",
  "tags": "icon--arrow--right",
  "styles": "",
  "viewBox": "0 0 16 14",
  "width": "16",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M11.95 5.997L7.86 2.092 9.233.639l6.763 6.356-6.763 6.366L7.86 11.91l4.092-3.912H-.003v-2h11.952z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconArrowUp = {
  "id": "icon--arrow--up",
  "name": "icon--arrow--up",
  "tags": "icon--arrow--up",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5.993 4.047l-3.905 4.09L.635 6.763 6.992 0l6.366 6.762-1.452 1.376-3.913-4.092V16h-2V4.047z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconArrows = {
  "id": "icon--arrows",
  "name": "icon--arrows",
  "tags": "icon--arrows",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 14.186l2.724-2.477.686.726-3.875 3.524-3.875-3.524.686-.726L11 14.122V0h1v14.186zM5.038 1.805V16h-1V1.805L1.348 4.25l-.685-.727L4.538 0l3.875 3.523-.686.727-2.69-2.445z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAsleep = {
  "id": "icon--asleep",
  "name": "icon--asleep",
  "tags": "icon--asleep",
  "styles": "",
  "viewBox": "0 0 15 16",
  "width": "15",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M14 12c-3.8-.2-6.8-3.3-6.8-7.1 0-1.4.4-2.8 1.3-4V.8c.1-.1.1-.2.1-.3 0-.3-.2-.5-.5-.5H8C3.6 0 0 3.6 0 8s3.6 8 8 8c2.5 0 4.8-1.2 6.3-3.1.2-.2.2-.5.1-.7-.1-.1-.3-.2-.4-.2zm-6 3c-3.9 0-7-3.1-7-7 0-3.6 2.6-6.6 6.2-7-2.1 4-.6 8.9 3.3 11 .8.4 1.6.7 2.5.9-1.3 1.4-3.1 2.1-5 2.1z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAsleepGlyph = {
  "id": "icon--asleep--glyph",
  "name": "icon--asleep--glyph",
  "tags": "icon--asleep--glyph",
  "styles": "",
  "viewBox": "0 0 14 17",
  "width": "14",
  "height": "17",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12.043 3.505c-1.5-2.3-4.1-3.6-6.8-3.5-.301 0-.501.1-.601.4-.1.2 0 .4.2.6.3.3.5.6.7.9 1.2 1.9 1.5 4.3.8 6.4-1 2.5-3.2 4.3-5.8 4.7-.2 0-.4.2-.5.4-.1.2 0 .4.1.6 1.5 1.3 3.4 2 5.3 2 .6 0 1.3-.1 1.9-.2 2.6-.7 4.6-2.5 5.601-5 1-2.5.7-5.2-.9-7.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAttachment = {
  "id": "icon--attachment",
  "name": "icon--attachment",
  "tags": "icon--attachment",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M3.498 7.54l-.707.706L1.124 6.58A3.858 3.858 0 116.58 1.123l8.31 8.311a3.838 3.838 0 010 5.429 3.883 3.883 0 01-5.484 0L6.17 11.625A2.599 2.599 0 019.845 7.95l1.484 1.484-.707.707-1.484-1.484a1.599 1.599 0 10-2.262 2.261l3.237 3.237a2.878 2.878 0 004.059.012 2.842 2.842 0 00.011-4.026l-8.31-8.31a2.858 2.858 0 00-4.043 4.04L3.498 7.54z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAwake = {
  "id": "icon--awake",
  "name": "icon--awake",
  "tags": "icon--awake",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.5 0h1v3h-1zm0 13h1v3h-1zM16 7.5v1h-3v-1zm-13 0v1H0v-1zM1.99 2.697l.707-.707 2.121 2.12-.707.708zm9.192 9.193l.707-.708 2.121 2.121-.707.707zm2.121-9.9l.707.707-2.12 2.121-.708-.707zM4.11 11.182l.708.707-2.121 2.121-.707-.707zM8 10.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 1a3.5 3.5 0 110-7 3.5 3.5 0 010 7z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconBackToTop = {
  "id": "icon--back-to-top",
  "name": "icon--back-to-top",
  "tags": "icon--back-to-top",
  "styles": "",
  "viewBox": "0 0 11 16",
  "width": "11",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 1V0h11v1zm5 3.984L.862 9.357.135 8.67 5.502 3l5.363 5.673-.727.687-4.137-4.376V16H5V4.984z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCalendar = {
  "id": "icon--calendar",
  "name": "icon--calendar",
  "tags": "icon--calendar",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 5h14v1H0V5zm3-5h1v4H3V0zm7 0h1v4h-1V0zM0 2.5A1.5 1.5 0 011.5 1h11A1.5 1.5 0 0114 2.5v12a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 010 14.5v-12zm1 0v12a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-12a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCaretDown = {
  "id": "icon--caret--down",
  "name": "icon--caret--down",
  "tags": "icon--caret--down",
  "styles": "",
  "viewBox": "0 0 10 5",
  "width": "10",
  "height": "5",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0l5 4.998L10 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCaretLeft = {
  "id": "icon--caret--left",
  "name": "icon--caret--left",
  "tags": "icon--caret--left",
  "styles": "",
  "viewBox": "0 0 5 10",
  "width": "5",
  "height": "10",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M4.998 10L0 5l4.998-5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCaretRight = {
  "id": "icon--caret--right",
  "name": "icon--caret--right",
  "tags": "icon--caret--right",
  "styles": "",
  "viewBox": "0 0 5 10",
  "width": "5",
  "height": "10",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 10l4.998-5L0 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCaretUp = {
  "id": "icon--caret--up",
  "name": "icon--caret--up",
  "tags": "icon--caret--up",
  "styles": "",
  "viewBox": "0 0 10 5",
  "width": "10",
  "height": "5",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 5L5 .002 10 5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconChat = {
  "id": "icon--chat",
  "name": "icon--chat",
  "tags": "icon--chat",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M3 8V7h6v1zm0-3V4h10v1z"
    }, {
      "d": "M11.7 12l-3.9 4-.7-.7 4.1-4.3H14c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1H2c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h5.5v1H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2h-2.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCheckmark = {
  "id": "icon--checkmark",
  "name": "icon--checkmark",
  "tags": "icon--checkmark",
  "styles": "",
  "viewBox": "0 0 10 8",
  "width": "10",
  "height": "8",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M8.498 0L10 1.502 3.672 7.83 0 4.158l1.502-1.502 2.17 2.17z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCheckmarkGlyph = {
  "id": "icon--checkmark--glyph",
  "name": "icon--checkmark--glyph",
  "tags": "icon--checkmark--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM6.7 11.5L3.4 8.1l1.4-1.4 1.9 1.9 4.1-4.1 1.4 1.4-5.5 5.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCheckmarkOutline = {
  "id": "icon--checkmark--outline",
  "name": "icon--checkmark--outline",
  "tags": "icon--checkmark--outline",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 14.5c3.6 0 6.5-2.9 6.5-6.5S11.6 1.5 8 1.5 1.5 4.4 1.5 8s2.9 6.5 6.5 6.5zM8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
    }, {
      "d": "M11.3 4.7l1.4 1.4L6.8 12 3.3 8.6l1.4-1.4 2.1 2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconChevronDown = {
  "id": "icon--chevron--down",
  "name": "icon--chevron--down",
  "tags": "icon--chevron--down",
  "styles": "",
  "viewBox": "0 0 12 7",
  "width": "12",
  "height": "7",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M6.002 5.55L11.27 0l.726.685L6.003 7 0 .685.726 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconChevronLeft = {
  "id": "icon--chevron--left",
  "name": "icon--chevron--left",
  "tags": "icon--chevron--left",
  "styles": "",
  "viewBox": "0 0 7 12",
  "width": "7",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M1.45 6.002L7 11.27l-.685.726L0 6.003 6.315 0 7 .726z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconChevronRight = {
  "id": "icon--chevron--right",
  "name": "icon--chevron--right",
  "tags": "icon--chevron--right",
  "styles": "",
  "viewBox": "0 0 7 12",
  "width": "7",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M5.569 5.994L0 .726.687 0l6.336 5.994-6.335 6.002L0 11.27z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconChevronUp = {
  "id": "icon--chevron--up",
  "name": "icon--chevron--up",
  "tags": "icon--chevron--up",
  "styles": "",
  "viewBox": "0 0 12 7",
  "width": "12",
  "height": "7",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M5.994 1.45L.726 7 0 6.315 5.994 0l6.002 6.315L11.27 7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconClose = {
  "id": "icon--close",
  "name": "icon--close",
  "tags": "icon--close",
  "styles": "",
  "viewBox": "0 0 10 10",
  "width": "10",
  "height": "10",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6.32 5L10 8.68 8.68 10 5 6.32 1.32 10 0 8.68 3.68 5 0 1.32 1.32 0 5 3.68 8.68 0 10 1.32 6.32 5z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCloseGlyph = {
  "id": "icon--close--glyph",
  "name": "icon--close--glyph",
  "tags": "icon--close--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCloseOutline = {
  "id": "icon--close--outline",
  "name": "icon--close--outline",
  "tags": "icon--close--outline",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 14.5c3.6 0 6.5-2.9 6.5-6.5S11.6 1.5 8 1.5 1.5 4.4 1.5 8s2.9 6.5 6.5 6.5zM8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
    }, {
      "d": "M8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCode = {
  "id": "icon--code",
  "name": "icon--code",
  "tags": "icon--code",
  "styles": "",
  "viewBox": "0 0 16 10",
  "width": "16",
  "height": "10",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M1.363 5.098l2.928 3.16-.733.68L0 5.098l3.558-3.84.733.68zm13.274 0l-2.928-3.16.733-.68L16 5.098l-3.558 3.84-.733-.68zM6.466 10l-.927-.388L9.56 0l.927.388z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconContainers = {
  "id": "icon--containers",
  "name": "icon--containers",
  "tags": "icon--containers",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21.7 5.8L13.5.4c-.9-.6-2.2-.6-3.1 0L2.2 5.9c-.4.3-.7.6-.9 1.1 0 0-.3.6-.3 1.3v7.6c0 .9.5 1.7 1.3 2.2l8.2 5.4c.5.3 1 .5 1.5.5s1.1-.2 1.6-.5l8.2-5.4c.8-.5 1.2-1.3 1.2-2.2V8.3c0-.3.1-1.5-1.3-2.5zm-18.9.9L11 1.3c.6-.4 1.4-.4 1.9 0l8.2 5.4c.3.2.6.5.7.9L16 11.2l-.4.3L13 9.6c-.6-.4-1.3-.4-1.9 0l-2.6 1.7-6.3-3.8c.1-.3.3-.6.6-.8zm11.9 5.4l-2.3 1.5c-.2.1-.5.1-.7 0L9.4 12l2.3-1.5c.2-.1.5-.1.7 0l2.3 1.6zm7.3 3.8c0 .6-.3 1.1-.8 1.4L13 22.7c-.6.4-1.4.4-1.9 0l-8.3-5.4C2.3 17 2 16.5 2 16V8.6l6.2 3.8 2.9 2c.6.4 1.3.4 1.9 0l2.9-1.9L22 8.6v7.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCopy = {
  "id": "icon--copy",
  "name": "icon--copy",
  "tags": "icon--copy",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M1 10H0V2C0 .9.9 0 2 0h8v1H2c-.6 0-1 .5-1 1v8z"
    }, {
      "d": "M11 4.2V8h3.8L11 4.2zM15 9h-4c-.6 0-1-.4-1-1V4H4.5c-.3 0-.5.2-.5.5v10c0 .3.2.5.5.5h10c.3 0 .5-.2.5-.5V9zm-4-6c.1 0 .3.1.4.1l4.5 4.5c0 .1.1.3.1.4v6.5c0 .8-.7 1.5-1.5 1.5h-10c-.8 0-1.5-.7-1.5-1.5v-10C3 3.7 3.7 3 4.5 3H11z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCopyGlyph = {
  "id": "icon--copy--glyph",
  "name": "icon--copy--glyph",
  "tags": "icon--copy--glyph",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10 4V0H0v12h4v4h10V4h-4zm-6 6H2V2h6v2H4v6zm8 4H6V6h6v8z"
    }, {
      "d": "M7 7h4v2H7zm0 3h4v2H7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCsv = {
  "id": "icon--csv",
  "name": "icon--csv",
  "tags": "icon--csv",
  "styles": "",
  "viewBox": "0 0 12 16",
  "width": "12",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V4L8 0zm2.58 4l-2.54-.01-.03-2.56L10.58 4zM11 15H1v-1.69h10V15zm0-2.69H1V7.53h10v4.78zm0-5.78H1V1h6.01l.03 3a1 1 0 001 .99L11 5v1.53z"
    }, {
      "d": "M3.4 11.5c.32 0 .61-.06.87-.17v-.7c-.13.05-.26.1-.38.14-.13.04-.26.06-.39.06-.45 0-.67-.29-.67-.89 0-.28.05-.51.17-.67.1-.17.25-.25.45-.25.13 0 .25.02.37.05s.23.08.34.13l.25-.65c-.31-.13-.62-.21-.95-.21-.3 0-.57.06-.79.19s-.4.31-.52.56c-.12.24-.18.52-.18.84 0 .51.12.9.37 1.17.24.26.6.4 1.06.4zm2.4 0c.25 0 .46-.04.64-.12s.32-.2.42-.34.14-.32.14-.52c0-.21-.05-.38-.15-.52s-.29-.26-.55-.37c-.28-.13-.45-.22-.51-.26a.223.223 0 01-.09-.17c0-.06.02-.1.07-.14.05-.03.13-.05.23-.05.21 0 .46.07.74.2L7 8.56c-.33-.14-.65-.22-.97-.22-.36 0-.64.08-.85.24-.2.16-.31.38-.31.66 0 .15.02.28.07.39.05.11.12.21.22.29.1.09.25.17.45.26.22.1.36.17.41.2.05.03.09.06.11.1.02.03.03.07.03.11 0 .07-.03.12-.09.17a.49.49 0 01-.27.06c-.14 0-.3-.02-.47-.07-.17-.04-.33-.11-.49-.19v.74c.15.07.29.12.43.15s.32.05.53.05zm3.45-.04l1.01-3.07h-.94L8.9 9.95c-.02.08-.05.2-.08.35-.03.15-.05.27-.06.37-.01-.14-.06-.38-.14-.72L8.2 8.39h-.93l1 3.07h.98z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDashboard = {
  "id": "icon--dashboard",
  "name": "icon--dashboard",
  "tags": "icon--dashboard",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0v24h24V0H0zm1 23V7h8v16H1zm22 0H10v-8h13v8zm0-9H10V7h13v7zM1 6V1h22v5H1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconData = {
  "id": "icon--data",
  "name": "icon--data",
  "tags": "icon--data",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0v24h24V0H0zm22.1 7l-7.2 8.9-9.2-3.8c-.2-.1-.4 0-.6.1L1 16.6V7h21.1zm.9 16H1v-4.9l4.6-5 9.2 3.8c.2.1.4 0 .6-.1L23 7.5V23zm0-17H1V1h22v5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDelete = {
  "id": "icon--delete",
  "name": "icon--delete",
  "tags": "icon--delete",
  "styles": "",
  "viewBox": "0 0 12 16",
  "width": "12",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M11 4v11c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V4H0V3h12v1h-1zM2 4v11h8V4H2z"
    }, {
      "d": "M4 6h1v7H4zm3 0h1v7H7zM3 1V0h6v1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDeleteGlyph = {
  "id": "icon--delete--glyph",
  "name": "icon--delete--glyph",
  "tags": "icon--delete--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5 0h6v2H5zM2 3v3h1v10h10V6h1V3H2zm5 11H5V7h2v7zm4 0H9V7h2v7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDocument = {
  "id": "icon--document",
  "name": "icon--document",
  "tags": "icon--document",
  "styles": "",
  "viewBox": "0 0 12 16",
  "width": "12",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10.581 3.996L8.014 1.429l.026 2.559 2.541.008zM7.011 1H1v14h10V4.997l-2.963-.01a1 1 0 01-.997-.99L7.01 1zM1 0h7l4 4v11a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1z",
      "fill-rule": "nonzero"
    }, {
      "d": "M3 9h6v1H3zm0 3h6v1H3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDownload = {
  "id": "icon--download",
  "name": "icon--download",
  "tags": "icon--download",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.5 11l4.1-4.4.7.7L7 13 1.6 7.3l.7-.7L6.5 11V0h1v11zm5.5 4v-2h1v2c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1v-2h1v2h12z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDownloadGlyph = {
  "id": "icon--download--glyph",
  "name": "icon--download--glyph",
  "tags": "icon--download--glyph",
  "styles": "",
  "viewBox": "-1 2 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 9V2H6.1v7L3.5 6.5 2 8l5 5 5-5-1.5-1.5L8 9z"
    }, {
      "d": "M13 12v3H1v-3h-2v6h16v-6h-2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDraggable = {
  "id": "icon--draggable",
  "name": "icon--draggable",
  "tags": "icon--draggable",
  "styles": "",
  "viewBox": "0 0 6 14",
  "width": "6",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0h2v2H0zm4 0h2v2H4zM0 6h2v2H0zm4 0h2v2H4zm-4 6h2v2H0zm4 0h2v2H4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEdit = {
  "id": "icon--edit",
  "name": "icon--edit",
  "tags": "icon--edit",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.926 3.38L1.002 9.72V12h2.304l6.926-6.316L7.926 3.38zm.738-.675l2.308 2.304 1.451-1.324-2.308-2.309-1.451 1.329zM.002 9.28L9.439.639a1 1 0 011.383.03l2.309 2.309a1 1 0 01-.034 1.446L3.694 13H.002V9.28zM0 16.013v-1h16v1z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEditGlyph = {
  "id": "icon--edit--glyph",
  "name": "icon--edit--glyph",
  "tags": "icon--edit--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M2.032 10.924l7.99-7.99 2.97 2.97-7.99 7.99zm9.014-8.91l1.98-1.98 2.97 2.97-1.98 1.98zM0 16l3-1-2-2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEllipsis = {
  "id": "icon--ellipsis",
  "name": "icon--ellipsis",
  "tags": "icon--ellipsis",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9.5 8.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm5-1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-13 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEmail = {
  "id": "icon--email",
  "name": "icon--email",
  "tags": "icon--email",
  "styles": "",
  "viewBox": "0 0 16 11",
  "width": "16",
  "height": "11",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M2.028 1l5.977 4.38L13.974 1H2.028zM15 1.487L8.3 6.403a.5.5 0 01-.59 0L1 1.486V10h14V1.487zM1 0h14a1 1 0 011 1v9a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEmergencyL2Large = {
  "id": "icon--emergency--l2-large",
  "name": "icon--emergency--l2-large",
  "tags": "icon--emergency--l2-large",
  "styles": "",
  "viewBox": "0 0 63 58",
  "width": "63",
  "height": "58",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill": "#FD6925",
      "d": "M63 0v58H0V0h63zM20.442 17.015h-5.297V42h15.432v-4.375H20.442v-20.61zm21.585-.36c-1.185 0-2.256.118-3.213.351a11.23 11.23 0 00-2.649 1c-.809.433-1.829 1.173-3.059 2.222l2.871 3.4c.991-.82 1.943-1.452 2.854-1.897a6.364 6.364 0 012.82-.666c.923 0 1.66.245 2.213.735.553.49.829 1.236.829 2.239a5.2 5.2 0 01-.376 1.948c-.25.626-.66 1.307-1.23 2.042-.456.588-1.324 1.55-2.604 2.885l-1.037 1.071-6.272 6.34V42H50.64v-4.443H39.754v-.24l3.213-3.025c2.142-1.96 3.637-3.469 4.486-4.528.849-1.06 1.475-2.094 1.88-3.102a8.617 8.617 0 00.606-3.239c0-1.321-.33-2.495-.99-3.52-.662-1.026-1.59-1.823-2.786-2.393-1.197-.57-2.575-.854-4.136-.854z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEmergencyL2Small = {
  "id": "icon--emergency--l2-small",
  "name": "icon--emergency--l2-small",
  "tags": "icon--emergency--l2-small",
  "styles": "",
  "viewBox": "0 0 53 28",
  "width": "53",
  "height": "28",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill": "#FD6925",
      "d": "M39 0c7.732 0 14 6.268 14 14s-6.268 14-14 14H14C6.268 28 0 21.732 0 14S6.268 0 14 0h25zM20.86 8.578h-2.422V20h7.054v-2H20.86V8.578zm9.867-.164c-.542 0-1.032.053-1.47.16-.437.107-.84.26-1.21.457-.37.198-.836.537-1.399 1.016l1.313 1.555a6.652 6.652 0 011.305-.868 2.91 2.91 0 011.289-.304c.422 0 .759.112 1.011.336.253.224.38.565.38 1.023 0 .307-.058.604-.173.89a3.978 3.978 0 01-.562.934c-.2.259-.575.675-1.123 1.25l-.541.559-2.867 2.898V20h7.984v-2.031h-4.977v-.11l1.47-1.382c.815-.747 1.426-1.35 1.831-1.811l.219-.26c.388-.484.675-.957.86-1.418a3.94 3.94 0 00.277-1.48c0-.604-.151-1.14-.453-1.61a3.016 3.016 0 00-1.274-1.093c-.547-.26-1.177-.39-1.89-.39z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEmergencyL3Large = {
  "id": "icon--emergency--l3-large",
  "name": "icon--emergency--l3-large",
  "tags": "icon--emergency--l3-large",
  "styles": "",
  "viewBox": "0 0 63 58",
  "width": "63",
  "height": "58",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill": "#C5192D",
      "d": "M63 0v58H0V0h63zM41.292 16.656c-3.156 0-5.873.82-8.152 2.46l2.444 3.64c1.037-.671 1.98-1.144 2.828-1.418a8.135 8.135 0 012.504-.41c2.37 0 3.555.946 3.555 2.837 0 1.23-.447 2.1-1.342 2.606-.894.507-2.31.76-4.247.76h-1.93v4.051h1.896c2.097 0 3.623.245 4.58.735.957.49 1.436 1.322 1.436 2.495 0 1.31-.416 2.262-1.248 2.854-.831.593-2.119.889-3.862.889-1.14 0-2.29-.154-3.452-.462a16.3 16.3 0 01-3.196-1.196v4.495c2.096.9 4.5 1.35 7.212 1.35 3.236 0 5.725-.67 7.468-2.008 1.743-1.339 2.615-3.21 2.615-5.614 0-1.652-.519-2.965-1.555-3.94-1.037-.974-2.564-1.586-4.58-1.837v-.102c1.709-.41 3.036-1.162 3.982-2.256.945-1.094 1.418-2.421 1.418-3.982 0-1.868-.75-3.327-2.247-4.375-1.499-1.048-3.54-1.572-6.127-1.572zm-20.85.359h-5.297V42h15.432v-4.375H20.442v-20.61z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEmergencyL3Small = {
  "id": "icon--emergency--l3-small",
  "name": "icon--emergency--l3-small",
  "tags": "icon--emergency--l3-small",
  "styles": "",
  "viewBox": "0 0 53 28",
  "width": "53",
  "height": "28",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill": "#C5192D",
      "d": "M39 0c7.732 0 14 6.268 14 14s-6.268 14-14 14H14C6.268 28 0 21.732 0 14S6.268 0 14 0h25zm-8.61 8.414c-1.442 0-2.684.375-3.726 1.125l1.117 1.664c.474-.307.905-.523 1.293-.648.388-.125.77-.188 1.145-.188 1.083 0 1.625.432 1.625 1.297 0 .563-.205.96-.614 1.191-.408.232-1.056.348-1.94.348h-.884v1.852h.867c.959 0 1.657.112 2.094.336.438.224.656.604.656 1.14 0 .6-.19 1.034-.57 1.305-.38.27-.969.406-1.765.406-.521 0-1.047-.07-1.579-.21a7.451 7.451 0 01-1.46-.548v2.055c.958.412 2.057.617 3.296.617 1.48 0 2.617-.306 3.414-.918.797-.612 1.196-1.467 1.196-2.566 0-.755-.237-1.356-.711-1.8-.474-.446-1.172-.726-2.094-.84v-.048c.781-.187 1.388-.53 1.82-1.03.433-.5.649-1.108.649-1.821 0-.854-.343-1.521-1.028-2-.684-.48-1.618-.719-2.8-.719zm-9.53.164h-2.422V20h7.054v-2H20.86V8.578z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEmergencyMLarge = {
  "id": "icon--emergency--m-large",
  "name": "icon--emergency--m-large",
  "tags": "icon--emergency--m-large",
  "styles": "",
  "viewBox": "0 0 63 58",
  "width": "63",
  "height": "58",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill": "#19486A",
      "d": "M63 0v58H0V0h63zM26.356 17.015h-7.211V42h4.733V30.379c0-.988-.059-2.703-.178-5.147l-.146-2.834h.154L29.723 42h4.854l6.443-19.568h.153c-.115 2.66-.188 4.457-.218 5.388l-.022.85c-.005.278-.01.542-.012.793l-.004.71V42h4.939V17.015h-7.212L32.372 36.12h-.102l-5.914-19.106z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEmergencyMSmall = {
  "id": "icon--emergency--m-small",
  "name": "icon--emergency--m-small",
  "tags": "icon--emergency--m-small",
  "styles": "",
  "viewBox": "0 0 53 28",
  "width": "53",
  "height": "28",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill": "#19486A",
      "d": "M39 0c7.732 0 14 6.268 14 14s-6.268 14-14 14H14C6.268 28 0 21.732 0 14S6.268 0 14 0h25zM24.734 8.578h-3.297V20h2.165v-5.313c0-.342-.016-.877-.047-1.604l-.102-2.044h.07L26.273 20h2.22l2.945-8.945h.07a259.033 259.033 0 00-.101 2.493l-.016.847V20h2.257V8.578h-3.296l-2.868 8.735h-.047l-2.703-8.735z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconError = {
  "id": "icon--error",
  "name": "icon--error",
  "tags": "icon--error",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 16A8 8 0 118 0a8 8 0 010 16zM4 4.65L11.35 12l.65-.65L4.65 4 4 4.65z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconErrorGlyph = {
  "id": "icon--error--glyph",
  "name": "icon--error--glyph",
  "tags": "icon--error--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM5.1 13.3L3.5 12 11 2.6l1.5 1.2-7.4 9.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconErrorOutline = {
  "id": "icon--error--outline",
  "name": "icon--error--outline",
  "tags": "icon--error--outline",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M2.751 4.165a6.5 6.5 0 009.084 9.084L2.75 4.165zm1.414-1.414l9.084 9.084A6.5 6.5 0 004.165 2.75zM8 16A8 8 0 118 0a8 8 0 010 16z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconErrorSolid = {
  "id": "icon--error--solid",
  "name": "icon--error--solid",
  "tags": "icon--error--solid",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 16A8 8 0 118 0a8 8 0 010 16zM3.293 4.707l8 8 1.414-1.414-8-8-1.414 1.414z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFavorite = {
  "id": "icon--favorite",
  "name": "icon--favorite",
  "tags": "icon--favorite",
  "styles": "",
  "viewBox": "0 0 16 15",
  "width": "16",
  "height": "15",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8.109 11.75l-4.5 3.2c-.2.1-.5 0-.4-.3l1.5-5.1-4.6-3.2c-.2-.2-.1-.5.1-.5l5.5-.5 2-5.2c.1-.2.4-.2.5 0l2 5.2 5.5.5c.2 0 .3.3.1.4l-4.5 3.3 1.5 5.1c.1.2-.2.4-.4.3l-4.3-3.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFavoriteOutline = {
  "id": "icon--favorite--outline",
  "name": "icon--favorite--outline",
  "tags": "icon--favorite--outline",
  "styles": "",
  "viewBox": "0 0 16 14",
  "width": "16",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M11.58 1a3.41 3.41 0 012.21 6L8 12.49 2.15 7a3.42 3.42 0 115-4.55L8 3.54l.81-1.12A3.43 3.43 0 0111.58 1m0-1A4.39 4.39 0 008 1.84a4.41 4.41 0 10-6.51 5.88L8 13.87l6.46-6.08A4.42 4.42 0 0011.58 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFavoriteSolid = {
  "id": "icon--favorite--solid",
  "name": "icon--favorite--solid",
  "tags": "icon--favorite--solid",
  "styles": "",
  "viewBox": "0 0 16 14",
  "width": "16",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M1.49 7.72A4.41 4.41 0 118 1.84a4.42 4.42 0 116.44 6L8 13.87z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFemale = {
  "id": "icon--female",
  "name": "icon--female",
  "tags": "icon--female",
  "styles": "",
  "viewBox": "0 0 8 16",
  "width": "8",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.958 10.653L6.71 5.519a1.506 1.506 0 00-.668-.93A2.739 2.739 0 006.75 2.75 2.753 2.753 0 004 0a2.753 2.753 0 00-2.75 2.75c0 .706.268 1.35.707 1.838a1.506 1.506 0 00-.667.931L.041 10.653a1.5 1.5 0 001.46 1.847h.404v1.844c0 .913.743 1.656 1.656 1.656h.875c.914 0 1.657-.743 1.657-1.656V12.5h.404a1.5 1.5 0 001.46-1.847zM4 1a1.75 1.75 0 110 3.5A1.75 1.75 0 014 1zm2.5 10.5H5.094v2.844a.656.656 0 01-.657.656h-.875a.656.656 0 01-.656-.656V11.5H1.5a.5.5 0 01-.488-.61l1.25-5.14a.5.5 0 01.488-.39h.386a2.75 2.75 0 001.728 0h.386a.5.5 0 01.488.39l1.25 5.14a.5.5 0 01-.488.61z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFilter = {
  "id": "icon--filter",
  "name": "icon--filter",
  "tags": "icon--filter",
  "styles": "",
  "viewBox": "0 0 16 12",
  "width": "16",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8.05 2a2.5 2.5 0 014.9 0H16v1h-3.05a2.5 2.5 0 01-4.9 0H0V2h8.05zm2.45 2a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM3.05 9a2.5 2.5 0 014.9 0H16v1H7.95a2.5 2.5 0 01-4.9 0H0V9h3.05zm2.45 2a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFilterGlyph = {
  "id": "icon--filter--glyph",
  "name": "icon--filter--glyph",
  "tags": "icon--filter--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5 0C3.7 0 2.6.8 2.2 2H0v2h2.2C2.6 5.2 3.7 6 5 6c1.3 0 2.4-.8 2.8-2H16V2H7.8C7.4.8 6.3 0 5 0zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm0 6c-1.3 0-2.4.8-2.8 2H0v2h2.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H16v-2H7.8c-.4-1.2-1.5-2-2.8-2zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
      "fill": "#231F20"
    }, {
      "d": "M11 5c-1.3 0-2.4.8-2.8 2H0v2h8.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H16V7h-2.2c-.4-1.2-1.5-2-2.8-2zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
      "fill": "#231F20"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFilterAlt = {
  "id": "icon--filter-alt",
  "name": "icon--filter-alt",
  "tags": "icon--filter-alt",
  "styles": "",
  "viewBox": "0 0 16 14",
  "width": "16",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M4.571 8L2.857 5h10.286l-1.714 3H4.57zm1.143 2h4.572L8 14l-2.286-4zm-4-7L0 0h16l-1.714 3H1.714z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFolder = {
  "id": "icon--folder",
  "name": "icon--folder",
  "tags": "icon--folder",
  "styles": "",
  "viewBox": "0 0 14 12",
  "width": "14",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13 12H1a1 1 0 01-1-1V1.001a1 1 0 011.002-1l2.293.005a1 1 0 01.704.291L5.707 2H13a1 1 0 011 1v8a1 1 0 01-1 1zm0-9H5.707A1 1 0 015 2.708L3.293 1.006 1 1v10h12V3z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFolderGlyph = {
  "id": "icon--folder--glyph",
  "name": "icon--folder--glyph",
  "tags": "icon--folder--glyph",
  "styles": "",
  "viewBox": "0 0 16 12",
  "width": "16",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 12h16V2H8V0H0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconForum = {
  "id": "icon--forum",
  "name": "icon--forum",
  "tags": "icon--forum",
  "styles": "",
  "viewBox": "0 0 16 15",
  "width": "16",
  "height": "15",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M11.7 12l-3 3-.7-.7 3.3-3.3h3.2c.3 0 .5-.2.5-.5v-6c0-.3-.2-.5-.5-.5h-10c-.3 0-.5.2-.5.5v6c0 .3.2.5.5.5H8v1H4.5c-.8 0-1.5-.7-1.5-1.5v-6C3 3.7 3.7 3 4.5 3h10c.8 0 1.5.7 1.5 1.5v6c0 .8-.7 1.5-1.5 1.5h-2.8z"
    }, {
      "d": "M1 8H0V1.5C0 .7.7 0 1.5 0H8v1H1.5c-.3 0-.5.2-.5.5V8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconGlobe = {
  "id": "icon--globe",
  "name": "icon--globe",
  "tags": "icon--globe",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm6.232 4.903h-2.661c-.29-1.432-.777-2.651-1.394-3.52a6.998 6.998 0 014.055 3.52zM10.84 8c0 .739-.052 1.426-.139 2.065H5.3A15.247 15.247 0 015.161 8c0-.739.052-1.426.139-2.065h5.4c.087.64.139 1.326.139 2.065zM8 1.032c.868 0 1.98 1.423 2.52 3.871H5.48c.54-2.448 1.652-3.87 2.52-3.87zm-2.177.352c-.613.864-1.104 2.084-1.394 3.52H1.768a6.998 6.998 0 014.055-3.52zM1.033 8c0-.72.109-1.413.312-2.065h2.92a15.778 15.778 0 000 4.129h-2.92A6.924 6.924 0 011.032 8zm.735 3.097h2.661c.29 1.432.777 2.651 1.394 3.52a6.998 6.998 0 01-4.055-3.52zM8 14.967c-.868 0-1.98-1.422-2.52-3.87h5.04c-.54 2.448-1.652 3.87-2.52 3.87zm2.177-.35c.613-.865 1.104-2.085 1.394-3.52h2.661a6.998 6.998 0 01-4.055 3.52zm1.558-4.552a15.778 15.778 0 000-4.129h2.92c.203.651.313 1.345.313 2.064 0 .72-.11 1.413-.313 2.065h-2.92z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconGrid = {
  "id": "icon--grid",
  "name": "icon--grid",
  "tags": "icon--grid",
  "styles": "",
  "viewBox": "0 0 15 15",
  "width": "15",
  "height": "15",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M1 1v4h4V1H1zm0-1h4a1 1 0 011 1v4a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1zm0 10v4h4v-4H1zm0-1h4a1 1 0 011 1v4a1 1 0 01-1 1H1a1 1 0 01-1-1v-4a1 1 0 011-1zm9-8v4h4V1h-4zm0-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V1a1 1 0 011-1zm0 14h4v-4h-4v4zm0-5h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4a1 1 0 011-1z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderAvatar = {
  "id": "icon--header--avatar",
  "name": "icon--header--avatar",
  "tags": "icon--header--avatar",
  "styles": "",
  "viewBox": "0 0 20 20",
  "width": "20",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6 15.745A6.968 6.968 0 0010 17a6.968 6.968 0 004-1.255V15.5a2.5 2.5 0 00-2.5-2.5h-3A2.5 2.5 0 006 15.5v.245zm-.956-.802A3.5 3.5 0 018.5 12h3a3.5 3.5 0 013.456 2.943 7 7 0 10-9.912 0zM10 18a8 8 0 110-16 8 8 0 010 16z",
      "fill-rule": "nonzero"
    }, {
      "d": "M10 10a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderChevron = {
  "id": "icon--header--chevron",
  "name": "icon--header--chevron",
  "tags": "icon--header--chevron",
  "styles": "",
  "viewBox": "0 0 20 20",
  "width": "20",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M6.542 4.945l.707-.707 6.004 6.004-6.004 6.02-.708-.707 5.298-5.312z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderClose = {
  "id": "icon--header--close",
  "name": "icon--header--close",
  "tags": "icon--header--close",
  "styles": "",
  "viewBox": "0 0 20 20",
  "width": "20",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10 9.293l4.146-4.147.708.708L10.707 10l4.147 4.146-.708.708L10 10.707l-4.146 4.147-.708-.708L9.293 10 5.146 5.854l.708-.708L10 9.293z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderDocs = {
  "id": "icon--header--docs",
  "name": "icon--header--docs",
  "tags": "icon--header--docs",
  "styles": "",
  "viewBox": "0 0 20 20",
  "width": "20",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5 2h7l4 4v11a1 1 0 01-1 1H5a1 1 0 01-1-1V3a1 1 0 011-1zm6.586 1H5v14h10V6.414L11.586 3zm3.41 2.997L16 7l-3.963-.012a1 1 0 01-.997-.99L11 2l1.01 1.01.03 2.978 2.957.009zM16 7l-3.963-.012a1 1 0 01-.997-.99L11 2l1.01 1.01.03 2.978 2.957.009L16 7z",
      "fill-rule": "nonzero"
    }, {
      "d": "M7 11h6v1H7zm0 3h6v1H7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderHamburger = {
  "id": "icon--header--hamburger",
  "name": "icon--header--hamburger",
  "tags": "icon--header--hamburger",
  "styles": "",
  "viewBox": "0 0 20 20",
  "width": "20",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M3 4h14v1H3zm0 6h14v1H3zm0 6h14v1H3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderNotification = {
  "id": "icon--header--notification",
  "name": "icon--header--notification",
  "tags": "icon--header--notification",
  "styles": "",
  "viewBox": "0 0 20 20",
  "width": "20",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.17 17H2.5a.5.5 0 01-.5-.5v-2a.5.5 0 01.146-.354L4 12.293V9a6 6 0 015.5-5.98V1h1v2.02A6 6 0 0116 9v3.293l1.854 1.853A.5.5 0 0118 14.5v2a.5.5 0 01-.5.5h-4.67a3.001 3.001 0 01-5.66 0zm1.098 0a2 2 0 003.464 0H8.268zM13 16h4v-1.293l-1.854-1.853A.5.5 0 0115 12.5V9A5 5 0 005 9v3.5a.5.5 0 01-.146.354L3 14.707V16h10z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderSearch = {
  "id": "icon--header--search",
  "name": "icon--header--search",
  "tags": "icon--header--search",
  "styles": "",
  "viewBox": "0 0 20 20",
  "width": "20",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8.5 14a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm4.936-1.27l4.418 4.416-.708.708-4.417-4.418a6.5 6.5 0 11.707-.707z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderUser = {
  "id": "icon--header--user",
  "name": "icon--header--user",
  "tags": "icon--header--user",
  "styles": "",
  "viewBox": "0 0 20 20",
  "width": "20",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10 9a3 3 0 100-6 3 3 0 000 6zm0 1a4 4 0 110-8 4 4 0 010 8zm-5 8H4v-2.48a4.5 4.5 0 014.5-4.5l3.022.014a4.5 4.5 0 014.478 4.5V18h-1v-2.466a3.5 3.5 0 00-3.483-3.5l-3-.015A3.504 3.504 0 005 15.52V18z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHelp = {
  "id": "icon--help",
  "name": "icon--help",
  "tags": "icon--help",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }, {
      "d": "M8.3 10c.2-2 1.5-3.5 3.7-3.5 2.8 0 3.7 1.8 3.7 2.9 0 2.9-2.5 2.5-2.7 4.3V15h-2v-1c.2-2.6 2.4-2.8 2.3-4.4 0-.9-.5-1.3-1.3-1.3-1 0-1.5.8-1.5 1.7H8.3zm2.7 6h2v2h-2v-2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHelpGlyph = {
  "id": "icon--help--glyph",
  "name": "icon--help--glyph",
  "tags": "icon--help--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm.9 13H7v-1.8h1.9V13zm-.1-3.6v.5H7.1v-.6c.2-2.1 2-1.9 1.9-3.2.1-.7-.3-1.1-1-1.1-.8 0-1.2.7-1.2 1.6H5c0-1.7 1.2-3 2.9-3 2.3 0 3 1.4 3 2.3.1 2.3-1.9 2-2.1 3.5z",
      "fill": "#231F20"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHelpOutline = {
  "id": "icon--help--outline",
  "name": "icon--help--outline",
  "tags": "icon--help--outline",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": [{
      "cx": "8",
      "cy": "13",
      "r": "1"
    }],
    "ellipses": "",
    "paths": [{
      "d": "M8 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM8 16A8 8 0 118 0a8 8 0 010 16z",
      "fill-rule": "nonzero"
    }, {
      "d": "M8.75 9.364V10.5h-1.5V7.863h1.5A1.682 1.682 0 008.678 4.5h-.996C6.753 4.5 6 5.253 6 6.182H4.5A3.182 3.182 0 017.682 3h.996a3.182 3.182 0 01.072 6.364z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHome = {
  "id": "icon--home",
  "name": "icon--home",
  "tags": "icon--home",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13.555 9.515v3.842a.654.654 0 01-.666.643H9.666a.329.329 0 01-.333-.322v-3.002a.329.329 0 00-.334-.322H7a.329.329 0 00-.333.322v3.002c0 .177-.15.322-.334.322H3.11a.654.654 0 01-.667-.643V9.515a.32.32 0 01.122-.25l5.223-4.149a.348.348 0 01.425 0l5.223 4.15c.075.062.12.153.12.25zm2.323-1.632l-2.323-1.847V2.323a.329.329 0 00-.333-.322h-1.556a.329.329 0 00-.333.322v1.946L8.846 2.294a1.37 1.37 0 00-1.694 0L.12 7.883a.315.315 0 00-.045.453l.709.83a.343.343 0 00.469.044l6.534-5.193a.348.348 0 01.425 0l6.534 5.193a.343.343 0 00.47-.043l.708-.831a.315.315 0 00-.047-.453z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconInfo = {
  "id": "icon--info",
  "name": "icon--info",
  "tags": "icon--info",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }, {
      "d": "M14 10H9v2h2v4H9v2h7v-2h-2zM11 7.5a1.5 1.5 0 113 0 1.5 1.5 0 11-3 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconInfoGlyph = {
  "id": "icon--info--glyph",
  "name": "icon--info--glyph",
  "tags": "icon--info--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 4c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm2 8H6v-1h1V8H6V7h3v4h1v1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconInfoOutline = {
  "id": "icon--info--outline",
  "name": "icon--info--outline",
  "tags": "icon--info--outline",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": [{
      "cx": "8",
      "cy": "4",
      "r": "1"
    }],
    "ellipses": "",
    "paths": [{
      "d": "M8 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM8 16A8 8 0 118 0a8 8 0 010 16z",
      "fill-rule": "nonzero"
    }, {
      "fill-rule": "nonzero",
      "d": "M9 13H7V7h2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconInfoSolid = {
  "id": "icon--info--solid",
  "name": "icon--info--solid",
  "tags": "icon--info--solid",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 16A8 8 0 118 0a8 8 0 010 16zm1-3V7H7v6h2zM8 5a1 1 0 100-2 1 1 0 000 2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconLaunch = {
  "id": "icon--launch",
  "name": "icon--launch",
  "tags": "icon--launch",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M14.3 1h-3.8V0H16v5.5h-1V1.7L9.7 7 9 6.3 14.3 1z"
    }, {
      "d": "M14.3 1h-3.8V0H16v5.5h-1V1.7L9.7 7 9 6.3 14.3 1z"
    }, {
      "d": "M13 9h1v6c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h7v1H1v12h12V9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconLaunchGlyph = {
  "id": "icon--launch--glyph",
  "name": "icon--launch--glyph",
  "tags": "icon--launch--glyph",
  "styles": "",
  "viewBox": "-3 5 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M11 19H-1V9h3V5h-5v16h16v-5h-2z"
    }, {
      "d": "M4.7 14.7L11 8.4V13h2V5H5v2h4.6l-6.3 6.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconLink = {
  "id": "icon--link",
  "name": "icon--link",
  "tags": "icon--link",
  "styles": "",
  "viewBox": "0 0 16 13",
  "width": "16",
  "height": "13",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9.3 7.1l-.7-.7c.1-.1.2-.2.6-.5.9-.8.9-2.2.1-3l-.1-.1c-.8-.8-2.3-.8-3.1.1L1.6 7.3c-.9.9-.9 2.3 0 3.1l.2.2c.8.8 2 .8 2.8.1l.7.7c-1.2 1.1-3 1-4.2-.1l-.2-.2C-.3 9.9-.3 7.8.9 6.6l4.4-4.4C6.6.9 8.6.9 9.9 2.2l.1.1c1.2 1.3 1.1 3.2-.1 4.4-.3.2-.5.4-.6.4z"
    }, {
      "d": "M6.8 4.7l.7.7-.7.7c-.9.9-.9 2.3 0 3.2.9.9 2.3.9 3.1 0l4.5-4.5c.9-.9.9-2.3 0-3.1l-.1-.1c-.7-.7-1.9-.7-2.7 0l-.1.1-.8-.7.1-.1c1.1-1.1 3-1.1 4.1 0l.2.1c1.2 1.2 1.2 3.3 0 4.5L10.6 10c-1.2 1.2-3.3 1.2-4.5 0-1.3-1.3-1.3-3.3 0-4.5l.7-.8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconList = {
  "id": "icon--list",
  "name": "icon--list",
  "tags": "icon--list",
  "styles": "",
  "viewBox": "0 0 16 10",
  "width": "16",
  "height": "10",
  "svgData": {
    "circles": [{
      "cx": "1.5",
      "cy": "1.5",
      "r": "1.5"
    }, {
      "cx": "1.5",
      "cy": "8.5",
      "r": "1.5"
    }],
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M6 9V8h10v1zm0-7V1h10v1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconLocked = {
  "id": "icon--locked",
  "name": "icon--locked",
  "tags": "icon--locked",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M4.5 7V3.5a3.5 3.5 0 017 0V7h1A1.5 1.5 0 0114 8.5v6a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 012 14.5v-6A1.5 1.5 0 013.5 7h1zm1 0h5V3.5a2.5 2.5 0 00-5 0V7zm-2 1a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5h-9z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconMale = {
  "id": "icon--male",
  "name": "icon--male",
  "tags": "icon--male",
  "styles": "",
  "viewBox": "0 0 8 16",
  "width": "8",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6.21 4.384a2.73 2.73 0 00.54-1.634A2.753 2.753 0 004 0a2.753 2.753 0 00-2.75 2.75c0 .611.2 1.176.54 1.634A2.316 2.316 0 00.25 6.562v3.282A1.66 1.66 0 001.5 11.45v2.894c0 .913.743 1.656 1.656 1.656h1.688c.913 0 1.656-.743 1.656-1.656V11.45a1.66 1.66 0 001.25-1.606V6.563c0-1.004-.643-1.86-1.54-2.18zM4 1a1.75 1.75 0 110 3.5A1.75 1.75 0 014 1zm2.75 8.844a.656.656 0 01-.656.656H5.5v3.844a.656.656 0 01-.656.656H3.156a.656.656 0 01-.656-.656V10.5h-.594a.656.656 0 01-.656-.656V6.563c0-.725.588-1.313 1.313-1.313h.292c.71.326 1.55.34 2.29 0h.293c.724 0 1.312.588 1.312 1.313v3.28z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconMaximize = {
  "id": "icon--maximize",
  "name": "icon--maximize",
  "tags": "icon--maximize",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M1.71 15H4v1H.003L0 12h1l.002 2.293 4.296-4.296.707.707L1.709 15zM14.998 1.668l-4.271 4.317-.711-.703L14.252 1H12V0h3.997L16 4h-1l-.002-2.332z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconMenu = {
  "id": "icon--menu",
  "name": "icon--menu",
  "tags": "icon--menu",
  "styles": "",
  "viewBox": "0 0 20 14",
  "width": "20",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0h20v2H0zm0 6h20v2H0zm0 6h20v2H0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconMinimize = {
  "id": "icon--minimize",
  "name": "icon--minimize",
  "tags": "icon--minimize",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M4.998 11.709L.704 16.004l-.708-.708 4.274-4.273L1.995 11l.01-1 3.992.04L6 14H5l-.002-2.291zM11.707 5H14v1h-3.997L10 2h1l.002 2.291 4.291-4.29.707.706L11.707 5z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconNotificationOff = {
  "id": "icon--notification-off",
  "name": "icon--notification-off",
  "tags": "icon--notification-off",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M1.501 13.987l-.876.702L0 13.908 13.33 3.24l.625.78-1.963 1.572v3.642l1.801 1.35a.5.5 0 01.2.399l.008 2.516a.5.5 0 01-.5.501h-4.05a2.5 2.5 0 01-4.9 0h-3.05v-.013zM2.735 13H13l-.006-1.765-1.802-1.35a.5.5 0 01-.2-.4V6.391L2.735 13zm2.852 1a1.5 1.5 0 002.829 0h-2.83z",
      "fill-rule": "nonzero"
    }, {
      "d": "M7.501 1.248c.629.05 1.128.2 1.695.481.933.46 1.616 1.114 2.076 1.9l-.864.505a4.163 4.163 0 00-1.68-1.512c-.506-.25-1.148-.376-1.891-.376-.494 0-.875.05-1.366.293-1.429.708-2.324 1.814-2.474 3.475L2.941 9.74.797 11.434l-.62-.784 1.771-1.4.05-3.28c.106-1.968 1.41-3.724 3.071-4.347a5.207 5.207 0 011.432-.367V0h1v1.248z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconNotificationOn = {
  "id": "icon--notification-on",
  "name": "icon--notification-on",
  "tags": "icon--notification-on",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M11.199 9.9a.5.5 0 01-.2-.4V6.23a4 4 0 00-3.99-4A3.989 3.989 0 003.01 6.206L3 9.52a.5.5 0 01-.202.4L1 11.252V13h12v-1.75L11.199 9.9zM4.55 14H.5a.5.5 0 01-.5-.5V11a.5.5 0 01.202-.402l1.799-1.333.01-3.062A4.99 4.99 0 016.5 1.254V0h1v1.254a5 5 0 014.498 4.975v3.02L13.8 10.6a.5.5 0 01.2.4v2.5a.5.5 0 01-.5.5H9.45a2.5 2.5 0 01-4.9 0zm1.035 0a1.5 1.5 0 002.83 0h-2.83z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconOverflowMenu = {
  "id": "icon--overflow-menu",
  "name": "icon--overflow-menu",
  "tags": "icon--overflow-menu",
  "styles": "",
  "viewBox": "0 0 3 15",
  "width": "3",
  "height": "15",
  "svgData": {
    "circles": [{
      "cx": "1.5",
      "cy": "1.5",
      "r": "1.5"
    }, {
      "cx": "1.5",
      "cy": "7.5",
      "r": "1.5"
    }, {
      "cx": "1.5",
      "cy": "13.5",
      "r": "1.5"
    }],
    "ellipses": "",
    "paths": "",
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPa = {
  "id": "icon--pa",
  "name": "icon--pa",
  "tags": "icon--pa",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M22.588 12.982L10.643 1h-6.23L1 4.406v6.265l12.004 11.917 9.584-9.605zm1.412 0L13.008 24 0 11.087V3.99L4 0h7.058L24 12.982zM9 7a2 2 0 11-4 0 2 2 0 014 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPaStress = {
  "id": "icon--pa--stress",
  "name": "icon--pa--stress",
  "tags": "icon--pa--stress",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M22.588 12.982l-3.937-3.95L16 15V9h-3l1.733-3.898L10.643 1h-6.23L1 4.406v6.265l12.004 11.917 9.584-9.605zm1.412 0L13.008 24 0 11.087V3.99L4 0h7.058l4.11 4.123L17 0v5.96l.04.04H20l-.913 2.053L24 12.983zM9 7a2 2 0 11-4 0 2 2 0 014 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPause = {
  "id": "icon--pause",
  "name": "icon--pause",
  "tags": "icon--pause",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0h9v24H0zm15 0h9v24h-9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPauseGlyph = {
  "id": "icon--pause--glyph",
  "name": "icon--pause--glyph",
  "tags": "icon--pause--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11H5V5h2v6zm4 0H9V5h2v6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPauseOutline = {
  "id": "icon--pause--outline",
  "name": "icon--pause--outline",
  "tags": "icon--pause--outline",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5 5h2v6H5zm4 0h2v6H9z"
    }, {
      "d": "M8 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM8 16A8 8 0 118 0a8 8 0 010 16z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPlay = {
  "id": "icon--play",
  "name": "icon--play",
  "tags": "icon--play",
  "styles": "",
  "viewBox": "0 0 21 24",
  "width": "21",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 24l21-12L0 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPlayGlyph = {
  "id": "icon--play--glyph",
  "name": "icon--play--glyph",
  "tags": "icon--play--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM5 11V5l6.6 3L5 11z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPlayOutline = {
  "id": "icon--play--outline",
  "name": "icon--play--outline",
  "tags": "icon--play--outline",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 14.5c3.6 0 6.5-2.9 6.5-6.5S11.6 1.5 8 1.5 1.5 4.4 1.5 8s2.9 6.5 6.5 6.5zM8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
    }, {
      "d": "M5 4.8c0-.2.1-.4.2-.6.3-.6 1.1-.8 1.7-.4L12.4 7c.2.1.3.3.4.4.3.6.2 1.4-.4 1.7l-5.5 3.2c-.2.1-.4.2-.6.2-.7 0-1.2-.6-1.2-1.2V4.8zm2 5.1L10.3 8 7 6.1v3.8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPortfolio = {
  "id": "icon--portfolio",
  "name": "icon--portfolio",
  "tags": "icon--portfolio",
  "styles": "",
  "viewBox": "0 0 24 20",
  "width": "24",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7 5H6V1a1 1 0 011-1h10a1 1 0 011 1v4h-1V1H7v4zM1 19h22V7H1v12zM23 6H1a1 1 0 00-1 1v12a1 1 0 001 1h22a1 1 0 001-1V7a1 1 0 00-1-1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPower = {
  "id": "icon--power",
  "name": "icon--power",
  "tags": "icon--power",
  "styles": "",
  "viewBox": "0 0 15 16",
  "width": "15",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7 0h1v8H7z"
    }, {
      "d": "M10.74 1.735a7.5 7.5 0 11-8.45 1.371c.627-.605 1.62-1.186 2.086-1.398l.414.91c-.52.236-1.356.774-1.805 1.208a6.5 6.5 0 107.323-1.189l.432-.902z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPowerGlyph = {
  "id": "icon--power--glyph",
  "name": "icon--power--glyph",
  "tags": "icon--power--glyph",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9 2.3V0H5v2.3C2.1 3.2 0 5.8 0 9c0 3.9 3.1 7 7 7s7-3.1 7-7c0-3.2-2.1-5.8-5-6.7zM7 14c-2.8 0-5-2.2-5-5 0-2 1.2-3.8 3-4.6V9h4V4.4c1.8.8 3 2.6 3 4.6 0 2.8-2.2 5-5 5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPrintGlyph = {
  "id": "icon--print--glyph",
  "name": "icon--print--glyph",
  "tags": "icon--print--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12.5 8.25a.75.75 0 100 1.5.75.75 0 000-1.5zm1-2.75V3.121a1.5 1.5 0 00-.44-1.06L11.44.439A1.5 1.5 0 0010.378 0H3.453C2.926 0 2.5.448 2.5 1v4.5A2.5 2.5 0 000 8v4a.5.5 0 00.5.5h2v3a.5.5 0 00.5.5h10a.5.5 0 00.5-.5v-3h2a.5.5 0 00.5-.5V8a2.5 2.5 0 00-2.5-2.5zM4 1.5h6V3a.5.5 0 00.5.5H12v2H4v-4zm8 13H4v-2h8v2zm2.5-3.5h-13V8c0-.551.449-1 1-1h11c.551 0 1 .449 1 1v3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPurchase = {
  "id": "icon--purchase",
  "name": "icon--purchase",
  "tags": "icon--purchase",
  "styles": "",
  "viewBox": "0 0 16 11",
  "width": "16",
  "height": "11",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M15 3V1H1v2h14zm0 1H1v6h14V4zM.8 0h14.5c.4 0 .7.3.7.8v9.5c0 .4-.3.8-.8.8H.8c-.5-.1-.8-.4-.8-.9V.8C0 .3.3 0 .8 0z"
    }, {
      "d": "M2 9V8h5v1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconRestart = {
  "id": "icon--restart",
  "name": "icon--restart",
  "tags": "icon--restart",
  "styles": "",
  "viewBox": "0 0 13 16",
  "width": "13",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10.948 3L8.542.727 9.23 0 13 3.564 9.228 7.108l-.685-.729L11.075 4H6.5A5.5 5.5 0 1012 9.5h1A6.5 6.5 0 116.5 3h4.448z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconRestartGlyph = {
  "id": "icon--restart--glyph",
  "name": "icon--restart--glyph",
  "tags": "icon--restart--glyph",
  "styles": "",
  "viewBox": "0 0 12 16",
  "width": "12",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6 8l1.3 1.3 1.9-1.9L10.6 6 12 4.7 7.3 0 6 1.2l2.6 2.4H5.9c-1.7 0-3.3.8-4.4 2C.5 6.7 0 8.1 0 9.6c0 3.3 2.7 6 6 6 1.6 0 3-.6 4-1.6l-1.4-1.4c-.7.6-1.6 1-2.6 1-2.2 0-4-1.8-4-4s1.8-4 4-4h2.8l-.6.6L6 8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconRisk = {
  "id": "icon--risk",
  "name": "icon--risk",
  "tags": "icon--risk",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.25 4.2v5h1.5v-5h-1.5zM8 11.7a.75.75 0 110-1.5.75.75 0 010 1.5zM1.075 3.665c.736 6.327 3.056 10.026 6.93 11.29 3.884-1.248 6.203-4.945 6.924-11.29L8.002 1.069 1.075 3.665zM8.002 0l8 3c-.666 7.332-3.333 11.666-8 13C3.352 14.646.684 10.313 0 3l8.002-3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSave = {
  "id": "icon--save",
  "name": "icon--save",
  "tags": "icon--save",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 1.597v2.406a1 1 0 01-1 1H5a1 1 0 01-1-1V1H1v14h3V9a1 1 0 011-1h6a1 1 0 011 1v6h3V4.702l-3-3.105zM1 0h10.848L16 4.298V15a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1zm10 9H5v5.992l6 .007V9zM5 1v3.003h6V1H5z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSdgLogoCircle = {
  "id": "icon--sdg-logo-circle",
  "name": "icon--sdg-logo-circle",
  "tags": "icon--sdg-logo-circle",
  "styles": "",
  "viewBox": "0 0 46 46",
  "width": "46",
  "height": "46",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": "",
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSearch = {
  "id": "icon--search",
  "name": "icon--search",
  "tags": "icon--search",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M11.435 10.063h-.728l-.251-.252a5.89 5.89 0 001.437-3.865 5.946 5.946 0 10-5.947 5.947 5.91 5.91 0 003.865-1.432l.252.251v.723L14.637 16 16 14.637l-4.565-4.574zm-5.489 0a4.117 4.117 0 110-8.234 4.117 4.117 0 010 8.234z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSearchGlyph = {
  "id": "icon--search--glyph",
  "name": "icon--search--glyph",
  "tags": "icon--search--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6 2c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm0-2C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm10 13.8L13.8 16l-3.6-3.6 2.2-2.2z"
    }, {
      "d": "M16 13.8L13.8 16l-3.6-3.6 2.2-2.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSettings = {
  "id": "icon--settings",
  "name": "icon--settings",
  "tags": "icon--settings",
  "styles": "",
  "viewBox": "0 0 15 16",
  "width": "15",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.5 10.5C8.9 10.5 10 9.4 10 8S8.9 5.5 7.5 5.5 5 6.6 5 8s1.2 2.5 2.5 2.5zm0 1C5.6 11.5 4 9.9 4 8s1.6-3.5 3.5-3.5S11 6.1 11 8s-1.5 3.5-3.5 3.5z"
    }, {
      "d": "M6.3 2.6l-.3.1c-.7.2-1.3.5-1.9 1l-.2.2-1.4-.8-1.3 1.8L2.4 6l-.1.2C2.1 6.8 2 7.4 2 8c0 .3 0 .7.1 1l.1.3-1.2 1L2.2 12l1.1-.6.3.3c.6.8 1.4 1.3 2.4 1.6l.3.1.2 1.6h2.1l.2-1.6.3-.1c.8-.2 1.6-.7 2.2-1.3l.3-.2 1.1.6 1.2-1.7-1.1-1 .1-.3c.1-.5.1-1 .1-1.4 0-.5-.1-1.1-.2-1.6l-.1-.3 1.2-1-1.2-1.7-1.4.6-.3-.2c-.6-.5-1.3-.9-2-1.1l-.2-.1L8.6 1H6.5l-.2 1.6zM5.5.9c0-.5.5-.9 1-.9h2.1c.5 0 .9.4 1 .9l.1 1c.6.2 1.2.5 1.8 1l.7-.4c.4-.2 1-.1 1.3.3l1.2 1.7c.3.4.2 1-.1 1.3l-.7.6c.1.5.1 1.1.1 1.6 0 .4 0 .8-.1 1.3l.6.6c.4.3.4.9.1 1.3l-1.2 1.7c-.3.4-.8.5-1.3.3l-.4-.2c-.6.5-1.3.9-2 1.2l-.1 1c-.1.5-.5.9-1 .9H6.5c-.5 0-.9-.4-1-.9l-.1-1c-.8-.3-1.6-.8-2.3-1.4l-.4.2c-.4.2-1 .1-1.3-.3L.2 11c-.3-.4-.2-1 .1-1.3l.8-.7c0-.4-.1-.7-.1-1 0-.6.1-1.2.2-1.8l-.6-.6C.2 5.3.1 4.7.4 4.3l1.2-1.7c.3-.5.9-.6 1.3-.4l.9.5c.5-.3 1-.6 1.6-.8l.1-1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSettingsGlyph = {
  "id": "icon--settings--glyph",
  "name": "icon--settings--glyph",
  "tags": "icon--settings--glyph",
  "styles": "",
  "viewBox": "-1 2 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13.1 10c0-.3 0-.6-.1-1l2-1.7-1.7-2.7-2.3.8c-.6-.5-1.2-.9-1.9-1.1L8.6 2H5.4l-.5 2.2c-.7.3-1.4.7-1.9 1.2L.7 4.6-1 7.3.9 9c0 .3-.1.6-.1 1s0 .6.1 1L-1 12.7l1.7 2.7 2.3-.8c.6.5 1.2.9 1.9 1.1l.5 2.3h3.2l.5-2.2c.7-.3 1.3-.6 1.9-1.1l2.3.8 1.7-2.7-1.9-1.8v-1zM7 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStarOutline = {
  "id": "icon--star--outline",
  "name": "icon--star--outline",
  "tags": "icon--star--outline",
  "styles": "",
  "viewBox": "0 0 16 15",
  "width": "16",
  "height": "15",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M3 15l1-5.2-4-4L5.5 5 8 0l2.5 5 5.5.7-4 4 1 5.2-5-2.5L3 15zm5-3.6l3.6 1.8-.7-3.8 2.9-3-4-.5L8 2.2 6.2 5.9l-4 .5 2.9 2.9-.7 3.8L8 11.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStarSolid = {
  "id": "icon--star--solid",
  "name": "icon--star--solid",
  "tags": "icon--star--solid",
  "styles": "",
  "viewBox": "0 0 16 15",
  "width": "16",
  "height": "15",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.998 0L5.5 5 0 5.75l4 4L3 15l4.998-2.5L13 15l-1-5.25 4-4.005L10.5 5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStart = {
  "id": "icon--start",
  "name": "icon--start",
  "tags": "icon--start",
  "styles": "",
  "viewBox": "0 0 21 24",
  "width": "21",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 24l21-12L0 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStartGlyph = {
  "id": "icon--start--glyph",
  "name": "icon--start--glyph",
  "tags": "icon--start--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM5 11V5l6.6 3L5 11z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStartOutline = {
  "id": "icon--start--outline",
  "name": "icon--start--outline",
  "tags": "icon--start--outline",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 17l9-5-9-5z"
    }, {
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStop = {
  "id": "icon--stop",
  "name": "icon--stop",
  "tags": "icon--stop",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0h24v24H0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStopGlyph = {
  "id": "icon--stop--glyph",
  "name": "icon--stop--glyph",
  "tags": "icon--stop--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3 11H5V5h6v6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStopSolid = {
  "id": "icon--stop--solid",
  "name": "icon--stop--solid",
  "tags": "icon--stop--solid",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 16A8 8 0 118 0a8 8 0 010 16zM6 5a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V6a1 1 0 00-1-1H6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSubtractGlyph = {
  "id": "icon--subtract--glyph",
  "name": "icon--subtract--glyph",
  "tags": "icon--subtract--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 7v2H4V7"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSubtractOutline = {
  "id": "icon--subtract--outline",
  "name": "icon--subtract--outline",
  "tags": "icon--subtract--outline",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM8 16A8 8 0 118 0a8 8 0 010 16z",
      "fill-rule": "nonzero"
    }, {
      "d": "M4 7h8v2H4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconTerminal = {
  "id": "icon--terminal",
  "name": "icon--terminal",
  "tags": "icon--terminal",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M16 4.5V15c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v3.5zM15 4V1H1v3h14zm0 1H1v10h14V5z"
    }, {
      "d": "M3 8.4l.7-.8L6 9.9l-2.3 2.3-.7-.7 1.6-1.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconUnlock = {
  "id": "icon--unlock",
  "name": "icon--unlock",
  "tags": "icon--unlock",
  "styles": "",
  "viewBox": "0 0 12 16",
  "width": "12",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M2.5 7V3.5a3.5 3.5 0 017 0V4h-1v-.5a2.5 2.5 0 00-5 0V7h7A1.5 1.5 0 0112 8.5v6a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 010 14.5v-6A1.5 1.5 0 011.5 7h1zm-1 1a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5h-9z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconUnlocked = {
  "id": "icon--unlocked",
  "name": "icon--unlocked",
  "tags": "icon--unlocked",
  "styles": "",
  "viewBox": "0 0 18 24",
  "width": "18",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9 6.5c-1.6 0-3.1.4-4.4 1.2V6.5c0-2.3 2-4.4 4.4-4.4 1.2 0 2.3.5 3.1 1.3l1.5-1.5C12.4.8 10.8 0 9 0 5.5 0 2.5 3 2.5 6.5v3C1.1 11 .3 13 .3 15.3.3 20.1 4.2 24 9 24c4.8 0 8.7-3.9 8.7-8.7 0-4.8-3.9-8.8-8.7-8.8zm4 11.3l-1.5 1.5L9 16.8l-2.5 2.5L5 17.8l2.5-2.5L5 12.8l1.5-1.5L9 13.7l2.5-2.5 1.5 1.6-2.5 2.5 2.5 2.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconUpload = {
  "id": "icon--upload",
  "name": "icon--upload",
  "tags": "icon--upload",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5 6.6l1.2 1.1L11 3v13h2V3l4.8 4.7L19 6.6 12 0z"
    }, {
      "d": "M22 14v6H2v-6H0v10h24V14z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconUser = {
  "id": "icon--user",
  "name": "icon--user",
  "tags": "icon--user",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6.123 9.455a3.5 3.5 0 113.754 0c1.958.97 3.571 3.424 4.436 6.64-5.852-.027-6.488-.027-12.62-.027.867-3.203 2.477-5.645 4.43-6.613z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconVisibilityOff = {
  "id": "icon--visibility-off",
  "name": "icon--visibility-off",
  "tags": "icon--visibility-off",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M11.846 3.45L15.293.007 16 .714l-3.284 3.281c1.261.902 2.377 2.212 3.347 3.93C14.02 11.642 11.333 13.5 8 13.5c-1.392 0-2.667-.324-3.822-.973L.703 16l-.706-.708 3.323-3.32C2.071 11.042.976 9.694.035 7.924 2.012 4.308 4.667 2.5 8 2.5c1.395 0 2.677.317 3.846.95zm-6.928 8.338c.944.477 1.97.712 3.082.712 2.795 0 5.076-1.483 6.907-4.568-.866-1.417-1.833-2.486-2.91-3.219l-1.55 1.55a3 3 0 01-4.185 4.182l-1.344 1.343zm-.882-.533l1.518-1.517A3 3 0 019.74 5.556l1.364-1.363A7.02 7.02 0 008 3.5c-2.798 0-5.047 1.439-6.819 4.432.842 1.465 1.792 2.568 2.855 3.323zm2.948-1.532a2 2 0 002.74-2.738l-2.74 2.738zm-.707-.707l2.74-2.738a2 2 0 00-2.74 2.738z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconVisibilityOn = {
  "id": "icon--visibility-on",
  "name": "icon--visibility-on",
  "tags": "icon--visibility-on",
  "styles": "",
  "viewBox": "0 0 16 11",
  "width": "16",
  "height": "11",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 7.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 1c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
    }, {
      "d": "M8 10c2.8 0 5.1-1.5 6.9-4.6C13.1 2.5 10.8 1 8 1 5.2 1 3 2.4 1.2 5.4 2.9 8.6 5.2 10 8 10zM8 0c3.3 0 6 1.8 8.1 5.4C14 9.2 11.3 11 8 11S2 9.2 0 5.5C2 1.9 4.6 0 8 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWarning = {
  "id": "icon--warning",
  "name": "icon--warning",
  "tags": "icon--warning",
  "styles": "",
  "viewBox": "0 0 24 21",
  "width": "24",
  "height": "21",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 0L0 21h24L12 0zm0 3l9 16H3l9-16z"
    }, {
      "d": "M11.2 8.4V10l.4 4h.8l.4-4V8.4zM11.2 16a.8.8 0 111.6 0 .8.8 0 11-1.6 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWarningGlyph = {
  "id": "icon--warning--glyph",
  "name": "icon--warning--glyph",
  "tags": "icon--warning--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 1L0 15h16L8 1zm-.8 5h1.5v1.4L8.3 11h-.8l-.4-3.6V6h.1zm.8 8c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWarningOutline = {
  "id": "icon--warning--outline",
  "name": "icon--warning--outline",
  "tags": "icon--warning--outline",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": [{
      "cx": "8",
      "cy": "12.75",
      "r": "1"
    }],
    "ellipses": "",
    "paths": [{
      "d": "M7.25 6h1.5v5h-1.5z"
    }, {
      "d": "M.75 16a.75.75 0 01-.67-1.085L7.33.415a.75.75 0 011.34 0l7.25 14.5A.75.75 0 0115.25 16H.75zm1.214-1.5h12.072L8 2.427 1.964 14.5z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWarningSolid = {
  "id": "icon--warning--solid",
  "name": "icon--warning--solid",
  "tags": "icon--warning--solid",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M.75 16a.75.75 0 01-.67-1.085L7.33.415a.75.75 0 011.34 0l7.25 14.5A.75.75 0 0115.25 16H.75zm6.5-10v5h1.5V6h-1.5zM8 13.5A.75.75 0 108 12a.75.75 0 000 1.5z",
      "fill-rule": "nonzero"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumAffectedPopulationNeg = {
  "id": "icon--wfp-hum--affected-population-neg",
  "name": "icon--wfp-hum--affected-population-neg",
  "tags": "icon--wfp-hum--affected-population-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-26 7.8c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4-3.4-1.5-3.4-3.4 1.5-3.4 3.4-3.4zm-19.8.5c.7-.7 1.7-.7 2.4 0l6.1 6c.7.7.7 1.7 0 2.4-.3.3-.8.5-1.2.5-.4 0-.9-.2-1.2-.5l-6.1-6C8 10.1 8 9 8.6 8.3zM17 41.7l-6 6.1c-.3.3-.8.5-1.2.5-.4 0-.9-.2-1.2-.5-.7-.7-.7-1.7 0-2.4l6-6.1c.7-.7 1.7-.7 2.4 0s.7 1.8 0 2.4zm20.7-13.6c-.9 0-1.7-.8-1.7-1.7 0-2.7-1.4-4.6-3.4-5.7v25.8c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7V34h-1.7v12.6c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7V20.7c-2 1.1-3.4 3-3.4 5.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-5.8 4.7-10.1 11-10.1s11 4.3 11 10.1c0 .9-.7 1.7-1.6 1.7zm10.4 19.7c-.3.3-.8.5-1.2.5-.4 0-.9-.2-1.2-.5l-6-6.1c-.7-.7-.7-1.7 0-2.4s1.7-.7 2.4 0l6 6.1c.7.7.7 1.8 0 2.4zm0-37.1l-6.1 6c-.3.3-.8.5-1.2.5-.4 0-.9-.2-1.2-.5-.6-.7-.6-1.7.1-2.4l6.1-6c.7-.7 1.7-.6 2.4 0 .6.7.6 1.8-.1 2.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumAffectedPopulationPos = {
  "id": "icon--wfp-hum--affected-population-pos",
  "name": "icon--wfp-hum--affected-population-pos",
  "tags": "icon--wfp-hum--affected-population-pos",
  "styles": "",
  "viewBox": "0 0 41 42",
  "width": "41",
  "height": "42",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M20.4.8c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4S17 6.1 17 4.2 18.5.8 20.4.8zM.6 1.3C1.3.6 2.3.6 3 1.3l6.1 6c.7.7.7 1.7 0 2.4-.3.3-.8.5-1.2.5-.4 0-.9-.2-1.2-.5l-6.1-6C0 3.1 0 2 .6 1.3zM9 34.7l-6 6.1c-.3.3-.8.5-1.2.5-.4 0-.9-.2-1.2-.5-.7-.7-.7-1.7 0-2.4l6-6.1c.7-.7 1.7-.7 2.4 0s.7 1.8 0 2.4zm20.7-13.6c-.9 0-1.7-.8-1.7-1.7 0-2.7-1.4-4.6-3.4-5.7v25.8c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7V27h-1.7v12.6c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7V13.7c-2 1.1-3.4 3-3.4 5.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-5.8 4.7-10.1 11-10.1s11 4.3 11 10.1c0 .9-.7 1.7-1.6 1.7zm10.4 19.7c-.3.3-.8.5-1.2.5-.4 0-.9-.2-1.2-.5l-6-6.1c-.7-.7-.7-1.7 0-2.4s1.7-.7 2.4 0l6 6.1c.7.7.7 1.8 0 2.4zm0-37.1l-6.1 6c-.3.3-.8.5-1.2.5-.4 0-.9-.2-1.2-.5-.6-.7-.6-1.7.1-2.4l6.1-6c.7-.7 1.7-.6 2.4 0 .6.7.6 1.8-.1 2.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumAidsNeg = {
  "id": "icon--wfp-hum--aids-neg",
  "name": "icon--wfp-hum--aids-neg",
  "tags": "icon--wfp-hum--aids-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": "",
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumAidsPos = {
  "id": "icon--wfp-hum--aids-pos",
  "name": "icon--wfp-hum--aids-pos",
  "tags": "icon--wfp-hum--aids-pos",
  "styles": "",
  "viewBox": "0 0 36 46",
  "width": "36",
  "height": "46",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": "",
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumAirportNeg = {
  "id": "icon--wfp-hum--airport-neg",
  "name": "icon--wfp-hum--airport-neg",
  "tags": "icon--wfp-hum--airport-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-8.3 33.1c-.3 0-.6-.1-.9-.2l-13.5-4.1v12.6l5.1 3.6c.2.1.3.2.4.4.2.3.3.6.3 1 0 .9-.8 1.7-1.7 1.7-.2 0-.4 0-.6-.1l-7-2.3-7.2 2.6h-.3c-.9 0-1.7-.8-1.7-1.7 0-.4.2-.8.4-1.1.1-.1.2-.2.4-.3l5.1-3.6V28.9L11.5 33c-.2.1-.5.1-.8.1-1.4 0-2.5-1.1-2.5-2.5 0-.9.4-1.6 1.1-2l15.7-9v-8.4c0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4v8.4l15.5 8.7c.8.4 1.3 1.3 1.3 2.2 0 1.5-1.1 2.6-2.5 2.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumAirportPos = {
  "id": "icon--wfp-hum--airport-pos",
  "name": "icon--wfp-hum--airport-pos",
  "tags": "icon--wfp-hum--airport-pos",
  "styles": "",
  "viewBox": "0 0 41 42",
  "width": "41",
  "height": "42",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M38.1 26.1c-.3 0-.6-.1-.9-.2l-13.5-4.1v12.6l5.1 3.6c.2.1.3.2.4.4.2.3.3.6.3 1 0 .9-.8 1.7-1.7 1.7-.2 0-.4 0-.6-.1l-7-2.3-7.2 2.6h-.3c-.9 0-1.7-.8-1.7-1.7 0-.4.2-.8.4-1.1.1-.1.2-.2.4-.3l5.1-3.6V21.9L3.5 26c-.2.1-.5.1-.8.1-1.4 0-2.5-1.1-2.5-2.5 0-.9.4-1.6 1.1-2l15.7-9V4.2C17 2.3 18.5.8 20.4.8s3.4 1.5 3.4 3.4v8.4l15.5 8.7c.8.4 1.3 1.3 1.3 2.2 0 1.5-1.1 2.6-2.5 2.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumBeneficariesNeg = {
  "id": "icon--wfp-hum--beneficaries-neg",
  "name": "icon--wfp-hum--beneficaries-neg",
  "tags": "icon--wfp-hum--beneficaries-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM43.2 15.8c1.6 0 3 1.3 3 3 0 1.6-1.3 3-3 3-1.6 0-3-1.3-3-3 .1-1.7 1.4-3 3-3zM31.3 8.2c0-.5.4-1 1-1 .5 0 1 .4 1 1v2.6c0 .5-.4 1-1 1-.5 0-1-.4-1-1V8.2zm1.3 4.8h.6v2c0 1.8-1.4 3.2-3.2 3.2h-.6v-1.9c-.1-1.8 1.4-3.3 3.2-3.3zM30 24h-.6v-1.9c0-1.8 1.4-3.2 3.2-3.2h.6v1.9c0 1.8-1.4 3.2-3.2 3.2zm1 5.4c0 1.5-1.2 2.7-2.7 2.7-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7 1.5.1 2.7 1.3 2.7 2.7zM27.4 5.6c0-.5.4-1 1-1 .5 0 1 .4 1 1v7.1c0 .5-.4 1-1 1-.5 0-1-.4-1-1V5.6zm-3.9 2.6c0-.5.4-1 1-1 .5 0 1 .4 1 1v2.6c0 .5-.4 1-1 1-.5 0-1-.4-1-1V8.2zm0 4.8h.6c1.8 0 3.2 1.4 3.2 3.2v1.9h-.6c-1.8 0-3.2-1.4-3.2-3.2V13zm0 5.8h.6c1.8 0 3.2 1.4 3.2 3.2v2h-.6c-1.8 0-3.2-1.4-3.2-3.2v-2zm-10-3c1.6 0 3 1.3 3 3 0 1.6-1.3 3-3 3-1.6 0-3-1.3-3-3s1.4-3 3-3zm6.7 16.3c0-2.5-1.5-4.3-3.7-5.2l3 14.1c.1.4-.3.8-.7.8h-1.5V50c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5v-8.2h-1.5V50c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5v-8.2H8.3c-.5 0-.8-.4-.7-.8l3-14.1c-2.2.9-3.7 2.7-3.7 5.2 0 .8-.7 1.5-1.5 1.5s-1.5-.6-1.5-1.5c0-5.2 4.1-8.9 9.7-8.9s9.7 3.8 9.7 8.9c0 .8-.7 1.5-1.5 1.5s-1.6-.6-1.6-1.5zM34 40.8c-.6 0-1-.4-1-1 0-1.5-.8-2.8-2-3.6v14.3c0 .6-.4 1-1 1s-1-.4-1-1v-7h-1.3v7c0 .6-.4 1-1 1s-1-.4-1-1V36.2c-1.2.8-2 2-2 3.6 0 .6-.4 1-1 1s-1-.4-1-1c0-3.6 2.9-6.3 6.7-6.3 3.8 0 6.7 2.7 6.7 6.3-.1.5-.5 1-1.1 1zm17.4-7.2c-.8 0-1.5-.7-1.5-1.5 0-2.4-1.2-4.1-3-5V50c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V38.8h-1.5V50c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V27.1c-1.7 1-3 2.6-3 5 0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5c0-5.1 4.2-8.9 9.7-8.9 5.5 0 9.7 3.8 9.7 8.9.1.9-.6 1.5-1.4 1.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumBeneficariesPos = {
  "id": "icon--wfp-hum--beneficaries-pos",
  "name": "icon--wfp-hum--beneficaries-pos",
  "tags": "icon--wfp-hum--beneficaries-pos",
  "styles": "",
  "viewBox": "0 0 50 48",
  "width": "50",
  "height": "48",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M40.2 11.8c1.6 0 3 1.3 3 3 0 1.6-1.3 3-3 3-1.6 0-3-1.3-3-3 .1-1.7 1.4-3 3-3zM28.3 4.2c0-.5.4-1 1-1 .5 0 1 .4 1 1v2.6c0 .5-.4 1-1 1-.5 0-1-.4-1-1V4.2zM29.6 9h.6v2c0 1.8-1.4 3.2-3.2 3.2h-.6v-1.9c-.1-1.8 1.4-3.3 3.2-3.3zM27 20h-.6v-1.9c0-1.8 1.4-3.2 3.2-3.2h.6v1.9c0 1.8-1.4 3.2-3.2 3.2zm1 5.4c0 1.5-1.2 2.7-2.7 2.7-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7 1.5.1 2.7 1.3 2.7 2.7zM24.4 1.6c0-.5.4-1 1-1 .5 0 1 .4 1 1v7.1c0 .5-.4 1-1 1-.5 0-1-.4-1-1V1.6zm-3.9 2.6c0-.5.4-1 1-1 .5 0 1 .4 1 1v2.6c0 .5-.4 1-1 1-.5 0-1-.4-1-1V4.2zm0 4.8h.6c1.8 0 3.2 1.4 3.2 3.2v1.9h-.6c-1.8 0-3.2-1.4-3.2-3.2V9zm0 5.8h.6c1.8 0 3.2 1.4 3.2 3.2v2h-.6c-1.8 0-3.2-1.4-3.2-3.2v-2zm-10-3c1.6 0 3 1.3 3 3 0 1.6-1.3 3-3 3-1.6 0-3-1.3-3-3s1.4-3 3-3zm6.7 16.3c0-2.5-1.5-4.3-3.7-5.2l3 14.1c.1.4-.3.8-.7.8h-1.5V46c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5v-8.2H9.8V46c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5v-8.2H5.3c-.5 0-.8-.4-.7-.8l3-14.1c-2.2.9-3.7 2.7-3.7 5.2 0 .8-.7 1.5-1.5 1.5S.9 29 .9 28.1c0-5.2 4.1-8.9 9.7-8.9s9.7 3.8 9.7 8.9c0 .8-.7 1.5-1.5 1.5s-1.6-.6-1.6-1.5zM31 36.8c-.6 0-1-.4-1-1 0-1.5-.8-2.8-2-3.6v14.3c0 .6-.4 1-1 1s-1-.4-1-1v-7h-1.3v7c0 .6-.4 1-1 1s-1-.4-1-1V32.2c-1.2.8-2 2-2 3.6 0 .6-.4 1-1 1s-1-.4-1-1c0-3.6 2.9-6.3 6.7-6.3 3.8 0 6.7 2.7 6.7 6.3-.1.5-.5 1-1.1 1zm17.4-7.2c-.8 0-1.5-.7-1.5-1.5 0-2.4-1.2-4.1-3-5V46c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V34.8h-1.5V46c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V23.1c-1.7 1-3 2.6-3 5 0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5c0-5.1 4.2-8.9 9.7-8.9 5.5 0 9.7 3.8 9.7 8.9.1.9-.6 1.5-1.4 1.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumBreastFeedingNeg = {
  "id": "icon--wfp-hum--breast-feeding-neg",
  "name": "icon--wfp-hum--breast-feeding-neg",
  "tags": "icon--wfp-hum--breast-feeding-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-26 5.2c3.6 0 6.5 2.9 6.5 6.5s-2.9 6.5-6.5 6.5-6.5-2.9-6.5-6.5 2.9-6.5 6.5-6.5zm13 35.3c0 1.3-.9 2.3-2.1 2.6 0 0-.3.1-.5.1H26.6c-1.5 0-2.8-1.3-2.8-2.8 0-.7.3-1.4.8-1.9.2-.2.5-.4.8-.5 0 0 .1 0 .2-.1.3-.1.6-.2 1-.2h5.8c2.3 0 4.2-1.9 4.2-4.2 0-2.3-1.9-4.2-4.2-4.2-2.3 0-4.2 1.9-4.2 4.2 0 .9.3 1.6.8 2.3h-2.1c-.4-1.1-.6-2.4-.2-3.7.3-1-.3-2-1.3-2.3-1-.3-2 .3-2.3 1.3-.6 2.1-.4 4.1.3 6-.9.8-1.4 2-1.4 3.3 0 1.2.5 2.4 1.4 3.3.9.9 2 1.4 3.3 1.4H36v.9c0 2-1.7 3.7-3.7 3.7h-13c-2 0-3.7-1.7-3.7-3.7V27.5c0-3.1 2.5-5.6 5.6-5.6h16.4c2 0 3.7 1.7 3.7 3.7v14.9h.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumBreastFeedingPos = {
  "id": "icon--wfp-hum--breast-feeding-pos",
  "name": "icon--wfp-hum--breast-feeding-pos",
  "tags": "icon--wfp-hum--breast-feeding-pos",
  "styles": "",
  "viewBox": "0 0 27 45",
  "width": "27",
  "height": "45",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13.4.2c3.6 0 6.5 2.9 6.5 6.5s-2.9 6.5-6.5 6.5-6.5-2.9-6.5-6.5S9.8.2 13.4.2zm13 35.3c0 1.3-.9 2.3-2.1 2.6 0 0-.3.1-.5.1H11.6c-1.5 0-2.8-1.3-2.8-2.8 0-.7.3-1.4.8-1.9.2-.2.5-.4.8-.5 0 0 .1 0 .2-.1.3-.1.6-.2 1-.2h5.8c2.3 0 4.2-1.9 4.2-4.2 0-2.3-1.9-4.2-4.2-4.2-2.3 0-4.2 1.9-4.2 4.2 0 .9.3 1.6.8 2.3h-2.1c-.4-1.1-.6-2.4-.2-3.7.3-1-.3-2-1.3-2.3-1-.3-2 .3-2.3 1.3-.6 2.1-.4 4.1.3 6-.9.8-1.4 2-1.4 3.3 0 1.2.5 2.4 1.4 3.3.9.9 2 1.4 3.3 1.4H21v.9c0 2-1.7 3.7-3.7 3.7h-13C2.3 44.7.6 43 .6 41V22.5c0-3.1 2.5-5.6 5.6-5.6h16.4c2 0 3.7 1.7 3.7 3.7v14.9h.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumCashBasedTransfersNeg = {
  "id": "icon--wfp-hum--cash-based-transfers-neg",
  "name": "icon--wfp-hum--cash-based-transfers-neg",
  "tags": "icon--wfp-hum--cash-based-transfers-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M41.9 25.5c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5c0-1.3-1.1-2.5-2.5-2.5zm-27 0c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5c0-1.3-1.1-2.5-2.5-2.5zm13.5-3.3c-3.3 0-5.9 2.6-5.9 5.9 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-3.3-2.7-5.9-5.9-5.9z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-8.7 45H12.5l1.2 1.2c.5.5.5 1.3 0 1.8-.2.2-.6.4-.9.4-.3 0-.6-.1-.9-.4l-3.3-3.3c-.1-.1-.2-.3-.3-.4-.1-.1-.1-.3-.1-.5s0-.3.1-.5.2-.3.3-.4l3.3-3.3c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.8l-1.2 1.2h33.2c.7 0 1.3.6 1.3 1.3-.1.5-.6 1.1-1.3 1.1zm2.1-9.3c0 .5-.4.8-.8.8H9.8c-.5 0-.8-.4-.8-.8V20.5c0-.5.4-.8.8-.8H47c.5 0 .8.4.8.8v15.2zm.7-22.8c-.1.2-.2.3-.3.4l-3.3 3.3c-.5.5-1.3.5-1.8 0s-.5-1.3 0-1.8l1.2-1.2H11.1c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h33.2l-1.2-1c-.5-.5-.5-1.3 0-1.8.3-.2.6-.4.9-.4.3 0 .6.1.9.4l3.3 3.3c.1.1.2.3.3.4.1.1.1.3.1.5s0 .4-.1.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumCashBasedTransfersPos = {
  "id": "icon--wfp-hum--cash-based-transfers-pos",
  "name": "icon--wfp-hum--cash-based-transfers-pos",
  "tags": "icon--wfp-hum--cash-based-transfers-pos",
  "styles": "",
  "viewBox": "0 0 41 42",
  "width": "41",
  "height": "42",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M37.7 35.4H4.5l1.2-1.2c.5-.5.5-1.3 0-1.8s-1.3-.5-1.8 0L.6 35.7c-.1.1-.2.3-.3.4-.1.1-.1.3-.1.5s0 .3.1.5.2.3.3.4l3.3 3.3c.2.2.6.4.9.4.3 0 .6-.1.9-.4.5-.5.5-1.3 0-1.8l-1.2-1h33.2c.7 0 1.3-.6 1.3-1.3-.1-.7-.6-1.3-1.3-1.3zM40.5 5c-.1-.2-.2-.3-.3-.4l-3.3-3.3c-.2-.3-.6-.5-.9-.5-.3 0-.6.1-.9.4-.5.5-.5 1.3 0 1.8l1.2 1.2H3.1c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3h33.2L35.1 8c-.5.5-.5 1.3 0 1.8s1.3.5 1.8 0l3.3-3.3c.1-.1.2-.3.3-.4.1-.1.1-.3.1-.5 0-.3 0-.5-.1-.6z"
    }, {
      "fill-rule": "nonzero",
      "d": "M39 12.6H1.8c-.4 0-.8.4-.8.9v15.2c0 .5.4.8.8.8H39c.5 0 .8-.4.8-.8V13.5c0-.5-.4-.9-.8-.9zm-32.1 11c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM20.4 27c-3.3 0-5.9-2.6-5.9-5.9 0-3.3 2.6-5.9 5.9-5.9 3.3 0 5.9 2.6 5.9 5.9 0 3.3-2.7 5.9-5.9 5.9zm13.5-3.4c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumCashNeg = {
  "id": "icon--wfp-hum--cash-neg",
  "name": "icon--wfp-hum--cash-neg",
  "tags": "icon--wfp-hum--cash-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-10 33.1v6.7c0 .5-.4.8-.8.8H9c-.5 0-.8-.4-.8-.8v-16c-.1-.4.3-.8.8-.8h34.6c.5 0 .8.4.8.8v9.3zm4.2-.8c0 .5-.4.8-.8.8h-1.7v-9.3c0-1.4-1.1-2.5-2.5-2.5h-8.4c-1-1.5-2.7-2.5-4.6-2.5-1.9 0-3.6 1-4.6 2.5H12.4v-5.1c0-.5.4-.8.8-.8h34.6c.5 0 .8.4.8.8v16.1z"
    }, {
      "d": "M39.3 29.3c-1.4 0-2.5 1.1-2.5 2.5 0 .5.1.9.3 1.3.4.8 1.3 1.3 2.2 1.3.9 0 1.8-.5 2.2-1.3.2-.4.3-.8.3-1.3.1-1.3-1.1-2.5-2.5-2.5zm-13-2.9c-.3 0-.5 0-.8.1-2.6.4-4.7 2.7-4.7 5.4 0 .4.1.9.2 1.3.6 2.4 2.7 4.2 5.3 4.2 2.6 0 4.8-1.8 5.3-4.2.1-.4.2-.8.2-1.3 0-.8-.2-1.5-.4-2.2-.9-2-2.9-3.3-5.1-3.3zm-13.1 3.4c-.3 0-.6.1-.8.2-1 .3-1.7 1.3-1.7 2.4 0 1.4 1.1 2.5 2.5 2.5 1.1 0 2-.7 2.4-1.7.1-.3.2-.5.2-.8-.1-1.5-1.2-2.6-2.6-2.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumCashPos = {
  "id": "icon--wfp-hum--cash-pos",
  "name": "icon--wfp-hum--cash-pos",
  "tags": "icon--wfp-hum--cash-pos",
  "styles": "",
  "viewBox": "0 0 41 26",
  "width": "41",
  "height": "26",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M35.6 8H1c-.5 0-.8.4-.8.8v16c0 .5.4.8.8.8h34.6c.5 0 .8-.4.8-.8v-16c0-.4-.4-.8-.8-.8zm-28 10.1c-.3 1-1.3 1.7-2.4 1.7-1.4 0-2.5-1.1-2.5-2.5 0-1.1.7-2 1.7-2.4.3-.1.5-.2.8-.2 1.4 0 2.5 1.1 2.5 2.5 0 .4 0 .7-.1.9zm16 0c-.6 2.4-2.7 4.2-5.3 4.2-2.6 0-4.8-1.8-5.3-4.2-.1-.4-.2-.8-.2-1.3 0-2.7 2-5 4.7-5.4.3-.1.5-.1.8-.1 2.3 0 4.2 1.4 5 3.3.3.7.4 1.4.4 2.2.1.5 0 .9-.1 1.3zm9.9 0c-.4.8-1.3 1.3-2.2 1.3-.9 0-1.8-.5-2.2-1.3-.2-.4-.3-.8-.3-1.3 0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5c.1.5-.1 1-.3 1.3z"
    }, {
      "d": "M39.8.4H5.2c-.5 0-.8.4-.8.8v5.1h13.5c1-1.5 2.7-2.5 4.6-2.5 1.9 0 3.6 1 4.6 2.5h8.4c1.4 0 2.5 1.1 2.5 2.5v9.3h1.7c.5 0 .8-.4.8-.8v-16c.1-.5-.3-.9-.7-.9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumChildrenNeg = {
  "id": "icon--wfp-hum--children-neg",
  "name": "icon--wfp-hum--children-neg",
  "tags": "icon--wfp-hum--children-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM41.5 10.2c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7-3.7-1.7-3.7-3.7 1.7-3.7 3.7-3.7zm-26 0c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7-3.7-1.7-3.7-3.7 1.7-3.7 3.7-3.7zm7.9 19.5c-.8 0-1.4-.6-1.4-1.4 0-2.1-1.1-3.9-2.8-5v19.8c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4v-9.7h-1.9v9.7c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4V23.3c-1.7 1.1-2.8 2.8-2.8 5 0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-5 4-8.8 9.3-8.8 5.3 0 9.3 3.8 9.3 8.8.1.8-.5 1.4-1.3 1.4zm26 0c-.8 0-1.4-.6-1.4-1.4 0-2.3-1.3-4.2-3.2-5.2l2.1 11.1c.1.6-.4 1-.9 1h-.8v7.9c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4v-7.9h-1.9v7.9c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4v-7.9H37c-.6 0-1-.5-.9-1l2.1-11.1c-1.9 1-3.2 2.9-3.2 5.2 0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-5 4-8.8 9.3-8.8 5.3 0 9.3 3.8 9.3 8.8 0 .8-.7 1.4-1.4 1.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumChildrenPos = {
  "id": "icon--wfp-hum--children-pos",
  "name": "icon--wfp-hum--children-pos",
  "tags": "icon--wfp-hum--children-pos",
  "styles": "",
  "viewBox": "0 0 45 35",
  "width": "45",
  "height": "35",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M35.5.2c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7-3.7-1.7-3.7-3.7S33.5.2 35.5.2zm-26 0c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7-3.7-1.7-3.7-3.7S7.5.2 9.5.2zm7.9 19.5c-.8 0-1.4-.6-1.4-1.4 0-2.1-1.1-3.9-2.8-5v19.8c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4v-9.7H8.5v9.7c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4V13.3c-1.7 1.1-2.8 2.8-2.8 5 0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-5 4-8.8 9.3-8.8 5.3 0 9.3 3.8 9.3 8.8.1.8-.5 1.4-1.3 1.4zm26 0c-.8 0-1.4-.6-1.4-1.4 0-2.3-1.3-4.2-3.2-5.2l2.1 11.1c.1.6-.4 1-.9 1h-.8v7.9c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4v-7.9h-1.9v7.9c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4v-7.9H31c-.6 0-1-.5-.9-1l2.1-11.1c-1.9 1-3.2 2.9-3.2 5.2 0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-5 4-8.8 9.3-8.8 5.3 0 9.3 3.8 9.3 8.8 0 .8-.7 1.4-1.4 1.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumCivilMilitaryCoordinationNeg = {
  "id": "icon--wfp-hum--civil-military-coordination-neg",
  "name": "icon--wfp-hum--civil-military-coordination-neg",
  "tags": "icon--wfp-hum--civil-military-coordination-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M32.1 29c0 1.9.8 3.7 2.1 4.9V24c-1.2 1.3-2.1 3.1-2.1 5zm11.5 4.9c1.3-1.2 2.1-3 2.1-4.9 0-1.9-.8-3.7-2.1-4.9v9.8z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM38.9 10.1c2.1 0 3.8 1.7 3.8 3.8 0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8zm-24.8-.2c0-.4.3-.8.8-.9l5.9-.7c.5-.1.9.4.9.9v.8c0 .5-.4.9-.8.9H15c-.6 0-.9-.4-.9-1zm7.6 4c0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8 0-.5.1-.9.2-1.3h7.1c.2.4.3.8.3 1.3zm4.6 31.2L23 48.5c-.5.5-1.3.5-1.8 0s-.5-1.3 0-1.8l1.2-1.2H9.5c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h12.9l-1.2-1.2c-.5-.5-.5-1.3 0-1.8.2-.2.6-.4.9-.4.3 0 .7.1.9.4l3.4 3.4c.4.5.4 1.3-.1 1.8zm-3.8-7.6c-.1.2-.2.4-.4.4h-8.5c-.2 0-.4-.1-.4-.3-3-1.6-5.1-4.8-5.1-8.5 0-5.3 4.3-9.7 9.7-9.7 1.1 0 2.2.2 3.1.5L19.8 21l-1.2 1.2-5.4 5.4V24c-1.3 1.2-2.2 3-2.2 5s.8 3.7 2.2 5v-1.2h9.3V34c1.3-1.2 2.1-3 2.1-4.9 0-1.9-.8-3.7-2.1-4.9v6.2h-8.3l7.1-7.1 1.1-1.1 1-1c2.5 1.7 4.2 4.7 4.2 7.9-.1 3.6-2.1 6.8-5.1 8.4zm24.8 8H34.4l1.2 1.2c.5.5.5 1.3 0 1.8s-1.3.5-1.8 0l-3.4-3.4c-.5-.5-.5-1.3 0-1.8l3.4-3.4c.2-.2.6-.4.9-.4.3 0 .7.1.9.4.5.5.5 1.3 0 1.8l-1.2 1.2h12.9c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3zm-3.7-8c0 .2-.2.4-.4.4h-8.5c-.2 0-.4-.2-.4-.4-3-1.6-5-4.8-5-8.5 0-5.3 4.3-9.7 9.7-9.7 5.4 0 9.7 4.3 9.7 9.7-.1 3.7-2.1 6.8-5.1 8.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumCivilMilitaryCoordinationPos = {
  "id": "icon--wfp-hum--civil-military-coordination-pos",
  "name": "icon--wfp-hum--civil-military-coordination-pos",
  "tags": "icon--wfp-hum--civil-military-coordination-pos",
  "styles": "",
  "viewBox": "0 0 41 41",
  "width": "41",
  "height": "41",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M15 31.9c-.2-.2-.6-.4-.9-.4-.3 0-.7.1-.9.4-.5.5-.5 1.3 0 1.8l1.2 1.2H1.5c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3h12.9l-1.2 1.2c-.5.5-.5 1.3 0 1.8s1.3.5 1.8 0l3.4-3.4c.5-.5.5-1.3 0-1.8L15 31.9zm-8.9-26c0 2.1 1.7 3.8 3.8 3.8 2.1 0 3.8-1.7 3.8-3.8 0-.5-.1-.9-.2-1.3H6.4c-.2.4-.3.8-.3 1.3zm33.2 29H26.4l1.2-1.2c.5-.5.5-1.3 0-1.8-.2-.2-.6-.4-.9-.4-.3 0-.7.1-.9.4l-3.4 3.4c-.5.5-.5 1.3 0 1.8l3.4 3.4c.5.5 1.3.5 1.8 0s.5-1.3 0-1.8l-1.2-1.2h12.9c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3zM15.4 13.1l-1 1-1.1 1.1-7.1 7.1h8.3v-6.2c1.3 1.2 2.1 3 2.1 4.9 0 1.9-.8 3.7-2.1 4.9v-1.2H5.2V26C3.9 24.8 3 23 3 21s.8-3.7 2.2-5v3.6l5.4-5.4 1.2-1.2 1.2-1.2c-1-.3-2-.5-3.1-.5C4.6 11.3.2 15.6.2 21c0 3.7 2 6.9 5.1 8.5 0 .2.2.3.4.3h8.5c.2 0 .4-.2.4-.3 3-1.6 5-4.8 5-8.5-.1-3.3-1.7-6.2-4.2-7.9zm15.5-3.5c2.1 0 3.8-1.7 3.8-3.8C34.7 3.7 33 2 30.9 2c-2.1 0-3.8 1.7-3.8 3.8 0 2.1 1.7 3.8 3.8 3.8z"
    }, {
      "fill-rule": "nonzero",
      "d": "M26.3 29.5c.1.2.2.4.5.4h8.3c.2 0 .4-.2.4-.4 3-1.6 5-4.8 5-8.5 0-5.3-4.3-9.7-9.7-9.7-5.3 0-9.7 4.3-9.7 9.7.1 3.7 2.2 6.8 5.2 8.5zm9.3-13.4c1.3 1.2 2.1 3 2.1 4.9 0 1.9-.8 3.7-2.1 4.9v-9.8zm-9.3 0c0-.1 0-.1 0 0V26c-1.3-1.2-2.1-3-2.1-4.9 0-1.9.8-3.8 2.1-5z"
    }, {
      "d": "M6.9 2.9h5.9c.5 0 .8-.4.8-.9v-.8c0-.5-.4-.9-.9-.9L6.8 1c-.4.1-.8.4-.8.9V2c.1.5.4.9.9.9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumConflictNeg = {
  "id": "icon--wfp-hum--conflict-neg",
  "name": "icon--wfp-hum--conflict-neg",
  "tags": "icon--wfp-hum--conflict-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM26 12c0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4v8c0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4v-8zM9.9 10.3c1-1 2.5-1 3.4 0l10.3 10.3c1 1 1 2.5 0 3.4-1 1-2.5 1-3.4 0L9.9 13.8c-1-1-1-2.5 0-3.5zM22 28.8c0 1.3-1.1 2.4-2.4 2.4h-4.8c-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4h4.8c1.3 0 2.4 1.1 2.4 2.4zm1.7 8l-7.4 7.4c-.9.9-2.4.9-3.3 0-.9-.9-.9-2.4 0-3.3l7.4-7.4c.9-.9 2.4-.9 3.3 0 .9.9.9 2.4 0 3.3zm7.1 8.9c0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4v-8c0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4v8zm-2.4-12.9c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm4.7-11.9l2.6-2.6c.9-.9 2.4-.9 3.3 0 .9.9.9 2.4 0 3.3l-2.7 2.6c-.9.9-2.3.9-3.2 0-.9-.9-.9-2.4 0-3.3zm7.4 20c-.9.9-2.4.9-3.3 0l-4.1-4.1c-.9-.9-.9-2.4 0-3.3.9-.9 2.4-.9 3.3 0l4.1 4.1c.9 1 .9 2.4 0 3.3zm7.1-12.1c0 1.3-1.1 2.4-2.6 2.4h-7.7c-1.4 0-2.6-1.1-2.6-2.4 0-1.3 1.1-2.4 2.6-2.4H45c1.5 0 2.6 1.1 2.6 2.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumConflictPos = {
  "id": "icon--wfp-hum--conflict-pos",
  "name": "icon--wfp-hum--conflict-pos",
  "tags": "icon--wfp-hum--conflict-pos",
  "styles": "",
  "viewBox": "0 0 39 40",
  "width": "39",
  "height": "40",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M17 3C17 1.7 18.1.6 19.4.6c1.3 0 2.4 1.1 2.4 2.4v8c0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4V3zM.9 1.3c1-1 2.5-1 3.4 0l10.3 10.3c1 1 1 2.5 0 3.4-1 1-2.5 1-3.4 0L.9 4.8c-1-1-1-2.5 0-3.5zM13 19.8c0 1.3-1.1 2.4-2.4 2.4H5.8c-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4h4.8c1.3 0 2.4 1.1 2.4 2.4zm1.7 8l-7.4 7.4c-.9.9-2.4.9-3.3 0-.9-.9-.9-2.4 0-3.3l7.4-7.4c.9-.9 2.4-.9 3.3 0 .9.9.9 2.4 0 3.3zm7.1 8.9c0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4v-8c0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4v8zm-2.4-12.9c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm4.7-11.9l2.6-2.6c.9-.9 2.4-.9 3.3 0 .9.9.9 2.4 0 3.3l-2.7 2.6c-.9.9-2.3.9-3.2 0-.9-.9-.9-2.4 0-3.3zm7.4 20c-.9.9-2.4.9-3.3 0l-4.1-4.1c-.9-.9-.9-2.4 0-3.3.9-.9 2.4-.9 3.3 0l4.1 4.1c.9 1 .9 2.4 0 3.3zm7.1-12.1c0 1.3-1.1 2.4-2.6 2.4h-7.7c-1.4 0-2.6-1.1-2.6-2.4 0-1.3 1.1-2.4 2.6-2.4H36c1.5 0 2.6 1.1 2.6 2.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumDroughtNeg = {
  "id": "icon--wfp-hum--drought-neg",
  "name": "icon--wfp-hum--drought-neg",
  "tags": "icon--wfp-hum--drought-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM29.3 16.2c0 .7-.6 1.3-1.3 1.3h-2.7c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3H28c.7 0 1.3.6 1.3 1.3zM26 24c-.5.5-1.4.5-1.9 0l-1.9-1.9c-.5-.5-.5-1.4 0-1.9s1.4-.5 1.9 0l1.9 1.9c.5.6.5 1.4 0 1.9zm-3.7-13.7l1.9-1.9c.5-.5 1.4-.5 1.9 0s.5 1.4 0 1.9l-1.9 1.9c-.5.5-1.4.5-1.9 0-.6-.6-.6-1.4 0-1.9zm-5.4-3.8c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3v2.7c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3V6.5zm1.3 5.7c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm1.3 11.1V26c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3v-2.7c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3zm-5.4-1.1L12.2 24c-.5.5-1.4.5-1.9 0s-.5-1.4 0-1.9l1.9-1.9c.5-.5 1.4-.5 1.9 0 .5.6.5 1.4 0 2zM10.4 8.4c.5-.5 1.4-.5 1.9 0l1.9 1.9c.5.5.5 1.4 0 1.9s-1.4.5-1.9 0l-1.9-1.9c-.6-.6-.5-1.4 0-1.9zm-1.9 6.5h2.7c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3H8.5c-.7 0-1.3-.6-1.3-1.3-.1-.7.5-1.3 1.3-1.3zm36.7 7.9c0-1.9-1.6-3.5-3.5-3.5s-3.6 1.6-3.6 3.5v20.4h9.3c1.2 0 2.2 1 2.2 2.2 0 1.2-1 2.2-2.2 2.2H9.3c-1.2 0-2.2-1-2.2-2.2 0-1.2 1-2.2 2.2-2.2h26.1V29.9h-2.2c-1.2 0-2.2 1-2.2 2.2v1.1c1 .5 1.8 1.6 1.8 2.8 0 1.5-2.5 4.8-3 5.4 0 .1-.1.1-.2 0-.5-.6-3-3.9-3-5.4 0-1.2.7-2.3 1.8-2.8v-1.5c.2-1.7 1.2-3.1 2.6-3.9.5-.3 1.1-.5 1.8-.5h2.6v-4.5c0-3.4 2.8-6.2 6.2-6.2 3.4 0 6.2 2.8 6.2 6.2v.6c1 .5 1.8 1.6 1.8 2.8 0 1.5-2.5 4.8-3 5.4 0 .1-.1.1-.2 0-.5-.6-3-3.9-3-5.4 0-1.2.7-2.3 1.8-2.8v-.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumDroughtPos = {
  "id": "icon--wfp-hum--drought-pos",
  "name": "icon--wfp-hum--drought-pos",
  "tags": "icon--wfp-hum--drought-pos",
  "styles": "",
  "viewBox": "0 0 43 43",
  "width": "43",
  "height": "43",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M22.3 11.2c0 .7-.6 1.3-1.3 1.3h-2.7c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3H21c.7 0 1.3.6 1.3 1.3zM19 19c-.5.5-1.4.5-1.9 0l-1.9-1.9c-.5-.5-.5-1.4 0-1.9s1.4-.5 1.9 0l1.9 1.9c.5.6.5 1.4 0 1.9zM15.3 5.3l1.9-1.9c.5-.5 1.4-.5 1.9 0s.5 1.4 0 1.9l-1.9 1.9c-.5.5-1.4.5-1.9 0-.6-.6-.6-1.4 0-1.9zM9.9 1.5c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3v2.7c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3V1.5zm1.3 5.7c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm1.3 11.1V21c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3v-2.7c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3zm-5.4-1.1L5.2 19c-.5.5-1.4.5-1.9 0s-.5-1.4 0-1.9l1.9-1.9c.5-.5 1.4-.5 1.9 0 .5.6.5 1.4 0 2zM3.4 3.4c.5-.5 1.4-.5 1.9 0l1.9 1.9c.5.5.5 1.4 0 1.9s-1.4.5-1.9 0L3.4 5.3c-.6-.6-.5-1.4 0-1.9zM1.5 9.9h2.7c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3H1.5c-.7 0-1.3-.6-1.3-1.3-.1-.7.5-1.3 1.3-1.3zm36.7 7.9c0-1.9-1.6-3.5-3.5-3.5s-3.6 1.6-3.6 3.5v20.4h9.3c1.2 0 2.2 1 2.2 2.2 0 1.2-1 2.2-2.2 2.2H2.3c-1.2 0-2.2-1-2.2-2.2 0-1.2 1-2.2 2.2-2.2h26.1V24.9h-2.2c-1.2 0-2.2 1-2.2 2.2v1.1c1 .5 1.8 1.6 1.8 2.8 0 1.5-2.5 4.8-3 5.4 0 .1-.1.1-.2 0-.5-.6-3-3.9-3-5.4 0-1.2.7-2.3 1.8-2.8v-1.5c.2-1.7 1.2-3.1 2.6-3.9.5-.3 1.1-.5 1.8-.5h2.6v-4.5c0-3.4 2.8-6.2 6.2-6.2 3.4 0 6.2 2.8 6.2 6.2v.6c1 .5 1.8 1.6 1.8 2.8 0 1.5-2.5 4.8-3 5.4 0 .1-.1.1-.2 0-.5-.6-3-3.9-3-5.4 0-1.2.7-2.3 1.8-2.8v-.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEarthquakeNeg = {
  "id": "icon--wfp-hum--earthquake-neg",
  "name": "icon--wfp-hum--earthquake-neg",
  "tags": "icon--wfp-hum--earthquake-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-9.2 46.5c0 .5-.4.8-.8.8H28.2l6.4-6.4c.3-.3.5-.8.5-1.2 0-.5-.2-.9-.6-1.2l-7-6.3 4.4-3.8c.4-.3.6-.8.6-1.2 0-.5-.2-.9-.5-1.3l-3-3 2.2-2.2c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-3.4 3.4c-.7.7-.7 1.7 0 2.4l2.9 2.9-4.5 3.9c-.4.3-.6.8-.6 1.3s.2.9.6 1.3l7.1 6.4-7.5 7.5h-11c-.5 0-.8-.4-.8-.8V22.9c0-.3.1-.6.4-.8l15.9-15c.3-.3.8-.3 1.2 0l15.9 15c.2.2.4.5.4.8v23.6h-.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEarthquakePos = {
  "id": "icon--wfp-hum--earthquake-pos",
  "name": "icon--wfp-hum--earthquake-pos",
  "tags": "icon--wfp-hum--earthquake-pos",
  "styles": "",
  "viewBox": "0 0 35 42",
  "width": "35",
  "height": "42",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M34.2 40.5c0 .5-.4.8-.8.8H17.2l6.4-6.4c.3-.3.5-.8.5-1.2 0-.5-.2-.9-.6-1.2l-7-6.3 4.4-3.8c.4-.3.6-.8.6-1.2 0-.5-.2-.9-.5-1.3l-3-3 2.2-2.2c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-3.4 3.4c-.7.7-.7 1.7 0 2.4l2.9 2.9-4.5 3.9c-.4.3-.6.8-.6 1.3s.2.9.6 1.3l7.1 6.4-7.5 7.5h-11c-.5 0-.8-.4-.8-.8V16.9c0-.3.1-.6.4-.8l15.9-15c.3-.3.8-.3 1.2 0l15.9 15c.2.2.4.5.4.8v23.6h-.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEmailContactNeg = {
  "id": "icon--wfp-hum--email-contact-neg",
  "name": "icon--wfp-hum--email-contact-neg",
  "tags": "icon--wfp-hum--email-contact-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-6.8 38.5c0 .9-.7 1.6-1.6 1.6H10.8c-.9 0-1.6-.7-1.6-1.6V17.7c0-.9.7-1.6 1.6-1.6H46c.9 0 1.6.7 1.6 1.6v20.8z"
    }, {
      "d": "M39 30.1c-.7-.6-1.7-.5-2.3.2-.6.7-.5 1.7.2 2.3l5.6 4.8c.3.3.7.4 1 .4.4 0 .9-.2 1.2-.6.6-.7.5-1.7-.2-2.3L39 30.1zm3.6-11.3L28.4 29.3 14.1 18.8c-.7-.5-1.7-.4-2.2.3-.5.7-.4 1.7.3 2.2l15.2 11.2c.3.2.6.3 1 .3.3 0 .7-.1 1-.3l15.2-11.2c.7-.5.9-1.5.3-2.2-.5-.7-1.5-.8-2.3-.3zM17.7 30.1l-5.6 4.8c-.7.6-.8 1.6-.2 2.3.3.4.8.6 1.2.6.4 0 .7-.1 1-.4l5.6-4.8c.7-.6.8-1.6.2-2.3-.5-.7-1.5-.8-2.2-.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEmailContactPos = {
  "id": "icon--wfp-hum--email-contact-pos",
  "name": "icon--wfp-hum--email-contact-pos",
  "tags": "icon--wfp-hum--email-contact-pos",
  "styles": "",
  "viewBox": "0 0 39 25",
  "width": "39",
  "height": "25",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M37 .1H1.8C.9.1.2.8.2 1.7v20.8c0 .9.7 1.6 1.6 1.6H37c.9 0 1.6-.7 1.6-1.6V1.7c0-.9-.7-1.6-1.6-1.6zM10.8 16.5l-5.6 4.8c-.3.3-.7.4-1 .4-.4 0-.9-.2-1.2-.6-.6-.7-.5-1.7.2-2.3L8.8 14c.7-.6 1.7-.5 2.3.2.5.7.4 1.7-.3 2.3zm25 4.6c-.3.4-.8.6-1.2.6-.4 0-.7-.1-1-.4L28 16.5c-.7-.6-.8-1.6-.2-2.3.6-.7 1.6-.8 2.3-.2l5.6 4.8c.6.6.7 1.6.1 2.3zm-.2-15.7L20.3 16.6c-.3.2-.6.3-1 .3-.3 0-.7-.1-1-.3L3.2 5.4c-.7-.5-.9-1.5-.3-2.2.5-.7 1.5-.9 2.2-.3l14.3 10.5L33.7 2.9c.7-.5 1.7-.4 2.2.3.5.6.4 1.6-.3 2.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEmergencyResponseNeg = {
  "id": "icon--wfp-hum--emergency-response-neg",
  "name": "icon--wfp-hum--emergency-response-neg",
  "tags": "icon--wfp-hum--emergency-response-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M34.8 39.8h-2v5.8h1.6v-1.9h.4c.7 0 1.3-.2 1.6-.5.4-.4.6-.9.6-1.5s-.2-1.1-.6-1.4c-.3-.3-.9-.5-1.6-.5zm.4 2.4c-.1.1-.3.2-.6.2h-.3v-1.3h.4c.4 0 .7.2.7.6 0 .2-.1.4-.2.5z"
    }, {
      "d": "M28.7 45.7h1.6v-2.2H32v-1.3h-1.7v-1.1h1.9v-1.3h-3.5zm-2.8-3c-.2.7-.3 1.2-.3 1.5 0-.2-.1-.6-.2-1-.1-.5-.2-.9-.3-1.2l-.5-2.2h-1.5l-.4 2.2c-.1.3-.2.7-.3 1.2-.1.5-.2.8-.2 1.1-.1-.4-.2-.9-.3-1.5l-.6-2.9h-1.5l1.4 5.8h1.9c.3-1.5.5-2.4.6-2.6 0-.2.1-.5.1-.7 0-.3.1-.5.1-.6 0 .2.1.5.1.8.1.3.1.5.1.6l.6 2.5h1.9l1.4-5.8h-1.5l-.6 2.8z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM39.6 48.6c0 .5-.4.8-.8.8H18c-.5 0-.8-.4-.8-.8V36.8c0-.5.4-.8.8-.8h20.8c.5 0 .8.4.8.8v11.8zm.2-24.8L29.3 33.9c-.1.1-.2.2-.4.2-.1.1-.3.1-.4.1-.2 0-.3 0-.4-.1-.1-.1-.3-.1-.4-.2L17 23.8c-.5-.5-.5-1.3 0-1.8s1.3-.5 1.8 0l9.7 9.3L38 22c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.8zM14 20c0-8 6.5-14.4 14.4-14.4S42.7 12 42.7 19.9H14v.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEmergencyResponsePos = {
  "id": "icon--wfp-hum--emergency-response-pos",
  "name": "icon--wfp-hum--emergency-response-pos",
  "tags": "icon--wfp-hum--emergency-response-pos",
  "styles": "",
  "viewBox": "0 0 29 45",
  "width": "29",
  "height": "45",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M14.4.6C6.5.6 0 7 0 15h28.7C28.7 7 22.3.6 14.4.6zm6.3 35.5h-.4v1.3h.3c.2 0 .4-.1.6-.2.1-.1.2-.3.2-.6s-.2-.5-.7-.5z"
    }, {
      "fill-rule": "nonzero",
      "d": "M24.8 31H4c-.5 0-.8.4-.8.8v11.8c0 .5.4.8.8.8h20.8c.5 0 .8-.4.8-.8V31.8c0-.5-.4-.8-.8-.8zm-12.2 9.7h-1.9l-.6-2.5c0-.1-.1-.3-.1-.6s-.1-.6-.1-.8c0 .2-.1.4-.1.6 0 .3-.1.5-.1.7 0 .2-.2 1.1-.6 2.6H7.2l-1.4-5.8h1.5l.6 2.9c.1.6.2 1.2.3 1.5 0-.3.1-.6.2-1.1.1-.5.2-.9.3-1.2l.5-2.2h1.5l.5 2.2.3 1.2c.1.5.1.8.2 1 0-.3.1-.8.3-1.5l.6-2.9H14l-1.4 5.9zm5.6-4.6h-1.9v1.1H18v1.3h-1.8v2.2h-1.6v-5.8h3.5v1.2h.1zm4.2 2.1c-.4.4-.9.5-1.6.5h-.4v1.9h-1.6v-5.8h2c.7 0 1.3.2 1.7.5.4.3.6.8.6 1.4-.1.6-.3 1.1-.7 1.5z"
    }, {
      "d": "M24 17l-9.7 9.3L4.7 17c-.5-.5-1.3-.5-1.8 0s-.5 1.3 0 1.8l10.5 10.1c.1.1.2.2.4.2.1.1.3.1.4.1.2 0 .3 0 .4-.1.1-.1.3-.1.4-.2l10.5-10.1c.5-.5.5-1.3 0-1.8-.2-.5-1-.5-1.5 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEmergencyTelecommunicationsClusterNeg = {
  "id": "icon--wfp-hum--emergency-telecommunications-cluster-neg",
  "name": "icon--wfp-hum--emergency-telecommunications-cluster-neg",
  "tags": "icon--wfp-hum--emergency-telecommunications-cluster-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM34.2 13.1c-.4-.6-.5-1.5 0-2s1.5-.3 2.1.7c1.9 3 1.9 6.9 0 10-.6.9-1.7 1.2-2.1.7-.5-.5-.4-1.4 0-2 1.4-2.4 1.4-5.2 0-7.4zm-13.6-1.4c.6-.9 1.7-1.2 2.1-.7.5.5.4 1.4 0 2-1.4 2.2-1.4 5 0 7.2.4.6.5 1.5 0 2s-1.5.3-2.1-.7c-1.9-2.9-1.9-6.8 0-9.8zm-5.1-1.8c.6-.8 1.6-1 2.1-.5s.4 1.4 0 2c-2.3 3.1-2.3 7.4 0 10.6.4.6.5 1.5 0 2s-1.5.3-2.1-.5c-2.9-4.1-2.9-9.6 0-13.6zM38.6 47H18.4c-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7h8.4v-24c-1-.6-1.7-1.7-1.7-2.9 0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4c0 1.2-.7 2.3-1.7 2.9v24h8.4c.9 0 1.7.8 1.7 1.7 0 .9-.7 1.7-1.7 1.7zm2.9-23.6c-.6.8-1.6 1-2.1.5s-.4-1.4 0-2c2.3-3.1 2.3-7.4 0-10.6-.4-.6-.5-1.5 0-2s1.5-.3 2.1.5c2.9 4.1 2.9 9.6 0 13.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEmergencyTelecommunicationsClusterPos = {
  "id": "icon--wfp-hum--emergency-telecommunications-cluster-pos",
  "name": "icon--wfp-hum--emergency-telecommunications-cluster-pos",
  "tags": "icon--wfp-hum--emergency-telecommunications-cluster-pos",
  "styles": "",
  "viewBox": "0 0 31 38",
  "width": "31",
  "height": "38",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21.2 4.1c-.4-.6-.5-1.5 0-2s1.5-.3 2.1.7c1.9 3 1.9 6.9 0 10-.6.9-1.7 1.2-2.1.7-.5-.5-.4-1.4 0-2 1.4-2.4 1.4-5.2 0-7.4zM7.6 2.7c.6-.9 1.7-1.2 2.1-.7.5.5.4 1.4 0 2-1.4 2.2-1.4 5 0 7.2.4.6.5 1.5 0 2s-1.5.3-2.1-.7c-1.9-2.9-1.9-6.8 0-9.8zM2.5.9c.6-.8 1.6-1 2.1-.5s.4 1.4 0 2C2.3 5.5 2.3 9.8 4.6 13c.4.6.5 1.5 0 2s-1.5.3-2.1-.5C-.4 10.4-.4 4.9 2.5.9zM25.6 38H5.4c-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7h8.4v-24c-1-.6-1.7-1.7-1.7-2.9 0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4c0 1.2-.7 2.3-1.7 2.9v24h8.4c.9 0 1.7.8 1.7 1.7 0 .9-.7 1.7-1.7 1.7zm2.9-23.6c-.6.8-1.6 1-2.1.5s-.4-1.4 0-2c2.3-3.1 2.3-7.4 0-10.6-.4-.6-.5-1.5 0-2s1.5-.3 2.1.5c2.9 4.1 2.9 9.6 0 13.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEvacuationNeg = {
  "id": "icon--wfp-hum--evacuation-neg",
  "name": "icon--wfp-hum--evacuation-neg",
  "tags": "icon--wfp-hum--evacuation-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM29.8 45.2c-.2.4-.6.7-1 .9-.4.1-.9.1-1.3-.1-.9-.4-1.2-1.5-.8-2.4 2.1-4.1.6-9.2-3.5-11.4l-3.8-1.9-7.6 14.9c-.3.6-.9 1-1.6 1-.3 0-.5-.1-.8-.2-.9-.4-1.2-1.5-.8-2.4L21.2 19c-3.4-.4-6.9 1.3-8.6 4.5-.4.9-1.5 1.2-2.3.8-.9-.4-1.3-1.5-.8-2.3 2.9-5.7 9.7-8 15.4-5.5.1 0 .2.1.4.1l2.2 1.1c2 1 2.8 3.5 1.8 5.5L26 29.8c4.8 3.4 6.6 10 3.8 15.4zm1.6-28.7c-1.8.6-3.7-.4-4.3-2.1-.6-1.8.4-3.7 2.1-4.3 1.8-.6 3.7.4 4.3 2.1.6 1.8-.3 3.7-2.1 4.3zm4 18.7c-.3 0-.7-.1-.9-.4-.5-.5-.5-1.3 0-1.9l3.7-3.7 1.2-1.3-1.2-1.3-3.7-3.7c-.5-.5-.5-1.3 0-1.9.5-.5 1.3-.5 1.9 0l5.9 5.9c.2.2.4.6.4.9 0 .3-.1.7-.4.9l-5.9 5.9c-.3.5-.6.6-1 .6zM48.5 29l-5.9 5.9c-.3.3-.6.4-.9.4-.3 0-.7-.1-.9-.4-.5-.5-.5-1.3 0-1.9l3.7-3.7 1.2-1.3-1.2-1.3-3.7-3.7c-.5-.5-.5-1.3 0-1.9.5-.5 1.3-.5 1.9 0l5.9 5.9c.2.2.4.6.4.9-.1.5-.2.8-.5 1.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEvacuationPos = {
  "id": "icon--wfp-hum--evacuation-pos",
  "name": "icon--wfp-hum--evacuation-pos",
  "tags": "icon--wfp-hum--evacuation-pos",
  "styles": "",
  "viewBox": "0 0 41 38",
  "width": "41",
  "height": "38",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21.8 36.2c-.2.4-.6.7-1 .9-.4.1-.9.1-1.3-.1-.9-.4-1.2-1.5-.8-2.4 2.1-4.1.6-9.2-3.5-11.4l-3.8-1.9-7.6 14.9c-.3.6-.9 1-1.6 1-.3 0-.5-.1-.8-.2-.9-.4-1.2-1.5-.8-2.4L13.2 10c-3.4-.4-6.9 1.3-8.6 4.5-.4.9-1.5 1.2-2.3.8-.9-.4-1.3-1.5-.8-2.3 2.9-5.7 9.7-8 15.4-5.5.1 0 .2.1.4.1l2.2 1.1c2 1 2.8 3.5 1.8 5.5L18 20.8c4.8 3.4 6.6 10 3.8 15.4zm1.6-28.7c-1.8.6-3.7-.4-4.3-2.1-.6-1.8.4-3.7 2.1-4.3 1.8-.6 3.7.4 4.3 2.1.6 1.8-.3 3.7-2.1 4.3zm4 18.7c-.3 0-.7-.1-.9-.4-.5-.5-.5-1.3 0-1.9l3.7-3.7 1.2-1.3-1.2-1.3-3.7-3.7c-.5-.5-.5-1.3 0-1.9.5-.5 1.3-.5 1.9 0l5.9 5.9c.2.2.4.6.4.9 0 .3-.1.7-.4.9l-5.9 5.9c-.3.5-.6.6-1 .6zM40.5 20l-5.9 5.9c-.3.3-.6.4-.9.4-.3 0-.7-.1-.9-.4-.5-.5-.5-1.3 0-1.9l3.7-3.7 1.2-1.3-1.2-1.3-3.7-3.7c-.5-.5-.5-1.3 0-1.9.5-.5 1.3-.5 1.9 0l5.9 5.9c.2.2.4.6.4.9-.1.5-.2.8-.5 1.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEvaluationNeg = {
  "id": "icon--wfp-hum--evaluation-neg",
  "name": "icon--wfp-hum--evaluation-neg",
  "tags": "icon--wfp-hum--evaluation-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M31.2 33.1H34c-.1-.9-.3-1.8-.6-2.6h-2.2c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1h1c-1.3-1.7-3.1-2.9-5.3-3.4l-.1 13.6 6 .1c.6-1 1-2.2 1.2-3.4h-2.8c-.6 0-1.1-.5-1.1-1.1.1-.6.5-1 1.1-1zM40 11.5v4.2l4.6.1z"
    }, {
      "d": "M24.4 38.5V24.8c-4.8.3-8.7 4.3-8.7 9.2 0 2.4.9 4.6 2.5 6.3 1 1.1 2.3 1.9 3.7 2.4.4.1.8.3 1.2.3.6.1 1.2.2 1.8.2.6 0 1.2-.1 1.8-.2l1.2-.3c.9-.3 1.7-.8 2.5-1.4H27c-1.5-.1-2.6-1.3-2.6-2.8z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM12 50.4c-1 1-2.6 1-3.6 0s-1-2.6 0-3.6l4.4-4.4c1 1.4 2.2 2.6 3.6 3.6L12 50.4zm37-11.9c0 1.5-1.2 2.7-2.6 2.7H34.8c-2.2 3-5.8 5-9.8 5-6.8 0-12.3-5.5-12.3-12.3 0-6.6 5.2-11.9 11.7-12.2V10c0-1.5 1.2-2.7 2.6-2.7h12.1c.2 0 .4.1.5.3l9 8.6c.2.2.3.3.3.6v21.7h.1z"
    }, {
      "d": "M38.8 18.4c-.7 0-1.3-.6-1.3-1.3V9.9H27l-.1 12c1.7.3 3.2.9 4.6 1.8h10.7c.6 0 1.1.5 1.1 1.1 0 .6-.5 1.1-1.1 1.1H34c.7.8 1.3 1.7 1.8 2.6h6.4c.6 0 1.1.5 1.1 1.1 0 .6-.5 1.1-1.1 1.1h-5.6c.3.8.4 1.7.5 2.6h5.1c.6 0 1.1.5 1.1 1.1 0 .6-.5 1.1-1.1 1.1h-5.1c-.1 1.2-.4 2.4-.8 3.4l10.1.1.1-.2V18.4h-7.7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumEvaluationPos = {
  "id": "icon--wfp-hum--evaluation-pos",
  "name": "icon--wfp-hum--evaluation-pos",
  "tags": "icon--wfp-hum--evaluation-pos",
  "styles": "",
  "viewBox": "0 0 42 45",
  "width": "42",
  "height": "45",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M42 10v-.2l-.3-.6-9-8.6c-.1-.1-.3-.2-.5-.3H20c-1.5 0-2.6 1.2-2.6 2.7v11.7c-6.5.3-11.7 5.6-11.7 12.2 0 6.8 5.5 12.3 12.3 12.3 4 0 7.6-2 9.8-5h11.6c1.5 0 2.6-1.2 2.6-2.7V10zm-9-5.5l4.5 4.3-4.5-.1V4.5zM21 35.6c-.4.1-.8.3-1.2.3-.6.1-1.2.2-1.8.2-.6 0-1.2-.1-1.8-.2l-1.2-.3c-1.4-.5-2.7-1.3-3.7-2.4-1.5-1.6-2.5-3.8-2.5-6.3 0-4.9 3.8-8.9 8.7-9.2v13.8c0 1.5 1.2 2.7 2.6 2.7h3.5c-.9.6-1.7 1.1-2.6 1.4zm3.2-7.4H27c-.2 1.2-.6 2.4-1.2 3.4l-6-.1.1-13.6c2.1.5 4 1.7 5.3 3.4h-1c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h2.2c.3.8.5 1.7.6 2.6h-2.8c-.6 0-1.1.5-1.1 1.1.1.5.5 1 1.1 1zm15.3 3.3l-.1.2-10.1-.1c.4-1.1.7-2.2.8-3.4h5.1c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1h-5.1c-.1-.9-.2-1.8-.5-2.6h5.6c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1h-6.4c-.5-1-1.1-1.8-1.8-2.6h8.2c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1H24.5c-1.4-.9-2.9-1.5-4.6-1.8l.1-12h10.5v7.3c0 .7.6 1.3 1.3 1.3h7.8v20.3h-.1z"
    }, {
      "d": "M5.9 35.4l-4.4 4.4c-1 1-1 2.6 0 3.6s2.6 1 3.6 0L9.5 39c-1.4-1-2.7-2.2-3.6-3.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumFloodsNeg = {
  "id": "icon--wfp-hum--floods-neg",
  "name": "icon--wfp-hum--floods-neg",
  "tags": "icon--wfp-hum--floods-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-7.9 45.6c-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7 2 0 3 .6 3.9 1 .7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1s3 .6 3.9 1c.7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1s3 .6 3.9 1c.7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1 .9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7zm0-6.7c-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7 2 0 3 .6 3.9 1 .7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1s3 .6 3.9 1c.7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1s3 .6 3.9 1c.7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1 .9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7zm1.7-6.6c-.5-.1-1-.2-1.7-.2-2 0-3 .6-3.9 1-.7.4-1.2.6-2.3.6-1.1 0-1.6-.3-2.3-.6-.9-.5-1.9-1-3.9-1s-3 .6-3.9 1c-.7.4-1.2.6-2.3.6-1.1 0-1.6-.3-2.3-.6-.7-.4-1.5-.8-2.8-1V17.3c0-.1.1-.2.2-.3L35.4 6.9c.1-.1.2-.1.3 0l12.3 10c.1.1.2.2.2.3v15.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumFloodsPos = {
  "id": "icon--wfp-hum--floods-pos",
  "name": "icon--wfp-hum--floods-pos",
  "tags": "icon--wfp-hum--floods-pos",
  "styles": "",
  "viewBox": "0 0 42 42",
  "width": "42",
  "height": "42",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M39.5 39.6c-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7 2 0 3 .6 3.9 1 .7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1s3 .6 3.9 1c.7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1s3 .6 3.9 1c.7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1 .9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7zm0-6.7c-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-1.1 0-1.6.3-2.3.6-.9.5-1.9 1-3.9 1s-3-.6-3.9-1c-.7-.4-1.2-.6-2.3-.6-.9 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7 2 0 3 .6 3.9 1 .7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1s3 .6 3.9 1c.7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1s3 .6 3.9 1c.7.4 1.2.6 2.3.6 1.1 0 1.6-.3 2.3-.6.9-.5 1.9-1 3.9-1 .9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7zm1.7-6.6c-.5-.1-1-.2-1.7-.2-2 0-3 .6-3.9 1-.7.4-1.2.6-2.3.6-1.1 0-1.6-.3-2.3-.6-.9-.5-1.9-1-3.9-1s-3 .6-3.9 1c-.7.4-1.2.6-2.3.6-1.1 0-1.6-.3-2.3-.6-.7-.4-1.5-.8-2.8-1V11.3c0-.1.1-.2.2-.3L28.4.9c.1-.1.2-.1.3 0l12.3 10c.1.1.2.2.2.3v15.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumFoodAssistanceForAssetsNeg = {
  "id": "icon--wfp-hum--food-assistance-for-assets-neg",
  "name": "icon--wfp-hum--food-assistance-for-assets-neg",
  "tags": "icon--wfp-hum--food-assistance-for-assets-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM20.8 24.2h-4.6v2.7h4.2v3h-4.2v5.3h-3.7v-14h8.3v3zM31 29.9h-4.2v5.3h-3.7v-14h8.3v3h-4.6v2.7H31v3zm10.5 5.2l-.7-2.6h-4.6l-.7 2.6h-4.2L35.9 21H41l4.6 14.1h-4.1z"
    }, {
      "d": "M38.9 25.1c-.2-.8-.3-1.4-.4-1.7-.1.3-.2.9-.3 1.6-.2.7-.5 2.2-1.1 4.4h3l-.6-2.3c-.2-.5-.4-1.2-.6-2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumFoodAssistanceForAssetsPos = {
  "id": "icon--wfp-hum--food-assistance-for-assets-pos",
  "name": "icon--wfp-hum--food-assistance-for-assets-pos",
  "tags": "icon--wfp-hum--food-assistance-for-assets-pos",
  "styles": "",
  "viewBox": "0 0 34 15",
  "width": "34",
  "height": "15",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M14.8 3.2h4.6V.1h-8.3v14h3.7V8.9H19V5.8h-4.2zM.5 14.1h3.7V8.9h4.2V5.8H4.2V3.2h4.6V.1H.5z"
    }, {
      "fill-rule": "nonzero",
      "d": "M29 .1h-5.1l-4.6 14.1h4.2l.7-2.6h4.6l.7 2.6h4.1L29 .1zm-4 8.3c.6-2.2 1-3.7 1.1-4.4.2-.7.3-1.3.3-1.6.1.4.2.9.4 1.7.2.8.4 1.5.5 2l.6 2.3H25z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumFoodDistributionNeg = {
  "id": "icon--wfp-hum--food-distribution-neg",
  "name": "icon--wfp-hum--food-distribution-neg",
  "tags": "icon--wfp-hum--food-distribution-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-31 10.5l4.2-4.2c.1-.1.3-.2.4-.3.1-.1.3-.1.4-.1.2 0 .3 0 .4.1.1.1.3.2.4.3l4.2 4.2c.5.5.5 1.3 0 1.8s-1.3.5-1.8 0l-2.1-2.1-.1 6.9c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3l.1-6.8-2.1 2.1c-.5.5-1.3.5-1.8 0-.1-.6-.1-1.4.4-1.9zm-3 15.3c.9 0 1.7.2 2.4.6.8-2.3 3-4 5.6-4 2.6 0 4.8 1.7 5.6 4 .7-.4 1.6-.6 2.4-.6 2.9 0 5.2 2.2 5.5 5.1 3.3 0 5.9 2.6 5.9 5.9H9c0-3.3 2.6-5.9 5.9-5.9.2-2.9 2.6-5.1 5.5-5.1zM7.1 22.1c-.7 0-1.3-.6-1.3-1.3v-6c0-.2 0-.3.1-.5l.3-.3c.1-.1.2-.2.4-.3.2-.1.3-.1.5-.1h6c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3h-2.9l4.9 4.8c.5.5.5 1.3 0 1.8s-1.3.5-1.8 0L8.4 18v2.9c0 .6-.6 1.2-1.3 1.2zM45.4 47c-2 2-4.7 3.2-7.7 3.2H19.1c-6.1 0-11-4.9-11-11h40.5c0 3.1-1.2 5.8-3.2 7.8zm5.8-32.1v6c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3V18l-4.9 4.8c-.5.5-1.3.5-1.8 0s-.5-1.3 0-1.8l4.9-4.8h-2.9c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h6c.2 0 .3 0 .5.1.1.1.3.1.4.3.1.1.2.2.2.4.2.2.2.3.2.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumFoodDistributionPos = {
  "id": "icon--wfp-hum--food-distribution-pos",
  "name": "icon--wfp-hum--food-distribution-pos",
  "tags": "icon--wfp-hum--food-distribution-pos",
  "styles": "",
  "viewBox": "0 0 47 46",
  "width": "47",
  "height": "46",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M18.4 5.5l4.2-4.2c.1-.1.3-.2.4-.3.1-.1.3-.1.4-.1.2 0 .3 0 .4.1.1.1.3.2.4.3l4.2 4.2c.5.5.5 1.3 0 1.8s-1.3.5-1.8 0l-2.1-2.1-.1 6.9c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3l.1-6.8-2.1 2.1c-.5.5-1.3.5-1.8 0-.1-.6-.1-1.4.4-1.9zm-3 15.3c.9 0 1.7.2 2.4.6.8-2.3 3-4 5.6-4 2.6 0 4.8 1.7 5.6 4 .7-.4 1.6-.6 2.4-.6 2.9 0 5.2 2.2 5.5 5.1 3.3 0 5.9 2.6 5.9 5.9H4c0-3.3 2.6-5.9 5.9-5.9.2-2.9 2.6-5.1 5.5-5.1zM2.1 17.1c-.7 0-1.3-.6-1.3-1.3v-6c0-.2 0-.3.1-.5l.3-.3c.1-.1.2-.2.4-.3.2-.1.3-.1.5-.1h6c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3H5.2l4.9 4.8c.5.5.5 1.3 0 1.8s-1.3.5-1.8 0L3.4 13v2.9c0 .6-.6 1.2-1.3 1.2zM40.4 42c-2 2-4.7 3.2-7.7 3.2H14.1c-6.1 0-11-4.9-11-11h40.5c0 3.1-1.2 5.8-3.2 7.8zm5.8-32.1v6c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3V13l-4.9 4.8c-.5.5-1.3.5-1.8 0s-.5-1.3 0-1.8l4.9-4.8h-2.9c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h6c.2 0 .3 0 .5.1.1.1.3.1.4.3.1.1.2.2.2.4.2.2.2.3.2.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumFoodNeg = {
  "id": "icon--wfp-hum--food-neg",
  "name": "icon--wfp-hum--food-neg",
  "tags": "icon--wfp-hum--food-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM14.9 21.9c.2-2.8 2.6-5.1 5.5-5.1.9 0 1.7.2 2.4.6.8-2.3 3-4 5.6-4 2.6 0 4.8 1.7 5.6 4 .7-.4 1.6-.6 2.4-.6 2.9 0 5.2 2.2 5.5 5.1 3.3 0 5.9 2.6 5.9 5.9H9c0-3.2 2.6-5.9 5.9-5.9zm30.5 16.2c-2 2-4.7 3.2-7.7 3.2H19.1c-6.1 0-11-4.9-11-11h40.5c0 3.1-1.2 5.8-3.2 7.8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumFoodPos = {
  "id": "icon--wfp-hum--food-pos",
  "name": "icon--wfp-hum--food-pos",
  "tags": "icon--wfp-hum--food-pos",
  "styles": "",
  "viewBox": "0 0 41 29",
  "width": "41",
  "height": "29",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6.9 8.9c.2-2.8 2.6-5.1 5.5-5.1.9 0 1.7.2 2.4.6.8-2.3 3-4 5.6-4 2.6 0 4.8 1.7 5.6 4 .7-.4 1.6-.6 2.4-.6 2.9 0 5.2 2.2 5.5 5.1 3.3 0 5.9 2.6 5.9 5.9H1c0-3.2 2.6-5.9 5.9-5.9zm30.5 16.2c-2 2-4.7 3.2-7.7 3.2H11.1c-6.1 0-11-4.9-11-11h40.5c0 3.1-1.2 5.8-3.2 7.8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumFoodSecurityClusterNeg = {
  "id": "icon--wfp-hum--food-security-cluster-neg",
  "name": "icon--wfp-hum--food-security-cluster-neg",
  "tags": "icon--wfp-hum--food-security-cluster-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM41.8 24.5l4.2 1.1c.6.2 1 .8.8 1.5-.2.6-.8 1-1.5.8l-4.2-1.1.7-2.3zm-6.6-6.1l.1-.6 2.1.6c2.2.6 3.6 2.9 3 5.2l-.1.6-2.1-.6c-2.3-.6-3.6-3-3-5.2zm2.3 7.5l2.1.6-.1.5c-.6 2.2-2.9 3.6-5.2 3l-2.1-.6.1-.6c.7-2.2 3-3.5 5.2-2.9zm-9.3-9.4l.1-.6 2.1.6c2.2.6 3.6 2.9 3 5.2l-.1.6-2.1-.6c-2.2-.6-3.6-2.9-3-5.2zm2.4 7.5l2.1.6-.1.6c-.6 2.2-2.9 3.6-5.2 3l-2.1-.6.1-.6c.6-2.3 3-3.6 5.2-3zm-10.2 2.3l-2.1-.6.1-.6c.6-2.2 2.9-3.6 5.2-3l2.1.6-.1.6c-.6 2.2-2.9 3.6-5.2 3zm.9-11.6l.1-.6 2.1.6c2.2.6 3.6 2.9 3 5.2l-.1.6-2.1-.6c-2.3-.7-3.6-3-3-5.2zm-7.1-1.3c.2-.6.8-1 1.5-.8l3.1.8c.6.2 1 .8.8 1.5-.2.6-.8 1-1.5.8l-3.1-.8c-.6-.2-1-.8-.8-1.5zm-4.3 3.8c.2-.6.8-1 1.5-.8l8.5 2.3c.6.2 1 .8.8 1.5-.2.6-.8 1-1.5.8l-8.5-2.3c-.6-.2-1-.8-.8-1.5zm7.2 6.9c-.2.6-.8 1-1.5.8l-3.1-.8c-.6-.2-1-.8-.8-1.5.2-.6.8-1 1.5-.8l3.1.8c.6.2 1 .9.8 1.5zm20.6 19.5H19.1c-6.1 0-11-4.9-11-11 0-.5.4-.8.8-.8h38.8c.5 0 .8.4.8.8.1 6.1-4.8 11-10.8 11z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumFoodSecurityClusterPos = {
  "id": "icon--wfp-hum--food-security-cluster-pos",
  "name": "icon--wfp-hum--food-security-cluster-pos",
  "tags": "icon--wfp-hum--food-security-cluster-pos",
  "styles": "",
  "viewBox": "0 0 41 32",
  "width": "41",
  "height": "32",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M33.8 12.5l4.2 1.1c.6.2 1 .8.8 1.5-.2.6-.8 1-1.5.8l-4.2-1.1.7-2.3zm-6.6-6.1l.1-.6 2.1.6c2.2.6 3.6 2.9 3 5.2l-.1.6-2.1-.6c-2.3-.6-3.6-3-3-5.2zm2.3 7.5l2.1.6-.1.5c-.6 2.2-2.9 3.6-5.2 3l-2.1-.6.1-.6c.7-2.2 3-3.5 5.2-2.9zm-9.3-9.4l.1-.6 2.1.6c2.2.6 3.6 2.9 3 5.2l-.1.6-2.1-.6c-2.2-.6-3.6-2.9-3-5.2zm2.4 7.5l2.1.6-.1.6c-.6 2.2-2.9 3.6-5.2 3l-2.1-.6.1-.6c.6-2.3 3-3.6 5.2-3zm-10.2 2.3l-2.1-.6.1-.6c.6-2.2 2.9-3.6 5.2-3l2.1.6-.1.6c-.6 2.2-2.9 3.6-5.2 3zm.9-11.6l.1-.6 2.1.6c2.2.6 3.6 2.9 3 5.2l-.1.6-2.1-.6c-2.3-.7-3.6-3-3-5.2zM6.2 1.4c.2-.6.8-1 1.5-.8l3.1.8c.6.2 1 .8.8 1.5-.2.6-.8 1-1.5.8L7 2.9c-.6-.2-1-.8-.8-1.5zM1.9 5.2c.2-.6.8-1 1.5-.8l8.5 2.3c.6.2 1 .8.8 1.5-.2.6-.8 1-1.5.8L2.7 6.7c-.6-.2-1-.8-.8-1.5zm7.2 6.9c-.2.6-.8 1-1.5.8l-3.1-.8c-.6-.2-1-.8-.8-1.5.2-.6.8-1 1.5-.8l3.1.8c.6.2 1 .9.8 1.5zm20.6 19.5H11.1c-6.1 0-11-4.9-11-11 0-.5.4-.8.8-.8h38.8c.5 0 .8.4.8.8.1 6.1-4.8 11-10.8 11z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumGenderNeg = {
  "id": "icon--wfp-hum--gender-neg",
  "name": "icon--wfp-hum--gender-neg",
  "tags": "icon--wfp-hum--gender-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M28.5 13.8c-5.9 0-10.7 4.8-10.7 10.7 0 2.8 1.1 5.4 2.9 7.3 1.2 1.3 2.6 2.2 4.3 2.8.5.2.9.3 1.4.4.7.1 1.4.2 2.1.2.7 0 1.4-.1 2.1-.2.5-.1 1-.2 1.4-.4 1.7-.6 3.1-1.6 4.3-2.8 1.8-1.9 2.9-4.5 2.9-7.3 0-5.9-4.8-10.7-10.7-10.7zm4.3 14.6h-8.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h8.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm0-5.2h-8.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h8.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
    }, {
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-6.1 13.7c0 .4-.2.8-.4 1-.3.3-.6.4-1 .4-.8 0-1.4-.6-1.4-1.4v-2.6l-5.2 5.3c1.6 2.3 2.5 5.1 2.5 8.1 0 7.4-5.6 13.4-12.8 14.1v3.6h2.9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H30v3.2c0 .4-.2.7-.4 1-.3.3-.6.4-1 .4-.8 0-1.4-.6-1.4-1.4v-3.2h-2.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h2.9v-3.6c-7.2-.7-12.8-6.7-12.8-14.1 0-7.9 6.4-14.3 14.3-14.3 3.8 0 7.3 1.5 9.8 4l5.1-5.1H41c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4h6c.8 0 1.4.6 1.4 1.4v6h-.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumGenderPos = {
  "id": "icon--wfp-hum--gender-pos",
  "name": "icon--wfp-hum--gender-pos",
  "tags": "icon--wfp-hum--gender-pos",
  "styles": "",
  "viewBox": "0 0 35 44",
  "width": "35",
  "height": "44",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M18.8 14.2h-8.6c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h8.6c.8 0 1.5-.7 1.5-1.5 0-.9-.7-1.5-1.5-1.5zm0 5.1h-8.6c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h8.6c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5z"
    }, {
      "fill-rule": "nonzero",
      "d": "M32.9.2h-6c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4h2.6l-5.1 5.1c-2.6-2.4-6-4-9.8-4C6.7 4.1.3 10.5.3 18.4c0 7.4 5.6 13.4 12.8 14.1v3.6h-2.9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h2.9v3.2c0 .8.6 1.4 1.4 1.4.4 0 .7-.2 1-.4.3-.3.4-.6.4-1v-3.2h2.9c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5H16v-3.6c7.2-.7 12.8-6.7 12.8-14.1 0-3-1-5.8-2.5-8.1L31.5 5v2.6c0 .8.6 1.4 1.4 1.4.4 0 .7-.2 1-.4.3-.3.4-.6.4-1v-6c0-.7-.7-1.4-1.4-1.4zM22.4 25.8c-1.2 1.3-2.6 2.2-4.3 2.8-.5.2-.9.3-1.4.4-.7.1-1.4.2-2.1.2-.7 0-1.4-.1-2.1-.2-.5-.1-1-.2-1.4-.4C9.4 28 8 27 6.8 25.8c-1.8-1.9-2.9-4.5-2.9-7.3 0-5.9 4.8-10.7 10.7-10.7 5.9 0 10.7 4.8 10.7 10.7-.1 2.8-1.2 5.4-2.9 7.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumInfantNeg = {
  "id": "icon--wfp-hum--infant-neg",
  "name": "icon--wfp-hum--infant-neg",
  "tags": "icon--wfp-hum--infant-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-26 7.3c2.5 0 4.6 2.1 4.6 4.6 0 2.5-2.1 4.6-4.6 4.6-2.5 0-4.6-2.1-4.6-4.6 0-2.6 2-4.6 4.6-4.6zm-2.6 40.9c-.7.8-1.9.8-2.7.2-2.4-1.7-3.9-4.5-3.9-7.5 0-3.1 1.5-5.8 3.8-7.4.1-.1.2-.1.3 0l2.6 2.6c.1.1.1.3-.1.4-1.5.9-2.6 2.5-2.6 4.4 0 1.7.8 3.2 2.2 4.2 1.1.7 1.2 2.2.4 3.1zm7.8.3c-.4.2-.8.4-1.2.4-.6 0-1.3-.3-1.7-.9-.6-.9-.4-2.2.5-2.8 1.4-.9 2.2-2.5 2.2-4.2 0-1.9-1-3.5-2.6-4.4-.1-.1-.2-.3-.1-.4l2.6-2.6c.1-.1.2-.1.3 0 2.3 1.7 3.8 4.4 3.8 7.4.2 3-1.3 5.8-3.8 7.5zm5-16.7c-1.1 0-2-.9-2-2 0-2.4-1.3-4.3-3.1-5.6v6.6H23.3v-6.6c-1.8 1.2-3.1 3.1-3.1 5.6 0 1.1-.9 2-2 2s-2-.9-2-2c0-6.2 5.5-11.2 12.2-11.2 6.7 0 12.2 5 12.2 11.2 0 1.1-.9 2-2 2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumInfantPos = {
  "id": "icon--wfp-hum--infant-pos",
  "name": "icon--wfp-hum--infant-pos",
  "tags": "icon--wfp-hum--infant-pos",
  "styles": "",
  "viewBox": "0 0 25 42",
  "width": "25",
  "height": "42",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12.4.3C14.9.3 17 2.4 17 4.9c0 2.5-2.1 4.6-4.6 4.6-2.5 0-4.6-2.1-4.6-4.6 0-2.6 2-4.6 4.6-4.6zM9.8 41.2c-.7.8-1.9.8-2.7.2-2.4-1.7-3.9-4.5-3.9-7.5 0-3.1 1.5-5.8 3.8-7.4.1-.1.2-.1.3 0l2.6 2.6c.1.1.1.3-.1.4-1.5.9-2.6 2.5-2.6 4.4 0 1.7.8 3.2 2.2 4.2 1.1.7 1.2 2.2.4 3.1zm7.8.3c-.4.2-.8.4-1.2.4-.6 0-1.3-.3-1.7-.9-.6-.9-.4-2.2.5-2.8 1.4-.9 2.2-2.5 2.2-4.2 0-1.9-1-3.5-2.6-4.4-.1-.1-.2-.3-.1-.4l2.6-2.6c.1-.1.2-.1.3 0 2.3 1.7 3.8 4.4 3.8 7.4.2 3-1.3 5.8-3.8 7.5zm5-16.7c-1.1 0-2-.9-2-2 0-2.4-1.3-4.3-3.1-5.6v6.6H7.3v-6.6c-1.8 1.2-3.1 3.1-3.1 5.6 0 1.1-.9 2-2 2s-2-.9-2-2c0-6.2 5.5-11.2 12.2-11.2 6.7 0 12.2 5 12.2 11.2 0 1.1-.9 2-2 2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumLogisticsClusterNeg = {
  "id": "icon--wfp-hum--logistics-cluster-neg",
  "name": "icon--wfp-hum--logistics-cluster-neg",
  "tags": "icon--wfp-hum--logistics-cluster-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M35.3 36.9c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4zm11.6-5.6c0-.2 0-.3-.1-.4-.2-.8-.9-1.4-1.8-1.4h-8.3c-.3 0-.5.1-.7.2-.6.3-1.1.9-1.1 1.7v2.8H47v-2.9h-.1zm-.4 5.6c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4 0-.8-.7-1.4-1.4-1.4z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM32.1 24.9v-3.8c0-1 .8-1.9 1.9-1.9h13.9c1 0 1.9.8 1.9 1.9v5.7c-1.2-1.2-2.8-2-4.6-2h-9c-.7.1-1.3.2-1.9.5-.1 0-.1.1-.2.1-.7.3-1.3.8-1.9 1.3v-1.8h-.1zm-1.9 20.3v.2c0 .1-.1.2-.2.3-.1.1-.2.1-.2.2h-.1c-.1 0-.2.1-.3.1h-.3l-5.3-1.7-5.3 1.7h-.4c-.1 0-.2 0-.2-.1h-.1l-.1-.1c-.1 0-.1-.1-.2-.1l-.1-.1c0-.1-.1-.1-.1-.2V45.1c0-.1 0-.1.1-.2v-.2l.1-.1c0-.1.1-.1.1-.2l3.4-2.8V27.4l-12.6 3H8c-.2 0-.4 0-.5-.1-.1 0-.1 0-.2-.1h-.1s-.1 0-.1-.1c-.3-.2-.6-.5-.7-.8 0-.1-.1-.1-.1-.2s0-.1-.1-.2c-.1-.3-.1-.6 0-.9 0-.1 0-.1.1-.2v-.1s0-.1.1-.1c.2-.3.5-.6.9-.8L21 20.4v-7.6c0-1.5 1.2-2.8 2.8-2.8 1.5 0 2.8 1.2 2.8 2.8v7.6l2.8 1.3V28l-2.8-.7v14.3l3.4 2.8.2.2.1.1v.2c0 .1 0 .1.1.2l-.2.1zm20.4-2.8c0 .5-.4.9-.9.9h-.9v1.4c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4v-1.4H35.8v1.4c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4v-1.4h-.9c-.5 0-.9-.4-.9-.9V35c0-.5.4-.9.9-.9v-2.8c0-.9.3-1.7.7-2.5.2-.4.5-.7.9-1 .1-.1.2-.2.3-.2.8-.6 1.7-.9 2.8-.9h8.3c2.6 0 4.6 2.1 4.6 4.6v2.8c.5 0 .9.4.9.9v7.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumLogisticsClusterPos = {
  "id": "icon--wfp-hum--logistics-cluster-pos",
  "name": "icon--wfp-hum--logistics-cluster-pos",
  "tags": "icon--wfp-hum--logistics-cluster-pos",
  "styles": "",
  "viewBox": "0 0 45 37",
  "width": "45",
  "height": "37",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M28.1 15.4c.6-.3 1.2-.4 1.9-.5h9c1.8 0 3.5.8 4.6 2v-5.7c0-1-.8-1.9-1.9-1.9H27.9c-1 0-1.9.8-1.9 1.9v5.6c.5-.5 1.2-1 1.9-1.3.1-.1.2-.1.2-.1zm-4 19.4c0-.1 0-.1 0 0-.1-.2-.2-.2-.2-.3l-3.4-2.8V17.4l2.8.7v-6.4l-2.8-1.3V2.8c0-1.5-1.2-2.8-2.8-2.8-1.5 0-2.8 1.2-2.8 2.8v7.6L1.3 16.8c-.4.2-.7.4-.9.8l-.1.1v.1s0 .1-.1.2c-.1.3-.1.6 0 .9 0 .1 0 .1.1.2 0 .1 0 .1.1.2.2.4.4.6.7.8l.1.1h.1s.1 0 .2.1c.2.1.4.1.5.1h.4l12.6-3v14.3l-3.4 2.8c-.1.1-.1.1-.1.2l-.1.1v.2c0 .1 0 .1-.1.2v.3c0 .1.1.1.1.2 0 0 0 .1.1.1 0 .1.1.1.2.1l.1.1h.1c.1 0 .2.1.2.1h.4l5.3-1.7 5.3 1.7h.3c.1 0 .2 0 .3-.1h.1c.1 0 .2-.1.2-.2.1-.1.1-.2.2-.3V35.2c0-.1 0-.1-.1-.2.1-.1.1-.2 0-.2z"
    }, {
      "fill-rule": "nonzero",
      "d": "M43.7 24.1v-2.8c0-2.6-2.1-4.6-4.6-4.6h-8.3c-1 0-2 .3-2.8.9-.1.1-.2.1-.3.2-.3.3-.6.6-.9 1-.4.7-.7 1.6-.7 2.5v2.8c-.5 0-.9.4-.9.9v7.4c0 .5.4.9.9.9h.9v1.4c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-1.4H40v1.4c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-1.4h.9c.5 0 .9-.4.9-.9V25c0-.5-.4-.9-.9-.9zm-14.8-2.8c0-.8.5-1.4 1.1-1.7.2-.1.5-.2.7-.2H39c.9 0 1.6.6 1.8 1.4 0 .1.1.3.1.4V24h-12v-2.7zm.4 8.4c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .7-.6 1.4-1.4 1.4zm11.2 0c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .7-.7 1.4-1.4 1.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumMedicalEvacuationsNeg = {
  "id": "icon--wfp-hum--medical-evacuations-neg",
  "name": "icon--wfp-hum--medical-evacuations-neg",
  "tags": "icon--wfp-hum--medical-evacuations-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM28.1 48.8c-.2.4-.6.7-1 .9-.4.1-.9.1-1.3-.1-.9-.4-1.2-1.5-.8-2.4 2.1-4.1.6-9.2-3.5-11.4l-3.8-1.9-7.6 14.9c-.3.6-.9 1-1.6 1-.3 0-.5-.1-.8-.2-.8-.5-1.2-1.6-.7-2.4l12.5-24.6c-3.4-.4-6.9 1.3-8.6 4.5-.4.9-1.5 1.2-2.3.8-.9-.4-1.2-1.5-.8-2.3 2.9-5.7 9.7-8 15.4-5.5.1 0 .2.1.4.1l2.2 1.1c2 1 2.8 3.5 1.8 5.5l-3.3 6.6c4.9 3.3 6.7 9.9 3.8 15.4zm1.7-28.7c-1.8.6-3.7-.4-4.3-2.1-.6-1.8.4-3.7 2.1-4.3 1.8-.6 3.7.4 4.3 2.1.6 1.8-.4 3.7-2.1 4.3zm4 18.7c-.3 0-.7-.1-.9-.4-.5-.5-.5-1.3 0-1.9l3.7-3.7 1.2-1.3-1.2-1.3-3.7-3.7c-.5-.5-.5-1.3 0-1.9.5-.5 1.3-.5 1.9 0l5.9 5.9c.2.2.4.6.4.9 0 .3-.1.7-.4.9l-5.9 5.9c-.3.4-.6.6-1 .6zm13.1-6.3L41 38.4c-.3.3-.6.4-.9.4-.3 0-.7-.1-.9-.4-.5-.5-.5-1.3 0-1.9l3.7-3.7 1.2-1.3-1.2-1.3-3.7-3.7c-.5-.5-.5-1.3 0-1.9.5-.5 1.3-.5 1.9 0l5.9 5.9c.2.2.4.6.4.9-.1.5-.3.9-.5 1.1zm-1.5-12.8c-4.7 0-8.5-3.8-8.5-8.5s3.8-8.5 8.5-8.5 8.5 3.8 8.5 8.5-3.8 8.5-8.5 8.5z"
    }, {
      "d": "M45.4 5c-3.4 0-6.2 2.8-6.2 6.2 0 3.4 2.8 6.2 6.2 6.2 3.4 0 6.2-2.8 6.2-6.2 0-3.4-2.8-6.2-6.2-6.2zm3 7.5h-1.7v1.7c0 .3-.1.7-.4.9-.2.2-.5.4-.9.4-.7 0-1.3-.6-1.3-1.3v-1.7h-1.7c-.3 0-.7-.1-.9-.4-.2-.2-.4-.5-.4-.9 0-.7.6-1.3 1.3-1.3h1.7V8.3c0-.3.1-.7.4-.9.3-.2.6-.4.9-.4.7 0 1.3.6 1.3 1.3V10h1.7c.3 0 .7.1.9.4.2.2.4.5.4.9-.1.6-.6 1.2-1.3 1.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumMedicalEvacuationsPos = {
  "id": "icon--wfp-hum--medical-evacuations-pos",
  "name": "icon--wfp-hum--medical-evacuations-pos",
  "tags": "icon--wfp-hum--medical-evacuations-pos",
  "styles": "",
  "viewBox": "0 0 48 48",
  "width": "48",
  "height": "48",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M35 29.6c0-.3-.1-.7-.4-.9l-5.9-5.9c-.5-.5-1.3-.5-1.9 0-.5.5-.5 1.3 0 1.9l3.7 3.7 1.2 1.3-1.2 1.3-3.7 3.7c-.5.5-.5 1.3 0 1.9.3.3.6.4.9.4.3 0 .7-.1.9-.4l5.9-5.9c.4-.4.5-.8.5-1.1zM21.7 11.7c-1.8.6-2.7 2.5-2.1 4.3.6 1.8 2.5 2.7 4.3 2.1 1.8-.6 2.7-2.5 2.1-4.3-.7-1.8-2.6-2.7-4.3-2.1z"
    }, {
      "d": "M35 22.8c-.5-.5-1.3-.5-1.9 0-.5.5-.5 1.3 0 1.9l3.7 3.7 1.2 1.3-1.2 1.3-3.7 3.7c-.5.5-.5 1.3 0 1.9.3.3.6.4.9.4.3 0 .7-.1.9-.4l5.9-5.9c.2-.2.4-.6.4-.9 0-.3-.1-.7-.4-.9L35 22.8zm-16.7 8.5l3.3-6.6c1-2 .2-4.5-1.8-5.5l-2.2-1.1c-.1-.1-.2-.1-.4-.1-5.7-2.5-12.5-.2-15.4 5.5-.4.9-.1 1.9.8 2.3.9.4 1.9.1 2.3-.8 1.7-3.3 5.2-5 8.6-4.5L1 45.2c-.4.9-.1 1.9.8 2.4.3.1.5.2.8.2.6 0 1.3-.4 1.6-1l7.6-14.9 3.8 1.9c4.1 2.2 5.6 7.3 3.5 11.4-.4.9-.1 1.9.8 2.4.4.2.9.3 1.3.1.4-.1.8-.4 1-.9 2.8-5.5 1-12.1-3.9-15.5zM42.4 8h-1.7V6.3c0-.7-.6-1.3-1.3-1.3-.3 0-.7.1-.9.4-.2.2-.4.5-.4.9V8h-1.7c-.7 0-1.3.6-1.3 1.3 0 .3.1.7.4.9.2.2.5.4.9.4h1.7v1.7c0 .7.6 1.3 1.3 1.3.3 0 .7-.1.9-.4.2-.2.4-.5.4-.9v-1.7h1.7c.7 0 1.3-.6 1.3-1.3 0-.3-.1-.7-.4-.9-.3-.3-.6-.4-.9-.4z"
    }, {
      "fill-rule": "nonzero",
      "d": "M39.4.8c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5S44.1.8 39.4.8zm0 14.6c-3.4 0-6.2-2.8-6.2-6.2C33.2 5.8 36 3 39.4 3c3.4 0 6.2 2.8 6.2 6.2 0 3.5-2.8 6.2-6.2 6.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumMonitorinNeg = {
  "id": "icon--wfp-hum--monitorin-neg",
  "name": "icon--wfp-hum--monitorin-neg",
  "tags": "icon--wfp-hum--monitorin-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M31.4 13.9c-6.6 0-12 5.4-12 12 0 3.1 1.2 6 3.2 8.2 1.3 1.4 2.9 2.5 4.8 3.2.5.2 1 .3 1.6.4.8.2 1.6.2 2.4.2.8 0 1.6-.1 2.4-.2.6-.1 1.1-.3 1.6-.4 1.9-.6 3.5-1.8 4.8-3.2 2-2.1 3.2-5 3.2-8.2.1-6.6-5.3-12-12-12zM40.6 27l-4.8 4.8c-.3.3-.7.5-1.1.5-.4 0-.8-.2-1.1-.5-.6-.6-.6-1.6 0-2.3l2.1-2.1H23.4c-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6h12.2l-2.1-2.1c-.6-.6-.6-1.6 0-2.3.6-.6 1.6-.6 2.3 0l4.8 4.8c.6.8.6 1.8 0 2.4z"
    }, {
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM14.8 47.4a3.32 3.32 0 01-4.7 0 3.32 3.32 0 010-4.7l5.8-5.8c1.3 1.8 2.9 3.4 4.7 4.7l-5.8 5.8zm16.8-5.5c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumMonitoringPos = {
  "id": "icon--wfp-hum--monitoring-pos",
  "name": "icon--wfp-hum--monitoring-pos",
  "tags": "icon--wfp-hum--monitoring-pos",
  "styles": "",
  "viewBox": "0 0 39 40",
  "width": "39",
  "height": "40",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M31.6 15.8L26.8 11c-.6-.6-1.6-.6-2.3 0-.6.6-.6 1.6 0 2.3l2.1 2.1H14.4c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6h12.2l-2.1 2.1c-.6.6-.6 1.6 0 2.3.3.3.7.5 1.1.5.4 0 .8-.2 1.1-.5l4.8-4.8c.7-.8.7-1.8.1-2.4zM6.9 28l-5.8 5.8a3.32 3.32 0 000 4.7c1.3 1.3 3.4 1.3 4.7 0l5.8-5.8c-1.9-1.4-3.5-2.9-4.7-4.7z"
    }, {
      "fill-rule": "nonzero",
      "d": "M22.6.9c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm8.7 24.2c-1.3 1.4-2.9 2.5-4.8 3.2-.5.2-1 .3-1.6.4-.8.2-1.6.2-2.4.2-.8 0-1.6-.1-2.4-.2-.6-.1-1.1-.3-1.6-.4-1.9-.6-3.5-1.8-4.8-3.2-2-2.1-3.2-5-3.2-8.2 0-6.6 5.4-12 12-12s12 5.4 12 12c0 3.1-1.3 6-3.2 8.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumMonsoonNeg = {
  "id": "icon--wfp-hum--monsoon-neg",
  "name": "icon--wfp-hum--monsoon-neg",
  "tags": "icon--wfp-hum--monsoon-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M33.8 10.8H30v.7c0 .3-.1.5-.2.6-.2.2-.4.2-.6.2-.2 0-.5-.1-.6-.2-.2-.2-.2-.4-.2-.6v-.7H23v.7c0 .3-.1.5-.2.6-.2.2-.4.2-.6.2-.3 0-.5-.1-.6-.2-.2-.2-.2-.4-.2-.6v-.7H16v.7c0 .3-.1.5-.2.6-.2.2-.4.2-.6.2-.2 0-.5-.1-.6-.2-.2-.2-.2-.4-.2-.6v-.7h-3.8c-.2 0-.3.1-.4.2-.1.1-.2.3-.2.4v20.7c0 .2.1.3.2.4.1.1.3.2.4.2H16c.5-.4 1.2-.6 1.9-.6h.5c0-.3-.1-.5-.1-.8 0-1.8 1-3.3 2.5-4.1.2-.5.8-.9 1.4-.9.4 0 .8.2 1.1.5.4 0 .8.1 1.2.2.1-4.8 4-8.8 8.9-8.8.4 0 .7.1 1.1.1v-7c0-.2-.1-.3-.2-.4-.2-.1-.4-.1-.5-.1zM15.7 29.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c.1.8-.6 1.5-1.5 1.5zm0-5.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c.1.8-.6 1.5-1.5 1.5zm0-5.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c.1.8-.6 1.5-1.5 1.5zm6.5 5.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5S23 24 22.2 24zm0-5.4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm6.2 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c.1.8-.6 1.5-1.5 1.5z"
    }, {
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM24.1 44.5l-4.2 4.2c-.3.3-.6.4-1 .4-1.2 0-1.8-1.5-1-2.3l4.2-4.2c.3-.3.6-.4 1-.4 1.2 0 1.8 1.4 1 2.3zm10 0l-4.2 4.2c-.3.3-.6.4-1 .4-1.2 0-1.8-1.5-1-2.3l4.2-4.2c.3-.3.6-.4 1-.4 1.2 0 1.9 1.4 1 2.3zm10 0l-4.2 4.2c-.3.3-.6.4-1 .4-1.2 0-1.8-1.5-1-2.3l4.2-4.2c.3-.3.6-.4 1-.4 1.3 0 1.9 1.4 1 2.3zm7.2-11c-.6 3.2-3.4 5.6-6.8 5.6H17.9c-1.9 0-3.5-1.6-3.5-3.5 0-.4.1-.8.2-1.1h-4.2c-.7 0-1.2-.2-1.7-.7-.5-.5-.7-1-.7-1.7V11.4c0-.7.2-1.2.7-1.7.5-.4 1.1-.7 1.7-.7h3.8V7.3c0-.3.1-.5.2-.6.2-.2.4-.2.6-.2.2 0 .5.1.6.2.3.1.4.3.4.6V9h5.3V7.3c0-.3.1-.5.2-.6.2-.2.4-.2.6-.2.3 0 .5.1.6.2.2.1.3.3.3.6V9h5.3V7.3c0-.3.1-.5.2-.6.1-.1.4-.2.6-.2.3 0 .5.1.6.2.1.1.3.3.3.6V9h3.8c.7 0 1.2.2 1.7.7.5.5.7 1 .7 1.7v7.3c3.1 1 5.4 3.7 5.9 6.9.8-.3 1.6-.4 2.4-.4 3.8 0 6.9 3.1 6.9 6.9.1.5 0 1-.1 1.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumMonsoonPos = {
  "id": "icon--wfp-hum--monsoon-pos",
  "name": "icon--wfp-hum--monsoon-pos",
  "tags": "icon--wfp-hum--monsoon-pos",
  "styles": "",
  "viewBox": "0 0 44 44",
  "width": "44",
  "height": "44",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.7 14.9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5c.1-.8-.6-1.5-1.5-1.5zm27.5 21.3c-.4 0-.7.1-1 .4L30 40.8c-.9.9-.3 2.3 1 2.3.4 0 .7-.1 1-.4l4.2-4.2c.8-.9.2-2.3-1-2.3zm-20.1 0c-.4 0-.7.1-1 .4l-4.2 4.2c-.9.9-.3 2.3 1 2.3.4 0 .7-.1 1-.4l4.2-4.2c.8-.9.2-2.3-1-2.3zm10 0c-.4 0-.7.1-1 .4l-4.2 4.2c-.9.9-.3 2.3 1 2.3.4 0 .7-.1 1-.4l4.2-4.2c.9-.9.2-2.3-1-2.3z"
    }, {
      "fill-rule": "nonzero",
      "d": "M36.5 19.2c-.9 0-1.7.2-2.4.4-.5-3.3-2.9-5.9-5.9-6.9V5.4c0-.7-.2-1.2-.7-1.7-.5-.4-1.1-.7-1.7-.7H22V1.3c0-.3-.1-.5-.2-.6-.1-.1-.4-.2-.6-.2-.3 0-.5.1-.6.2-.1.1-.4.3-.4.6V3H15V1.3c0-.3-.1-.5-.2-.6-.2-.2-.4-.2-.6-.2-.3 0-.5.1-.6.2-.2.2-.2.4-.2.6V3H8V1.3C8 1 7.9.8 7.8.7 7.6.5 7.4.5 7.2.5c-.2 0-.5.1-.6.2-.2.2-.2.4-.2.6V3H2.6c-.8 0-1.4.3-1.8.7-.5.5-.7 1-.7 1.7v20.7c0 .7.2 1.2.7 1.7.5.5 1 .7 1.7.7h4.2c-.1.4-.2.7-.2 1.1 0 1.9 1.6 3.5 3.5 3.5h26.6c3.4 0 6.2-2.4 6.8-5.6.1-.4.1-.9.1-1.4 0-3.8-3.2-6.9-7-6.9zm-10.1-8.9v2.1c-.3 0-.7-.1-1.1-.1-4.9 0-8.8 3.9-8.9 8.8-.4-.1-.8-.2-1.2-.2-.3-.3-.7-.5-1.1-.5-.6 0-1.2.4-1.4.9-1.5.8-2.5 2.3-2.5 4.1 0 .3 0 .5.1.8h-.5c-.7 0-1.3.2-1.9.6H2.3c-.2 0-.3-.1-.4-.2-.1-.1-.2-.3-.2-.4V5.4c0-.2.1-.3.2-.4.1-.1.3-.2.4-.2h3.8v.7c0 .3.1.5.2.6.2.2.4.2.6.2.2 0 .5-.1.6-.2.2-.2.2-.4.2-.6v-.7H13v.7c0 .3.1.5.2.6.2.2.4.2.6.2.3 0 .5-.1.6-.2.2-.2.2-.4.2-.6v-.7h5.3v.7c0 .3.1.5.2.6.2.2.4.2.6.2.2 0 .5-.1.6-.2.2-.2.2-.4.2-.6v-.7h3.8c.2 0 .3.1.4.2.1.1.2.3.2.4v4.9h.5z"
    }, {
      "d": "M14.2 14.9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5zM6.2 21.9a1.5 1.5 0 113 0 1.5 1.5 0 11-3 0M12.7 11.1a1.5 1.5 0 113 0 1.5 1.5 0 11-3 0M18.9 11.1a1.5 1.5 0 113 0 1.5 1.5 0 11-3 0M6.2 11.1a1.5 1.5 0 113 0 1.5 1.5 0 11-3 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumMvamNeg = {
  "id": "icon--wfp-hum--mvam-neg",
  "name": "icon--wfp-hum--mvam-neg",
  "tags": "icon--wfp-hum--mvam-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M32.8 29.3h2.5L34 25.5z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM18.2 33.2h-2.5v-4.9c0-.3-.1-.5-.1-.6-.1-.2-.2-.3-.4-.4-.2-.1-.4-.1-.7-.1-.2 0-.4 0-.6.1-.2.1-.4.2-.7.4v5.5h-2.5v-4.9c0-.3-.1-.5-.2-.6-.1-.2-.2-.3-.4-.4-.2-.1-.4-.1-.7-.1-.2 0-.5 0-.7.1l-.6.3v5.5H5.5v-7.8H8v.9c.4-.3.8-.6 1.2-.8.4-.2.8-.3 1.3-.3s1 .1 1.4.3c.4.2.7.6.9 1 .5-.4 1-.8 1.5-1 .5-.2.9-.4 1.4-.4.8 0 1.5.3 1.9.8.4.5.7 1.2.7 2.2v5.2h-.1zm4.5 0l-3.8-10.3h2.8l2.5 7.3 2.5-7.3h2.7l-3.8 10.3h-2.9zm14 0l-.7-2h-3.8l-.7 2.1h-2.7L32.6 23h3.1l3.8 10.3h-2.8v-.1zm14.6 0h-2.7v-6.9l-1.9 4.5h-1.8L43 26.3v6.9h-2.5V22.9h3.1l2.3 5.2 2.3-5.2h3.1v10.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumMvamPos = {
  "id": "icon--wfp-hum--mvam-pos",
  "name": "icon--wfp-hum--mvam-pos",
  "tags": "icon--wfp-hum--mvam-pos",
  "styles": "",
  "viewBox": "0 0 47 12",
  "width": "47",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M43.2.9l-2.4 5.2L38.5.9h-3.1v10.3h2.5V4.3l2 4.5h1.8l1.9-4.5v6.9h2.7V.9zM21.7.9l-2.5 7.3L16.7.9h-2.8l3.8 10.3h3L24.4.9zm-11 2.3c-.5 0-.9.1-1.4.4-.5.2-1 .6-1.5 1-.2-.4-.5-.8-.9-1-.4-.2-.8-.3-1.4-.3-.5 0-.9.1-1.3.3-.4.1-.8.4-1.2.7v-.9H.5v7.8H3V5.7l.6-.3c.2-.1.5-.1.7-.1.3 0 .5 0 .7.1.2.1.3.2.4.4.1.2.1.4.2.6v4.9h2.5V5.8c.3-.2.5-.3.7-.4.2-.1.4-.1.6-.1.3 0 .6 0 .7.1.2.1.3.2.4.4.1.2.1.4.1.6v4.9h2.5V6.2c0-1-.2-1.7-.7-2.2-.2-.5-.9-.8-1.7-.8z"
    }, {
      "fill-rule": "nonzero",
      "d": "M27.5.9l-3.8 10.3h2.7l.7-2.1H31l.7 2.1h2.8L30.7.9h-3.2zm.3 6.4l1.3-3.7 1.3 3.7h-2.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumNutritionClusterNeg = {
  "id": "icon--wfp-hum--nutrition-cluster-neg",
  "name": "icon--wfp-hum--nutrition-cluster-neg",
  "tags": "icon--wfp-hum--nutrition-cluster-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M35.7 26.3c-.9.9-2.5.9-3.4 0-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4.8.8 1.9 1.2 3.1 1.2 1.2 0 2.3-.4 3.1-1.2.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0zm-11.8 0c-.9.9-2.5.9-3.4 0-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4.8.8 1.9 1.2 3.1 1.2 1.2 0 2.3-.4 3.1-1.2.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM9.8 38.2c-.8 0-1.3-.5-1.3-1.3s.5-1.3 1.3-1.3h23.7c.1 0 .3.1.3.2-.1 2.8-2 4.8-5.1 4.8-2.1 0-3.2-1-4.2-2.5H9.8v.1zm33.1-7.7c-.4.4-1 .7-1.5.9v1.7c0 4.3-5.7 11.8-12.6 11.8-3.8 0-7.3-2.3-9.6-5.1h4.5c1 1.3 2.5 2.5 5.1 2.5 3.9 0 6.6-2.6 6.7-6.4 0-.5-.2-1-.5-1.4-.4-.4-.9-.6-1.4-.6H16.2c0-.3-.1-.6-.1-.8v-1.7c-.6-.2-1.1-.5-1.5-.9-.6-.6-1-1.5-1-2.5s.4-1.8 1-2.5c.4-.4 1-.7 1.5-.9V23c0-5.8 4.5-10.7 10.5-11.6-.3.5-.4 1.1-.4 1.7 0 2.2 1.9 4 4.2 4 .5 0 .8-.4.8-.8 0-.5-.4-.8-.8-.8-1.3 0-2.5-1.1-2.5-2.3 0-.8.4-1.5 1-1.9 3.4 0 6.6 1.3 8.8 3.5 2.3 2.1 3.7 5.1 3.7 8.3v1.7c.6.2 1.1.5 1.5.9.6.6 1 1.5 1 2.5 0 .8-.3 1.7-1 2.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumNutritionClusterPos = {
  "id": "icon--wfp-hum--nutrition-cluster-pos",
  "name": "icon--wfp-hum--nutrition-cluster-pos",
  "tags": "icon--wfp-hum--nutrition-cluster-pos",
  "styles": "",
  "viewBox": "0 0 36 34",
  "width": "36",
  "height": "34",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M20.8 29.7c3.1 0 4.9-2 5.1-4.8 0-.1-.1-.2-.3-.2H1.8C1 24.7.5 25.2.5 26c0 .7.5 1.3 1.3 1.3h14.7c1 1.5 2.1 2.4 4.3 2.4z"
    }, {
      "fill-rule": "nonzero",
      "d": "M34.9 14.6c-.4-.4-1-.7-1.5-.9V12c0-3.3-1.4-6.2-3.7-8.3C27.4 1.6 24.3.3 20.9.2c-.6.4-1 1.1-1 1.9 0 1.2 1.2 2.3 2.5 2.3.5 0 .8.4.8.8 0 .5-.4.8-.8.8-2.3 0-4.2-1.8-4.2-4 0-.6.1-1.2.4-1.7-6 .9-10.5 5.8-10.5 11.6v1.7c-.6.2-1.1.5-1.5.9-.6.6-1 1.5-1 2.5s.4 1.8 1 2.5c.4.4 1 .7 1.5.9v1.7c0 .3 0 .5.1.8h17.4c.5 0 1 .2 1.4.6.4.4.5.9.5 1.4-.2 3.8-2.9 6.4-6.7 6.4-2.6 0-4.1-1.2-5.1-2.5h-4.5c2.3 2.8 5.8 5.1 9.6 5.1 7 0 12.6-7.5 12.6-11.8v-1.7c.6-.2 1.1-.5 1.5-.9.6-.6 1-1.5 1-2.5s-.3-1.8-1-2.4zm-17.6 2.1c-.8.8-1.9 1.2-3.1 1.2-1.2 0-2.3-.4-3.1-1.2-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0 .9.9 2.5.9 3.4 0 .4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4zm11.8 0c-.8.8-1.9 1.2-3.1 1.2-1.2 0-2.3-.4-3.1-1.2-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0 .9.9 2.5.9 3.4 0 .4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumP4pNeg = {
  "id": "icon--wfp-hum--p4p-neg",
  "name": "icon--wfp-hum--p4p-neg",
  "tags": "icon--wfp-hum--p4p-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M43.1 23.8c-.4-.2-.8-.2-1.1-.3h-2.1v4.4H41c.6 0 1.2 0 1.6-.1.4-.1.8-.2 1-.5.2-.2.4-.5.5-.7.1-.3.2-.6.2-1.1 0-.4-.1-.8-.3-1.1-.4-.3-.7-.5-.9-.6zm-14.5 5.5V24l-4.2 5.3z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-34 27.3c-.2.6-.6 1.1-1 1.6-.6.6-1.2 1-1.9 1.3-.7.3-1.6.4-2.7.4h-2.3v4.7H8.7V20.8h6.2c.9 0 1.7.1 2.3.2.6.2 1.2.4 1.7.7.6.4 1 .9 1.3 1.5.3.6.5 1.3.5 2.2 0 .6-.1 1.3-.3 1.9zM34.2 32h-2v3.4h-3.6V32h-7.1v-2.8l6.8-8.4h3.8v8.5h2V32h.1zm13.5-4.7c-.2.6-.6 1.1-1 1.6-.6.6-1.2 1-1.9 1.3-.7.3-1.6.4-2.7.4h-2.3v4.7H36V20.8h6.2c.9 0 1.7.1 2.3.2.6.2 1.2.4 1.7.7.6.4 1 .9 1.3 1.5.3.6.5 1.3.5 2.2 0 .6-.1 1.3-.3 1.9z"
    }, {
      "d": "M15.7 23.8c-.4-.2-.8-.2-1.1-.3h-2.1v4.4h1.1c.6 0 1.2 0 1.6-.1.4-.1.8-.2 1-.5.2-.2.4-.5.5-.7.1-.3.2-.6.2-1.1 0-.4-.1-.8-.3-1.1-.3-.3-.6-.5-.9-.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumP4pPos = {
  "id": "icon--wfp-hum--p4p-pos",
  "name": "icon--wfp-hum--p4p-pos",
  "tags": "icon--wfp-hum--p4p-pos",
  "styles": "",
  "viewBox": "0 0 40 16",
  "width": "40",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10.9 1.7c-.5-.3-1.1-.6-1.7-.7C8.6.8 7.8.8 6.9.8H.7v14.6h3.8v-4.7h2.3c1.1 0 1.9-.1 2.7-.4.7-.3 1.4-.7 1.9-1.3.4-.4.7-.9 1-1.6.2-.6.3-1.3.3-1.9 0-.8-.2-1.6-.5-2.2-.2-.7-.7-1.2-1.3-1.6zM8.7 6.5c-.1.3-.3.5-.5.7-.3.2-.6.4-1 .5-.4.1-.9.1-1.6.1H4.5V3.4h2.1c.4 0 .8.1 1.1.3.3.1.5.3.8.6.2.3.3.6.3 1.1.1.5 0 .8-.1 1.1zM24.2.8h-3.8l-6.8 8.4V12h7.1v3.4h3.6V12h2V9.3h-2V.8h-.1zm-3.6 8.5h-4.2L20.6 4v5.3zm19-6.1c-.3-.6-.8-1.1-1.3-1.5-.5-.3-1.1-.6-1.7-.7-.6-.2-1.4-.2-2.3-.2H28v14.6h3.8v-4.7h2.3c1.1 0 2-.1 2.7-.4.7-.3 1.4-.7 1.9-1.3.4-.4.8-.9 1-1.6.2-.6.3-1.3.3-1.9 0-1-.1-1.7-.4-2.3zM36 6.5c-.1.3-.3.5-.5.7-.3.2-.6.4-1 .5-.4.1-.9.1-1.6.1h-1.1V3.4h2.1c.4 0 .8.1 1.1.3.3.1.6.3.8.6.2.3.3.6.3 1.1.1.5 0 .8-.1 1.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPartnershipNeg = {
  "id": "icon--wfp-hum--partnership-neg",
  "name": "icon--wfp-hum--partnership-neg",
  "tags": "icon--wfp-hum--partnership-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM14.6 34.3c-.4 0-.8-.2-1.1-.5-.6-.6-.6-1.6 0-2.2l1.7-1.7 2.1-2.1c.3-.3.7-.4 1-.4h.4c.3.1.5.2.8.4.4.4.5.9.5 1.4 0 .3-.2.6-.4.8l-1.4 1.4-2.4 2.4c-.4.3-.8.5-1.2.5zm3.8 3.8c-.4 0-.8-.2-1.1-.5-.6-.6-.6-1.6 0-2.2l3.8-3.8c.2-.2.5-.4.8-.4h.2c.4 0 .8.2 1.1.5.4.4.5.9.5 1.4 0 .3-.2.6-.4.8l-3.8 3.8c-.3.2-.7.4-1.1.4zm3.9 3.8c-.4 0-.8-.2-1.1-.5-.6-.6-.6-1.6 0-2.2l3.8-3.8c.2-.2.5-.4.8-.4h.2c.4 0 .8.2 1.1.5.4.4.5.9.5 1.4 0 .3-.2.6-.4.8l-3.8 3.8c-.4.3-.7.4-1.1.4zm8.7-.4l-3.8 3.8c-.3.3-.7.4-1 .4-.4 0-.8-.2-1.1-.5-.6-.6-.6-1.6 0-2.2l3.8-3.8c.2-.2.5-.4.8-.4h.2c.4 0 .8.2 1.1.5.4.4.5.9.5 1.4-.2.3-.3.6-.5.8zM41.4 35c-.4.4-1 .7-1.6.7-.4 0-.8-.1-1.1-.3.6.9.5 2.1-.3 2.8-.4.4-1 .7-1.6.7-.4 0-.8-.1-1.2-.4.5.9.4 2-.4 2.7-.4.4-1 .7-1.6.7-.3 0-.6-.1-.9-.2.2-.4.3-.9.3-1.3 0-.8-.3-1.6-.9-2.2-.6-.6-1.4-.9-2.2-.9-.3 0-.5 0-.8.1.1-.3.1-.6.1-.9 0-.8-.3-1.6-.9-2.2-.6-.6-1.4-.9-2.2-.9-.3 0-.5 0-.8.1.1-.3.1-.6.1-.9 0-.8-.3-1.6-.9-2.2-.6-.6-1.4-.9-2.2-.9-.3 0-.5 0-.8.1.1-.3.1-.6.1-.9 0-.2 0-.5-.1-.7-.1-.5-.4-1-.8-1.4-.2-.2-.4-.4-.7-.5-.5-.3-1-.4-1.5-.4-.8 0-1.6.3-2.1.9l-2.2 2.2-.1-.1c-4.2-4.2-4.2-11 0-15.2 3.6-3.6 9.1-4.1 13.2-1.5-.2.1-.3.3-.5.5L20 19.1c-1.2 1.2-1.2 3.1 0 4.3.5.5 1.1.8 1.8.9h.4c.8 0 1.6-.3 2.2-.9l1.1-1.1.1-.1 2.9-2.9.2-.2 12.7 12.7c.9.8.9 2.3 0 3.2zm1.4-6.2c-.3.3-.6.6-.9.8l-11-11-1.9-1.9-5.6 5.6c-.3.3-.7.4-1.1.4-.4 0-.8-.1-1.1-.4-.6-.6-.6-1.6 0-2.2l6.5-6.5c.2-.2.5-.4.7-.6.9-.7 1.8-1.3 2.9-1.7 1.3-.5 2.7-.8 4-.8 2.7 0 5.5 1 7.6 3.1 4.1 4.2 4.1 11-.1 15.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPartnershipPos = {
  "id": "icon--wfp-hum--partnership-pos",
  "name": "icon--wfp-hum--partnership-pos",
  "tags": "icon--wfp-hum--partnership-pos",
  "styles": "",
  "viewBox": "0 0 36 36",
  "width": "36",
  "height": "36",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M4.6 24.3c-.4 0-.8-.2-1.1-.5-.6-.6-.6-1.6 0-2.2l1.7-1.7 2.1-2.1c.3-.3.7-.4 1-.4h.4c.3.1.5.2.8.4.4.4.5.9.5 1.4 0 .3-.2.6-.4.8l-1.4 1.4-2.4 2.4c-.4.3-.8.5-1.2.5zm3.8 3.8c-.4 0-.8-.2-1.1-.5-.6-.6-.6-1.6 0-2.2l3.8-3.8c.2-.2.5-.4.8-.4h.2c.4 0 .8.2 1.1.5.4.4.5.9.5 1.4 0 .3-.2.6-.4.8l-3.8 3.8c-.3.2-.7.4-1.1.4zm3.9 3.8c-.4 0-.8-.2-1.1-.5-.6-.6-.6-1.6 0-2.2l3.8-3.8c.2-.2.5-.4.8-.4h.2c.4 0 .8.2 1.1.5.4.4.5.9.5 1.4 0 .3-.2.6-.4.8l-3.8 3.8c-.4.3-.7.4-1.1.4zm8.7-.4l-3.8 3.8c-.3.3-.7.4-1 .4-.4 0-.8-.2-1.1-.5-.6-.6-.6-1.6 0-2.2l3.8-3.8c.2-.2.5-.4.8-.4h.2c.4 0 .8.2 1.1.5.4.4.5.9.5 1.4-.2.3-.3.6-.5.8zM31.4 25c-.4.4-1 .7-1.6.7-.4 0-.8-.1-1.1-.3.6.9.5 2.1-.3 2.8-.4.4-1 .7-1.6.7-.4 0-.8-.1-1.2-.4.5.9.4 2-.4 2.7-.4.4-1 .7-1.6.7-.3 0-.6-.1-.9-.2.2-.4.3-.9.3-1.3 0-.8-.3-1.6-.9-2.2-.6-.6-1.4-.9-2.2-.9-.3 0-.5 0-.8.1.1-.3.1-.6.1-.9 0-.8-.3-1.6-.9-2.2-.6-.6-1.4-.9-2.2-.9-.3 0-.5 0-.8.1.1-.3.1-.6.1-.9 0-.8-.3-1.6-.9-2.2-.6-.6-1.4-.9-2.2-.9-.3 0-.5 0-.8.1.1-.3.1-.6.1-.9 0-.2 0-.5-.1-.7-.1-.5-.4-1-.8-1.4-.2-.2-.4-.4-.7-.5-.5-.3-1-.4-1.5-.4-.8 0-1.6.3-2.1.9l-2.2 2.2-.1-.1c-4.2-4.2-4.2-11 0-15.2C7.7-.1 13.2-.6 17.3 2c-.2.1-.3.3-.5.5L10 9.1c-1.2 1.2-1.2 3.1 0 4.3.5.5 1.1.8 1.8.9h.4c.8 0 1.6-.3 2.2-.9l1.1-1.1.1-.1 2.9-2.9.2-.2 12.7 12.7c.9.8.9 2.3 0 3.2zm1.4-6.2c-.3.3-.6.6-.9.8l-11-11L19 6.7l-5.6 5.6c-.3.3-.7.4-1.1.4-.4 0-.8-.1-1.1-.4-.6-.6-.6-1.6 0-2.2l6.5-6.5c.2-.2.5-.4.7-.6.9-.7 1.8-1.3 2.9-1.7 1.3-.5 2.7-.8 4-.8 2.7 0 5.5 1 7.6 3.1 4.1 4.2 4.1 11-.1 15.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPopulationDisplacementNeg = {
  "id": "icon--wfp-hum--population-displacement-neg",
  "name": "icon--wfp-hum--population-displacement-neg",
  "tags": "icon--wfp-hum--population-displacement-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM29.8 45.2c-.2.4-.6.7-1 .9-.4.1-.9.1-1.3-.1-.9-.4-1.2-1.5-.8-2.4 2.1-4.1.6-9.2-3.5-11.4l-3.8-1.9-7.6 14.9c-.3.6-.9 1-1.6 1-.3 0-.5-.1-.8-.2-.9-.4-1.2-1.5-.8-2.4L21.2 19c-3.4-.4-6.9 1.3-8.6 4.5-.4.9-1.5 1.2-2.3.8-.9-.4-1.3-1.5-.8-2.3 2.9-5.7 9.7-8 15.4-5.5.1 0 .2.1.4.1l2.2 1.1c2 1 2.8 3.5 1.8 5.5L26 29.8c4.8 3.4 6.6 10 3.8 15.4zm-2.7-30.8c-.6-1.8.4-3.7 2.1-4.3 1.8-.6 3.7.4 4.3 2.1.6 1.8-.4 3.7-2.1 4.3-1.8.6-3.7-.4-4.3-2.1zM48.5 29l-5.9 5.9c-.3.3-.6.4-.9.4-.3 0-.7-.1-.9-.4-.5-.5-.5-1.3 0-1.9l3.7-3.7H33.3c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h11.2L40.8 23c-.5-.5-.5-1.3 0-1.9.5-.5 1.3-.5 1.9 0l5.9 5.9c.2.2.4.6.4.9 0 .3-.2.8-.5 1.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPopulationDisplacementPos = {
  "id": "icon--wfp-hum--population-displacement-pos",
  "name": "icon--wfp-hum--population-displacement-pos",
  "tags": "icon--wfp-hum--population-displacement-pos",
  "styles": "",
  "viewBox": "0 0 41 38",
  "width": "41",
  "height": "38",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21.8 36.2c-.2.4-.6.7-1 .9-.4.1-.9.1-1.3-.1-.9-.4-1.2-1.5-.8-2.4 2.1-4.1.6-9.2-3.5-11.4l-3.8-1.9-7.6 14.9c-.3.6-.9 1-1.6 1-.3 0-.5-.1-.8-.2-.9-.4-1.2-1.5-.8-2.4L13.2 10c-3.4-.4-6.9 1.3-8.6 4.5-.4.9-1.5 1.2-2.3.8-.9-.4-1.3-1.5-.8-2.3 2.9-5.7 9.7-8 15.4-5.5.1 0 .2.1.4.1l2.2 1.1c2 1 2.8 3.5 1.8 5.5L18 20.8c4.8 3.4 6.6 10 3.8 15.4zM19.1 5.4c-.6-1.8.4-3.7 2.1-4.3 1.8-.6 3.7.4 4.3 2.1.6 1.8-.4 3.7-2.1 4.3-1.8.6-3.7-.4-4.3-2.1zM40.5 20l-5.9 5.9c-.3.3-.6.4-.9.4-.3 0-.7-.1-.9-.4-.5-.5-.5-1.3 0-1.9l3.7-3.7H25.3c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h11.2L32.8 14c-.5-.5-.5-1.3 0-1.9.5-.5 1.3-.5 1.9 0l5.9 5.9c.2.2.4.6.4.9 0 .3-.2.8-.5 1.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPopulationReturnNeg = {
  "id": "icon--wfp-hum--population-return-neg",
  "name": "icon--wfp-hum--population-return-neg",
  "tags": "icon--wfp-hum--population-return-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM29.8 45.2c-.2.4-.6.7-1 .9-.4.1-.9.1-1.3-.1-.9-.4-1.2-1.5-.8-2.4 2.1-4.1.6-9.2-3.5-11.4l-3.8-1.9-7.6 14.9c-.3.6-.9 1-1.6 1-.3 0-.5-.1-.8-.2-.9-.4-1.2-1.5-.8-2.4L21.2 19c-3.4-.4-6.9 1.3-8.6 4.5-.4.9-1.5 1.2-2.3.8-.9-.4-1.3-1.5-.8-2.3 2.9-5.7 9.7-8 15.4-5.5.1 0 .2.1.4.1l2.2 1.1c2 1 2.8 3.5 1.8 5.5L26 29.8c4.8 3.4 6.6 10 3.8 15.4zm-2.7-30.8c-.6-1.8.4-3.7 2.1-4.3 1.8-.6 3.7.4 4.3 2.1.6 1.8-.4 3.7-2.1 4.3-1.8.6-3.7-.4-4.3-2.1zm14.2 21.7s-.1 0 0 0h-3.2l3.5 3.5c.5.5.5 1.3 0 1.8s-1.3.5-1.8 0l-5.7-5.7c-.2-.2-.4-.6-.4-.9 0-.3.1-.7.4-.9l5.7-5.7c.2-.2.6-.4.9-.4.3 0 .6.1.9.4.5.5.5 1.3 0 1.8L38 33.5h3.2c2.8 0 5.1-2.3 5.1-5.1s-2.3-5.1-5.1-5.1h-8c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h8c4.2 0 7.6 3.4 7.6 7.6 0 4.2-3.3 7.8-7.5 7.8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPopulationReturnPos = {
  "id": "icon--wfp-hum--population-return-pos",
  "name": "icon--wfp-hum--population-return-pos",
  "tags": "icon--wfp-hum--population-return-pos",
  "styles": "",
  "viewBox": "0 0 41 38",
  "width": "41",
  "height": "38",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21.8 36.2c-.2.4-.6.7-1 .9-.4.1-.9.1-1.3-.1-.9-.4-1.2-1.5-.8-2.4 2.1-4.1.6-9.2-3.5-11.4l-3.8-1.9-7.6 14.9c-.3.6-.9 1-1.6 1-.3 0-.5-.1-.8-.2-.9-.4-1.2-1.5-.8-2.4L13.2 10c-3.4-.4-6.9 1.3-8.6 4.5-.4.9-1.5 1.2-2.3.8-.9-.4-1.3-1.5-.8-2.3 2.9-5.7 9.7-8 15.4-5.5.1 0 .2.1.4.1l2.2 1.1c2 1 2.8 3.5 1.8 5.5L18 20.8c4.8 3.4 6.6 10 3.8 15.4zM19.1 5.4c-.6-1.8.4-3.7 2.1-4.3 1.8-.6 3.7.4 4.3 2.1.6 1.8-.4 3.7-2.1 4.3-1.8.6-3.7-.4-4.3-2.1zm14.2 21.7s-.1 0 0 0h-3.2l3.5 3.5c.5.5.5 1.3 0 1.8s-1.3.5-1.8 0l-5.7-5.7c-.2-.2-.4-.6-.4-.9 0-.3.1-.7.4-.9l5.7-5.7c.2-.2.6-.4.9-.4.3 0 .6.1.9.4.5.5.5 1.3 0 1.8L30 24.5h3.2c2.8 0 5.1-2.3 5.1-5.1s-2.3-5.1-5.1-5.1h-8c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h8c4.2 0 7.6 3.4 7.6 7.6 0 4.2-3.3 7.8-7.5 7.8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPowerplantNeg = {
  "id": "icon--wfp-hum--powerplant-neg",
  "name": "icon--wfp-hum--powerplant-neg",
  "tags": "icon--wfp-hum--powerplant-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M32.2 36.1h-6.6l3.7-6c.5-.7.2-1.7-.5-2.2-.7-.5-1.7-.2-2.2.5l-5.2 8.4c-.3.5-.3 1.1 0 1.6s.8.8 1.4.8h6.6l-3.7 6c-.5.7-.2 1.7.5 2.2.3.2.5.2.8.2.5 0 1-.3 1.3-.7l5.2-8.4c.3-.5.3-1.1 0-1.6-.2-.5-.8-.8-1.3-.8z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM21.2 15.7H27c1.3.1 2.6-.4 3.5-1.3 1-.9 1.5-2.1 1.6-3.4 0-1-.3-1.9-1-2.7-.7-.7-1.6-1.2-2.6-1.2-.7 0-1.4.2-2 .7-.5.5-.9 1.2-.9 1.9-.1 1.1.8 2 1.8 2 .7 0 1.2.6 1.1 1.3 0 .7-.6 1.2-1.3 1.1-2.4-.1-4.2-2.1-4.1-4.5.3-1.3.9-2.6 1.9-3.5 1-.9 2.3-1.4 3.7-1.3 3.4.2 6 3 5.8 6.4-.1 2-.9 3.8-2.4 5.1-1.4 1.3-3.3 2-5.2 1.9h-5.8c-.7 0-1.2-.5-1.2-1.2.1-.7.6-1.3 1.3-1.3zM14 50.4l3.9-23.9c0-.9.8-1.7 1.7-1.7h15.7c.9 0 1.7.8 1.7 1.7l3.9 23.9H14zm27.7-30.6c-.3.6-.6 1.1-1.1 1.6-1 .9-2.2 1.3-3.5 1.3l-16.6.1c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2l16.6-.1c.7 0 1.3-.2 1.8-.7.5-.5.8-1.1.8-1.8 0-1-.7-1.8-1.7-1.9-.3 0-.6.1-.8.3-.2.2-.4.5-.5.8-.1.4-.4 1-1.1 1-.7 0-1.2-.4-1.2-1.1 0-1 .5-1.8 1.2-2.5s1.6-1 2.5-.9c2.3.1 4.1 2 4 4.4.1.7-.1 1.3-.4 1.9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPowerplantPos = {
  "id": "icon--wfp-hum--powerplant-pos",
  "name": "icon--wfp-hum--powerplant-pos",
  "tags": "icon--wfp-hum--powerplant-pos",
  "styles": "",
  "viewBox": "0 0 29 47",
  "width": "29",
  "height": "47",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.2 14.1H13c1.9.1 3.8-.6 5.2-1.9 1.4-1.3 2.3-3.1 2.4-5.1.1-3.4-2.5-6.2-5.8-6.4-1.4-.1-2.7.4-3.7 1.3S9.5 4.2 9.4 5.5c-.1 2.4 1.7 4.4 4.1 4.5.7 0 1.2-.5 1.3-1.1 0-.7-.5-1.2-1.1-1.3-1.1 0-1.9-.9-1.8-2 0-.7.3-1.4.9-1.9.5-.5 1.2-.7 2-.7 1 0 1.9.5 2.6 1.2.7.7 1 1.7 1 2.7-.1 1.3-.6 2.5-1.6 3.4-1 .9-2.2 1.3-3.5 1.3H7.5c-.7 0-1.2.5-1.2 1.2-.3.8.2 1.3.9 1.3z"
    }, {
      "d": "M24.2 9.5c-.9 0-1.9.3-2.5.9-.7.8-1.2 1.6-1.2 2.6 0 .7.5 1 1.2 1.1.7 0 1-.6 1.1-1 .1-.3.2-.6.5-.8.2-.2.5-.3.8-.3 1 0 1.7.9 1.7 1.9 0 .7-.3 1.3-.8 1.8-.5.4-1.1.7-1.8.7l-16.6.1c-.7 0-1.2.6-1.2 1.2 0 .7.6 1.2 1.2 1.2l16.6-.1c1.3 0 2.5-.4 3.5-1.3.5-.4.9-1 1.1-1.6.3-.6.4-1.2.4-1.9.1-2.4-1.7-4.4-4-4.5z"
    }, {
      "fill-rule": "nonzero",
      "d": "M21.3 20.8H5.6c-.9 0-1.7.8-1.7 1.7L0 46.4h27l-4-23.9c0-.9-.8-1.7-1.7-1.7zm-1.8 13.7l-5.2 8.4c-.3.5-.8.7-1.3.7-.3 0-.6-.1-.8-.2-.7-.5-1-1.4-.5-2.2l3.7-6H8.8c-.6 0-1.1-.3-1.4-.8-.3-.5-.3-1.1 0-1.6l5.2-8.4c.5-.7 1.4-1 2.2-.5.7.5 1 1.4.5 2.2l-3.7 6h6.6c.6 0 1.1.3 1.4.8.2.5.2 1.1-.1 1.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPregnantNeg = {
  "id": "icon--wfp-hum--pregnant-neg",
  "name": "icon--wfp-hum--pregnant-neg",
  "tags": "icon--wfp-hum--pregnant-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM30.9 7.8c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4-3.4-1.5-3.4-3.4 1.5-3.4 3.4-3.4zm4.9 26.8c-.3 1-.8 1.9-1.5 2.6v9.4c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v-8.4h-1.7v8.4c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v-8.4h-3.2c-.7 0-1.2-.7-1-1.5l4.2-17c-3.3.8-5.9 4-5.9 7.6 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-6 4.8-10.8 10.8-10.9H33c.6 0 1 .5 1.1 1.1l.9 5.6c2.9.4 5.1 2.9 5.1 5.9.1 2.6-1.8 4.9-4.3 5.6z"
    }, {
      "d": "M35.2 26.5c-.3.1-.6.3-.8.5l-.2.2-.1-.2c-.7-.7-1.9-.8-2.6-.1-.8.7-.8 2 0 2.7l.2.2.9 1 1.2 1.3c.1.1.3.2.4.2.2 0 .3-.1.5-.2l1-1.1 1.1-1.2.2-.2c.7-.8.7-2 0-2.7-.4-.5-1.1-.6-1.8-.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPregnantPos = {
  "id": "icon--wfp-hum--pregnant-pos",
  "name": "icon--wfp-hum--pregnant-pos",
  "tags": "icon--wfp-hum--pregnant-pos",
  "styles": "",
  "viewBox": "0 0 25 42",
  "width": "25",
  "height": "42",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M14.9 7.6c1.9 0 3.4-1.5 3.4-3.4S16.8.8 14.9.8s-3.4 1.5-3.4 3.4 1.5 3.4 3.4 3.4z"
    }, {
      "fill-rule": "nonzero",
      "d": "M19.1 16l-.9-5.6c-.1-.6-.5-1.1-1.1-1.1H11.4C5.4 9.4.6 14.3.6 20.2c0 .9.8 1.7 1.7 1.7.9 0 1.7-.8 1.7-1.7 0-3.6 2.6-6.8 5.9-7.6l-4.2 17c-.2.8.3 1.5 1 1.5h3.2v8.4c0 .9.8 1.7 1.7 1.7.9 0 1.7-.8 1.7-1.7v-8.4H15v8.4c0 .9.8 1.7 1.7 1.7.9 0 1.7-.8 1.7-1.7v-9.4c.7-.6 1.3-1.5 1.5-2.6 2.5-.7 4.4-3 4.4-5.7-.1-2.9-2.3-5.4-5.2-5.8zm2 6.6l-.2.2-1.1 1.2-1 1.1c-.1.1-.3.2-.5.2s-.3-.1-.4-.2l-1.2-1.3-.9-1-.2-.2c-.7-.8-.7-2 0-2.7.7-.7 1.9-.6 2.6.1l.2.2.2-.2c.2-.2.5-.4.8-.5.6-.2 1.3-.1 1.8.4.6.7.6 2-.1 2.7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumProcurementNeg = {
  "id": "icon--wfp-hum--procurement-neg",
  "name": "icon--wfp-hum--procurement-neg",
  "tags": "icon--wfp-hum--procurement-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM27.5 8.8h2.4c.9 0 1.6.7 1.6 1.6 0-.9.7-1.6 1.6-1.6h2.4c.5 0 .9.5.8.9l-1.6 7.9h-6.4l-1.6-7.9c0-.4.3-.9.8-.9zm-8 1.7h4.3c.8 0 1.4.5 1.6 1.3l1.3 6h-6.4l-1.6-6.2c-.1-.7.3-1.1.8-1.1zm19.3 33.4c-2 2.1-4.8 3.4-8 3.4h-6.4c-3.2 0-6-1.3-8-3.4-3-3.1-4.2-7.8-2.3-12.2l6.3-12.4h14.4L41 31.7c1.9 4.4.7 9.1-2.2 12.2z"
    }, {
      "d": "M24.5 33.8c-.2 1-.3 1.7-.4 2.1 0-.3-.1-.8-.2-1.4-.1-.6-.2-1.2-.4-1.7l-.7-3h-2l-.7 3c-.1.4-.2 1-.3 1.6-.1.6-.2 1.1-.3 1.5-.1-.5-.2-1.2-.4-2.1l-.9-4h-2.1l2 8h2.6c.5-2.1.7-3.3.8-3.6.1-.3.1-.6.2-1s.1-.7.1-.9c0 .3.1.7.2 1.1.1.4.1.7.2.9l.8 3.5h2.6l2-8h-2.1l-1 4zm4 4h2.1v-3H33V33h-2.4v-1.5h2.6v-1.8h-4.7z"
    }, {
      "fill-rule": "nonzero",
      "d": "M36.8 29.7H34v8h2.2V35h.6c1 0 1.7-.2 2.3-.7.5-.5.8-1.2.8-2.1 0-.8-.3-1.4-.8-1.9-.6-.3-1.3-.6-2.3-.6zm.5 3.4c-.2.2-.5.3-.8.3h-.4v-1.8h.6c.6 0 .9.3.9.8 0 .2-.1.5-.3.7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumProcurementPos = {
  "id": "icon--wfp-hum--procurement-pos",
  "name": "icon--wfp-hum--procurement-pos",
  "tags": "icon--wfp-hum--procurement-pos",
  "styles": "",
  "viewBox": "0 0 29 40",
  "width": "29",
  "height": "40",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13.7 9.7l-1.3-6c-.2-.7-.8-1.3-1.6-1.3H6.5c-.5 0-.9.5-.8 1l1.6 6.2h6.4v.1zm10 13.8h-.6v1.8h.4c.3 0 .6-.1.8-.3.2-.2.3-.4.3-.8s-.3-.7-.9-.7z"
    }, {
      "fill-rule": "nonzero",
      "d": "M28 23.7l-6.3-12.4H7.3L1 23.7c-1.9 4.4-.7 9.2 2.3 12.2 2 2.1 4.8 3.4 8 3.4h6.4c3.2 0 6-1.3 8-3.4 3-3.1 4.2-7.8 2.3-12.2zm-15.5 6.1H10l-.8-3.5c0-.1-.1-.4-.2-.9-.1-.4-.1-.8-.2-1.1 0 .2-.1.5-.1.9-.1.4-.1.7-.2 1-.1.3-.3 1.5-.8 3.6H5.1l-2-8h2.1l.9 4c.2.9.3 1.6.4 2.1 0-.4.1-.9.3-1.5.1-.6.2-1.2.3-1.6l.7-3h2l.7 3c.1.5.2 1.1.4 1.7.1.6.2 1.1.2 1.4 0-.4.2-1.1.4-2.1l.9-4h2.1l-2 8zm7.7-6.3h-2.6V25H20v1.7h-2.4v3h-2.1v-8h4.8v1.8h-.1zm5.8 2.9c-.5.5-1.3.7-2.3.7h-.6v2.7H21v-8h2.8c1 0 1.8.2 2.3.7.5.4.8 1.1.8 1.9-.1.8-.4 1.5-.9 2z"
    }, {
      "d": "M18.5 9.7h3.2l1.6-7.9c.1-.5-.3-.9-.8-.9h-2.4c-.9 0-1.6.7-1.6 1.6 0-.9-.7-1.6-1.6-1.6h-2.4c-.5 0-.9.5-.8.9l1.6 7.9h3.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumProtectionClusterNeg = {
  "id": "icon--wfp-hum--protection-cluster-neg",
  "name": "icon--wfp-hum--protection-cluster-neg",
  "tags": "icon--wfp-hum--protection-cluster-neg",
  "styles": "",
  "viewBox": "0 0 39 40",
  "width": "39",
  "height": "40",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M17 39.3H9.8v-7.7c-.5-.2-.9-.6-1.3-1L.9 22.9c-.4-.5-.7-1.1-.7-1.7V7.3C.2 6 1.3 4.9 2.6 4.9 3.9 4.9 5 6 5 7.3v12.8l3.8 4c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L7 19.4c-.7-.7-.7-1.7 0-2.4s1.7-.7 2.4 0l6.3 6.4c1 1.1 1.5 2.5 1.5 3.9v12H17zM12.2 8.1c0-4 3.2-7.2 7.2-7.2s7.2 3.2 7.2 7.2-3.2 7.2-7.2 7.2-7.2-3.3-7.2-7.2zm26.4 13.1c0 .6-.2 1.2-.7 1.7l-7.6 7.7c-.4.4-.9.7-1.3 1v7.7h-7.2v-12c-.1-1.4.4-2.8 1.5-3.9l6.3-6.4c.7-.7 1.7-.7 2.4 0s.7 1.7 0 2.4l-3.2 3.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.3-.1l3.8-3.9V7.3c0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4v13.9h-.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumProtectionClusterPos = {
  "id": "icon--wfp-hum--protection-cluster-pos",
  "name": "icon--wfp-hum--protection-cluster-pos",
  "tags": "icon--wfp-hum--protection-cluster-pos",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM26 47.3h-7.2v-7.7c-.5-.2-.9-.6-1.3-1l-7.6-7.7c-.4-.5-.7-1.1-.7-1.7V15.3c0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4v12.8l3.8 4c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L16 27.4c-.7-.7-.7-1.7 0-2.4s1.7-.7 2.4 0l6.3 6.4c1 1.1 1.5 2.5 1.5 3.9v12H26zm-4.8-31.2c0-4 3.2-7.2 7.2-7.2s7.2 3.2 7.2 7.2-3.2 7.2-7.2 7.2-7.2-3.3-7.2-7.2zm26.4 13.1c0 .6-.2 1.2-.7 1.7l-7.6 7.7c-.4.4-.9.7-1.3 1v7.7h-7.2v-12c-.1-1.4.4-2.8 1.5-3.9l6.3-6.4c.7-.7 1.7-.7 2.4 0s.7 1.7 0 2.4l-3.2 3.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.3-.1l3.8-3.9V15.3c0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4v13.9h-.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPublicInformationNeg = {
  "id": "icon--wfp-hum--public-information-neg",
  "name": "icon--wfp-hum--public-information-neg",
  "tags": "icon--wfp-hum--public-information-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM22 15.2c0-3.5 2.9-6.4 6.4-6.4 3.5 0 6.4 2.9 6.4 6.4v13.6c0 3.5-2.9 6.4-6.4 6.4-3.5 0-6.4-2.9-6.4-6.4V15.2zm8 24.3V44h3.2c.6 0 1.1.3 1.4.8.6 1.2-.3 2.4-1.4 2.4h-9.6c-.6 0-1.1-.3-1.4-.8-.6-1.2.3-2.4 1.4-2.4h3.2v-4.5c-5.4-.8-9.6-5.4-9.6-11.1 0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2c0 4.9 3.9 8.8 8.8 8.8s8.8-4 8.8-8.8c0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2c0 5.7-4.2 10.4-9.6 11.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumPublicInformationPos = {
  "id": "icon--wfp-hum--public-information-pos",
  "name": "icon--wfp-hum--public-information-pos",
  "tags": "icon--wfp-hum--public-information-pos",
  "styles": "",
  "viewBox": "0 0 23 40",
  "width": "23",
  "height": "40",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5 7.2C5 3.7 7.9.8 11.4.8c3.5 0 6.4 2.9 6.4 6.4v13.6c0 3.5-2.9 6.4-6.4 6.4-3.5 0-6.4-2.9-6.4-6.4V7.2zm8 24.3V36h3.2c.6 0 1.1.3 1.4.8.6 1.2-.3 2.4-1.4 2.4H6.6c-.6 0-1.1-.3-1.4-.8-.6-1.2.3-2.4 1.4-2.4h3.2v-4.5C4.4 30.7.2 26.1.2 20.4c0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2c0 4.9 3.9 8.8 8.8 8.8s8.8-4 8.8-8.8c0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2c0 5.7-4.2 10.4-9.6 11.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumRefugeeCampNeg = {
  "id": "icon--wfp-hum--refugee-camp-neg",
  "name": "icon--wfp-hum--refugee-camp-neg",
  "tags": "icon--wfp-hum--refugee-camp-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM34 43l-5.1-10.3c-.1-.3-.5-.2-.5.1V43H9.2l2.4-18.5c.1-.4.3-.8.6-1.1l15.1-12.1c.6-.5 1.5-.5 2.1 0l15.1 12.1c.3.3.6.7.6 1.1L47.6 43H34z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumRefugeeCampPos = {
  "id": "icon--wfp-hum--refugee-camp-pos",
  "name": "icon--wfp-hum--refugee-camp-pos",
  "tags": "icon--wfp-hum--refugee-camp-pos",
  "styles": "",
  "viewBox": "0 0 39 33",
  "width": "39",
  "height": "33",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M25 33l-5.1-10.3c-.1-.3-.5-.2-.5.1V33H.2l2.4-18.5c.1-.4.3-.8.6-1.1L18.3 1.3c.6-.5 1.5-.5 2.1 0l15.1 12.1c.3.3.6.7.6 1.1L38.6 33H25z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumReliefGoodsNeg = {
  "id": "icon--wfp-hum--relief-goods-neg",
  "name": "icon--wfp-hum--relief-goods-neg",
  "tags": "icon--wfp-hum--relief-goods-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-21 47.5c0 .5-.4.8-.8.8h-8.4c-.5 0-.8-.4-.8-.8V39c0-.5.4-.8.8-.8h8.4c.5 0 .8.4.8.8v8.5zM39.8 26L29.3 36.1c-.1.1-.2.2-.4.2-.1.1-.3.1-.4.1-.2 0-.3 0-.4-.1-.1-.1-.3-.1-.4-.2L17 26c-.5-.5-.5-1.3 0-1.8s1.3-.5 1.8 0l9.7 9.3 9.7-9.3c.5-.5 1.3-.5 1.8 0 .3.5.3 1.3-.2 1.8zM14 22.2c0-7.9 6.4-14.3 14.3-14.3s14.3 6.4 14.3 14.3H14z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumReliefGoodsPos = {
  "id": "icon--wfp-hum--relief-goods-pos",
  "name": "icon--wfp-hum--relief-goods-pos",
  "tags": "icon--wfp-hum--relief-goods-pos",
  "styles": "",
  "viewBox": "0 0 29 42",
  "width": "29",
  "height": "42",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M19.4 40.5c0 .5-.4.8-.8.8h-8.4c-.5 0-.8-.4-.8-.8V32c0-.5.4-.8.8-.8h8.4c.5 0 .8.4.8.8v8.5zM25.8 19L15.3 29.1c-.1.1-.2.2-.4.2-.1.1-.3.1-.4.1-.2 0-.3 0-.4-.1-.1-.1-.3-.1-.4-.2L3 19c-.5-.5-.5-1.3 0-1.8s1.3-.5 1.8 0l9.7 9.3 9.7-9.3c.5-.5 1.3-.5 1.8 0 .3.5.3 1.3-.2 1.8zM0 15.2C0 7.3 6.4.9 14.3.9s14.3 6.4 14.3 14.3H0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumResourcingNeg = {
  "id": "icon--wfp-hum--resourcing-neg",
  "name": "icon--wfp-hum--resourcing-neg",
  "tags": "icon--wfp-hum--resourcing-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M27.9 32.1h-.7c-.7 0-1.2-.5-1.2-1.2s.6-1.2 1.2-1.2h2.4c.7 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2h-1.2v-1.2c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2v1.4c-1.4.5-2.4 1.8-2.4 3.4 0 2 1.6 3.6 3.7 3.6h.7c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-2.4c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2h.4v1.2c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2v-1.2c1.8-.2 3.2-1.8 3.2-3.6-.1-2-1.7-3.6-3.7-3.6z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM27.5 8.8h2.4c.9 0 1.6.7 1.6 1.6 0-.9.7-1.6 1.6-1.6h2.4c.5 0 .9.5.8.9l-1.6 7.9h-6.4l-1.6-7.9c0-.4.3-.9.8-.9zm-8 1.7h4.3c.8 0 1.4.5 1.6 1.3l1.3 6h-6.4l-1.6-6.2c-.1-.7.3-1.1.8-1.1zm19.3 33.4c-2 2.1-4.8 3.4-8 3.4h-6.4c-3.2 0-6-1.3-8-3.4-3-3.1-4.2-7.8-2.3-12.2l6.3-12.4h14.4L41 31.7c1.9 4.4.7 9.1-2.2 12.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumResourcingPos = {
  "id": "icon--wfp-hum--resourcing-pos",
  "name": "icon--wfp-hum--resourcing-pos",
  "tags": "icon--wfp-hum--resourcing-pos",
  "styles": "",
  "viewBox": "0 0 29 40",
  "width": "29",
  "height": "40",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13.7 9.7l-1.3-6c-.2-.7-.8-1.3-1.6-1.3H6.5c-.5 0-.9.5-.8 1l1.6 6.2h6.4v.1zm4.8 0h3.2l1.6-7.9c.1-.5-.3-.9-.8-.9h-2.4c-.9 0-1.6.7-1.6 1.6 0-.9-.7-1.6-1.6-1.6h-2.4c-.5 0-.9.5-.8.9l1.6 7.9h3.2z"
    }, {
      "fill-rule": "nonzero",
      "d": "M28 23.7l-6.3-12.4H7.3L1 23.7c-1.9 4.4-.7 9.2 2.3 12.2 2 2.1 4.8 3.4 8 3.4h6.4c3.2 0 6-1.3 8-3.4 3-3.1 4.2-7.8 2.3-12.2zm-12.7 7.6v1.2c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2v-1.2h-.4c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2h2.4c.7 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2h-.7c-2 0-3.7-1.6-3.7-3.6 0-1.6 1-2.9 2.4-3.4v-1.4c0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2v1.2h1.2c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2h-2.4c-.7 0-1.2.5-1.2 1.2s.6 1.2 1.2 1.2h.7c2 0 3.6 1.6 3.6 3.6.1 1.8-1.3 3.4-3.1 3.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumSchoolFeedingNeg = {
  "id": "icon--wfp-hum--school-feeding-neg",
  "name": "icon--wfp-hum--school-feeding-neg",
  "tags": "icon--wfp-hum--school-feeding-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-8 31.4c2.2 0 4 1.8 4 4H39.8c0-.4-.1-.8-.4-1.1-.3-.3-.8-.5-1.2-.5H24.4c.6-1.4 2-2.4 3.6-2.4.1-1.9 1.7-3.4 3.7-3.4.6 0 1.2.1 1.7.4.5-1.6 2-2.7 3.8-2.7 1.8 0 3.2 1.1 3.8 2.7.5-.2 1.1-.4 1.7-.4 1.9-.1 3.5 1.4 3.7 3.4zm-18.7-8.7c1.4-.7 3.1-1.1 4.8-1.1 1.7 0 3.3.3 4.7.8.5.2.7.7.5 1.2-.2.5-.7.7-1.2.5-1.2-.5-2.6-.7-4-.7s-2.8.3-3.9.9c-.1.1-.3.1-.4.1-.3 0-.7-.2-.8-.5-.3-.4-.1-1 .3-1.2zm0-4.4c1.4-.7 3.1-1.1 4.8-1.1 1.7 0 3.3.3 4.7.8.5.2.7.7.5 1.2-.2.5-.7.7-1.2.5-1.2-.5-2.6-.7-4-.7s-2.8.3-3.9.9c-.1.1-.3.1-.4.1-.3 0-.7-.2-.8-.5-.3-.4-.1-.9.3-1.2zm-9.1 20.1h-11c-.7 0-1.2-.6-1.2-1.2v-20c0-.7.6-1.2 1.2-1.2h.6v-1.6c0-.3.1-.6.4-.8.1-.1 2.9-2 8.3-2 4.1 0 6.7 1.4 7.8 2.2 1.1-.8 3.7-2.2 7.8-2.2 5.4 0 8.2 2 8.3 2 .2.2.4.5.4.8V16h.6c.7 0 1.2.6 1.2 1.2v9.4c-.5 0-.9-.1-1.4 0-.6-.9-1.4-1.5-2.4-1.9V15c-.9-.5-3.2-1.5-6.9-1.5-3.8 0-6.1 1.4-6.9 2v15.1c-.7.4-1.4.9-1.9 1.5V15.5c-.8-.6-3.1-2-6.9-2-3.7 0-6 1-6.9 1.5v19.1c1.4-.6 3.6-1.3 6.9-1.3.9 0 1.8.1 2.6.2-1 .7-1.6 1.9-1.6 3.2.3.9.6 1.6 1 2.2zm3.6-14.8c-.2.5-.7.7-1.2.5-1.2-.5-2.6-.7-4-.7s-2.8.3-3.9.9c-.1.1-.3.1-.4.1-.3 0-.7-.2-.8-.5-.2-.5 0-1 .4-1.3 1.4-.7 3.1-1.1 4.8-1.1 1.7 0 3.3.3 4.7.8.3.3.6.8.4 1.3zm0 4.4c-.2.5-.7.7-1.2.5-1.2-.5-2.6-.7-4-.7s-2.8.3-3.9.9c-.1.1-.3.1-.4.1-.3 0-.7-.2-.8-.5-.2-.5 0-1 .4-1.3 1.4-.7 3.1-1.1 4.8-1.1 1.7 0 3.3.3 4.7.8.3.3.6.8.4 1.3zm0-8.7c-.2.4-.7.7-1.2.5-1.2-.5-2.6-.7-4-.7s-2.8.3-3.9.9c-.1.1-.3.1-.4.1-.3 0-.7-.2-.8-.5-.2-.5 0-1 .4-1.3 1.4-.7 3.1-1.1 4.8-1.1 1.7 0 3.3.3 4.7.8.3.2.6.8.4 1.3zm-2.8 16.8c0-.5.4-.9.9-.9h17.8c.1 0 .2.1.2.2-.1 2.1-1.5 3.6-3.8 3.6-1.6 0-2.4-.7-3.2-1.9H20.2c-.4 0-.8-.4-.8-1zm29.4 6.2c-1.3 1.3-3.2 2.2-5.3 2.2H30.9c-3.6 0-6.6-2.6-7.3-6h7c.8 1 1.9 1.9 3.9 1.9 2.4 0 4.2-1.3 4.9-3.4H51c0 2.1-.9 4-2.2 5.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumSchoolFeedingPos = {
  "id": "icon--wfp-hum--school-feeding-pos",
  "name": "icon--wfp-hum--school-feeding-pos",
  "tags": "icon--wfp-hum--school-feeding-pos",
  "styles": "",
  "viewBox": "0 0 46 34",
  "width": "46",
  "height": "34",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13.5 22c-.8-.1-1.6-.2-2.6-.2-3.2 0-5.5.7-6.9 1.3V4c.9-.5 3.2-1.5 6.9-1.5 3.8 0 6.1 1.4 6.9 2v16.6c.5-.7 1.1-1.2 1.9-1.5V4.5c.8-.6 3-2 6.9-2 3.7 0 6 1 6.9 1.5v9.8c.9.4 1.8 1 2.4 1.9.5-.1.9-.1 1.4 0V6.3c0-.7-.6-1.2-1.2-1.2h-.6V3.5c0-.3-.1-.6-.4-.8-.1-.1-2.9-2-8.3-2-4.1 0-6.7 1.4-7.8 2.2-1.1-.8-3.7-2.2-7.8-2.2-5.4 0-8.2 2-8.3 2-.2.2-.4.5-.4.8V5h-.9C.9 5 .4 5.6.4 6.2v19.9c0 .7.6 1.2 1.2 1.2h11c-.4-.6-.6-1.4-.6-2.2-.1-1.2.6-2.3 1.5-3.1z"
    }, {
      "d": "M22.2 9.1c.1 0 .3 0 .4-.1 1.2-.6 2.5-.9 3.9-.9 1.5 0 2.8.2 4 .7.5.2 1-.1 1.2-.5.2-.5-.1-1-.5-1.2-1.4-.5-3-.8-4.7-.8-1.7 0-3.3.4-4.8 1.1-.5.2-.6.8-.4 1.3.2.2.5.4.9.4zm-.9 3.9c.2.3.5.5.8.5.1 0 .3 0 .4-.1 1.2-.6 2.5-.9 3.9-.9 1.5 0 2.8.2 4 .7.5.2 1-.1 1.2-.5.2-.5-.1-1-.5-1.2-1.4-.5-3-.8-4.7-.8-1.7 0-3.3.4-4.8 1.1-.3.1-.5.7-.3 1.2zM35 17.3c-.5-1.6-2-2.7-3.8-2.7-1.7 0-3.2 1.1-3.8 2.7-.5-.2-1.1-.4-1.7-.4-2 0-3.6 1.5-3.7 3.4-1.6 0-3 1-3.6 2.4h13.8c.5 0 .9.2 1.2.5.3.3.4.7.4 1.1h10.6c0-2.2-1.8-4-4-4-.1-1.9-1.7-3.4-3.7-3.4-.6 0-1.2.2-1.7.4zm-19.4-5.9c-1.4-.5-3-.8-4.7-.8-1.7 0-3.3.4-4.8 1.1-.5.2-.6.8-.4 1.3.2.3.5.5.8.5.1 0 .3 0 .4-.1 1.2-.6 2.5-.9 3.9-.9 1.5 0 2.8.2 4 .7.5.2 1-.1 1.2-.5.4-.6.1-1.1-.4-1.3zm17.9 14.7c-.7 2.1-2.5 3.4-4.9 3.4-2 0-3.2-.9-3.9-1.9h-7c.7 3.4 3.7 6 7.3 6h12.6c2.1 0 3.9-.8 5.3-2.2 1.3-1.3 2.2-3.2 2.2-5.3H33.5zM15.6 15.8c-1.4-.5-3-.8-4.7-.8-1.7 0-3.3.4-4.8 1.1-.5.2-.6.8-.4 1.3.2.3.5.5.8.5.1 0 .3 0 .4-.1 1.2-.6 2.5-.9 3.9-.9 1.5 0 2.8.2 4 .7.5.2 1-.1 1.2-.5.4-.6.1-1.1-.4-1.3z"
    }, {
      "d": "M25.4 26.1c.7 1.2 1.6 1.9 3.2 1.9 2.3 0 3.7-1.5 3.8-3.6 0-.1-.1-.2-.2-.2H14.4c-.6 0-.9.4-.9.9s.4.9.9.9h11v.1zM15.6 7c-1.4-.5-3-.8-4.7-.8-1.7 0-3.3.4-4.8 1.1-.5.2-.6.8-.4 1.3.2.3.5.5.8.5.1 0 .3 0 .4-.1 1.2-.6 2.5-.9 3.9-.9 1.5 0 2.8.2 4 .7.5.2 1-.1 1.2-.5.4-.5.1-1.1-.4-1.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumSecurityNeg = {
  "id": "icon--wfp-hum--security-neg",
  "name": "icon--wfp-hum--security-neg",
  "tags": "icon--wfp-hum--security-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M31.3 22.4c-.9 0-1.7.3-2.4 1l-.7.6-.7-.6c-.7-.6-1.5-1-2.4-1-.8 0-1.7.3-2.3.9-1.4 1.3-1.3 3.6 0 4.9l.6.6 4.5 4.7c.2.2.4.2.6 0l4.5-4.7.6-.6c1.4-1.3 1.4-3.6 0-4.9-.6-.5-1.5-.9-2.3-.9z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM41 30.6c0 7.9-5.8 14.3-12.8 14.3-7 0-12.8-6.4-12.8-14.3V14.4c0-.4.3-.7.6-.8l12-2.4h.3l12 2.4c.4.1.6.4.6.8v16.2h.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumSecurityPos = {
  "id": "icon--wfp-hum--security-pos",
  "name": "icon--wfp-hum--security-pos",
  "tags": "icon--wfp-hum--security-pos",
  "styles": "",
  "viewBox": "0 0 27 34",
  "width": "27",
  "height": "34",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M25.4 2.6L13.4.2h-.3l-12 2.4c-.4.1-.6.4-.6.8v16.2c0 7.9 5.8 14.3 12.8 14.3 7 0 12.8-6.4 12.8-14.3V3.4c-.1-.4-.4-.7-.7-.8zm-6.8 14.7l-.6.5-4.5 4.7c-.2.2-.4.2-.6 0l-4.5-4.7-.6-.6c-1.4-1.3-1.4-3.6 0-4.9.6-.6 1.5-.9 2.3-.9.9 0 1.7.3 2.4 1l.7.6.7-.6c.7-.6 1.5-1 2.4-1 .8 0 1.7.3 2.3.9 1.4 1.4 1.3 3.6 0 5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumShipNeg = {
  "id": "icon--wfp-hum--ship-neg",
  "name": "icon--wfp-hum--ship-neg",
  "tags": "icon--wfp-hum--ship-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM28.1 9.6c0-.4.4-.8.8-.8h4.8c.4 0 .8.4.8.8v4.8c0 .4-.4.8-.8.8h-4.8c-.4 0-.8-.4-.8-.8V9.6zm-8.1 0c0-.4.4-.8.8-.8h4.8c.4 0 .8.4.8.8v4.8c0 .4-.4.8-.8.8h-4.8c-.4 0-.8-.4-.8-.8V9.6zm-4.8 8.9c0-.4.4-.8.8-.8h22.4c.4 0 .8.4.8.8v2.4c0 .4-.4.8-.8.8H16c-.4 0-.8-.4-.8-.8v-2.4zm-2.4 5.6h28.8c.9 0 1.7.8 1.6 1.7-.4 3.3-1.7 6.3-3.7 8.7-.9 0-1.3-.3-1.9-.6-.8-.4-1.8-1-3.7-1-1.9 0-2.9.6-3.7 1-.7.4-1.1.6-2.2.6s-1.5-.2-2.2-.6c-.8-.4-1.8-1-3.7-1-1.9 0-2.9.6-3.7 1-.7.4-1.1.6-2.2.6-.8 0-1.2-.1-1.6-.3-1.9-2.3-3.1-5.2-3.4-8.3-.1-1 .7-1.8 1.6-1.8zm32.9 21.6c-1.1 0-1.5.2-2.2.6-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6s-1.5.2-2.2.6c-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6s-1.5.2-2.2.6c-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 .9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6zm0-6.4c-1.1 0-1.5.2-2.2.6-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6s-1.5.2-2.2.6c-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6s-1.5.2-2.2.6c-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 .9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumShipPos = {
  "id": "icon--wfp-hum--ship-pos",
  "name": "icon--wfp-hum--ship-pos",
  "tags": "icon--wfp-hum--ship-pos",
  "styles": "",
  "viewBox": "0 0 40 40",
  "width": "40",
  "height": "40",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M20.1 1.6c0-.4.4-.8.8-.8h4.8c.4 0 .8.4.8.8v4.8c0 .4-.4.8-.8.8h-4.8c-.4 0-.8-.4-.8-.8V1.6zm-8.1 0c0-.4.4-.8.8-.8h4.8c.4 0 .8.4.8.8v4.8c0 .4-.4.8-.8.8h-4.8c-.4 0-.8-.4-.8-.8V1.6zm-4.8 8.9c0-.4.4-.8.8-.8h22.4c.4 0 .8.4.8.8v2.4c0 .4-.4.8-.8.8H8c-.4 0-.8-.4-.8-.8v-2.4zm-2.4 5.6h28.8c.9 0 1.7.8 1.6 1.7-.4 3.3-1.7 6.3-3.7 8.7-.9 0-1.3-.3-1.9-.6-.8-.4-1.8-1-3.7-1-1.9 0-2.9.6-3.7 1-.7.4-1.1.6-2.2.6s-1.5-.2-2.2-.6c-.8-.4-1.8-1-3.7-1-1.9 0-2.9.6-3.7 1-.7.4-1.1.6-2.2.6-.8 0-1.2-.1-1.6-.3-1.9-2.3-3.1-5.2-3.4-8.3-.1-1 .7-1.8 1.6-1.8zm32.9 21.6c-1.1 0-1.5.2-2.2.6-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6s-1.5.2-2.2.6c-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6s-1.5.2-2.2.6c-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 .9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6zm0-6.4c-1.1 0-1.5.2-2.2.6-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6s-1.5.2-2.2.6c-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6s-1.5.2-2.2.6c-.8.4-1.8 1-3.7 1-1.9 0-2.9-.6-3.7-1-.7-.4-1.1-.6-2.2-.6-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 1.9 0 2.9.6 3.7 1 .7.4 1.1.6 2.2.6s1.5-.2 2.2-.6c.8-.4 1.8-1 3.7-1 .9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumTruckNeg = {
  "id": "icon--wfp-hum--truck-neg",
  "name": "icon--wfp-hum--truck-neg",
  "tags": "icon--wfp-hum--truck-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M23.6 32.3c-.3-.3-.7-.5-1.1-.5-.8 0-1.4.6-1.6 1.3v4.3c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6v-4.3c-.1-.3-.3-.5-.5-.8zm5.6 0c-.3-.3-.7-.5-1.1-.5-.8 0-1.4.6-1.6 1.3v4.3c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6v-4.3c-.1-.3-.3-.5-.5-.8zM34.8 32.3c-.3-.3-.7-.5-1.1-.5-.8 0-1.4.6-1.6 1.3v4.3c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6v-4.3c-.1-.3-.3-.5-.5-.8z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM13.6 11c0-.9.7-1.6 1.6-1.6h25.6c.9 0 1.6.7 1.6 1.6v8.3c-1.7-2.6-4.7-4.3-8-4.3H21.6c-3.3 0-6.3 1.7-8 4.3V11zm30.5 29.7c0 1.3-1.1 2.4-2.4 2.4v2.5c0 1.3-1.1 2.3-2.3 2.3h-.1c-1.3 0-2.3-1.1-2.3-2.3v-2.5H19.2v2.5c0 1.3-1.1 2.3-2.3 2.3h-.1c-1.3 0-2.3-1.1-2.3-2.3v-2.5c-1.3 0-2.4-1.1-2.4-2.4v-9.6c0-.9.5-1.7 1.2-2.1.1-.1.3-.1.4-.2.2-.1.5-.1.8-.1v-4c0-4 3.2-7.2 7.2-7.2h12.8c4 0 7.2 3.2 7.2 7.2v4c.3 0 .6 0 .8.1.1 0 .3.1.4.2.7.4 1.2 1.2 1.2 2.1v9.6z"
    }, {
      "d": "M34.5 22.3H21.6c-1.3 0-2.4 1.1-2.4 2.4v4h17.6v-4c.1-1.4-1-2.4-2.3-2.4zM14.399999999999999 34.7a2 2 0 114 0 2 2 0 11-4 0M37.7 34.7a2 2 0 114 0 2 2 0 11-4 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumTruckPos = {
  "id": "icon--wfp-hum--truck-pos",
  "name": "icon--wfp-hum--truck-pos",
  "tags": "icon--wfp-hum--truck-pos",
  "styles": "",
  "viewBox": "0 0 32 39",
  "width": "32",
  "height": "39",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9.6 6h12.8c3.3 0 6.3 1.7 8 4.3V2c0-.9-.7-1.6-1.6-1.6H3.2c-.9 0-1.6.7-1.6 1.6v8.3C3.3 7.8 6.3 6 9.6 6z"
    }, {
      "fill-rule": "nonzero",
      "d": "M30.9 20c-.1-.1-.3-.1-.4-.2-.2-.1-.5-.1-.8-.1v-4c0-4-3.2-7.2-7.2-7.2H9.6c-4 0-7.2 3.2-7.2 7.2v4c-.3 0-.6 0-.8.1-.1 0-.3.1-.4.2-.7.4-1.2 1.2-1.2 2.1v9.6c0 1.3 1.1 2.4 2.4 2.4v2.5c0 1.3 1.1 2.3 2.3 2.3h.1c1.3 0 2.3-1.1 2.3-2.3v-2.5h17.7v2.5c0 1.3 1.1 2.3 2.3 2.3h.1c1.3 0 2.3-1.1 2.3-2.3v-2.5c1.3 0 2.4-1.1 2.4-2.4v-9.6c.2-.9-.3-1.7-1-2.1zM4.4 27.7c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm7.6.8c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6v-4.3c.1-.7.8-1.3 1.6-1.3.4 0 .8.2 1.1.5.2.2.4.5.4.8v4.3h.1zm5.6 0c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6v-4.3c.1-.7.8-1.3 1.6-1.3.4 0 .8.2 1.1.5.2.2.4.5.4.8v4.3h.1zm5.7 0c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6v-4.3c.1-.7.8-1.3 1.6-1.3.4 0 .8.2 1.1.5.2.2.4.5.4.8v4.3h.1zm1.6-8.8H7.2v-4c0-1.3 1.1-2.4 2.4-2.4h12.8c1.3 0 2.4 1.1 2.4 2.4v4h.1zm2.8 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumVamNeg = {
  "id": "icon--wfp-hum--vam-neg",
  "name": "icon--wfp-hum--vam-neg",
  "tags": "icon--wfp-hum--vam-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M25.9 25.1c-.2-.8-.3-1.4-.4-1.8-.1.3-.2.9-.3 1.6-.2.8-.5 2.2-1.1 4.4h3l-.6-2.3c-.3-.4-.4-1.1-.6-1.9z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM9.9 35.1l-4.6-14h4.3l1.9 7.1c.4 1.6.6 2.7.7 3.3 0-.4.1-1 .3-1.7.1-.7.3-1.2.4-1.6l2-7.2H19l-4.6 14.1H9.9zm18.6 0l-.7-2.6h-4.6l-.7 2.6h-4.2L22.9 21H28l4.7 14.1h-4.2zm22.8 0h-3.5V27.9c0-.4.1-1.4.1-2.9h-.1L45 35.1h-3.6L38.6 25h-.1c.1 1.7.2 3.1.2 4v6.1h-3.4v-14h5.1l2.9 10h.1l2.9-10h5.1v14h-.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumVamPos = {
  "id": "icon--wfp-hum--vam-pos",
  "name": "icon--wfp-hum--vam-pos",
  "tags": "icon--wfp-hum--vam-pos",
  "styles": "",
  "viewBox": "0 0 47 15",
  "width": "47",
  "height": "15",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M41.3.1l-2.9 10h-.1L35.4.1h-5.1v14.1h3.4V8c0-1-.1-2.3-.2-4h.1l2.9 10.1h3.6L42.9 4h.1c-.1 1.5-.1 2.5-.1 2.9v7.3h3.5V.1h-5.1zM9.8.1l-2 7.2c-.1.4-.2.9-.4 1.6-.1.7-.2 1.2-.3 1.7 0-.6-.3-1.7-.7-3.3L4.5.2H.3l4.6 14.1h4.5L14 .1H9.8z"
    }, {
      "fill-rule": "nonzero",
      "d": "M17.9 0l-4.6 14.1h4.2l.7-2.6h4.6l.7 2.6h4.2L23 0h-5.1zM19 8.4c.6-2.2 1-3.7 1.1-4.4.2-.8.3-1.3.3-1.6.1.4.2.9.4 1.8.2.8.4 1.5.5 2l.6 2.3H19v-.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumVoucherNeg = {
  "id": "icon--wfp-hum--voucher-neg",
  "name": "icon--wfp-hum--voucher-neg",
  "tags": "icon--wfp-hum--voucher-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M39.4 32.5H27.5c-.5 0-.9.4-.9.9s.4.9.9.9h11.9c.5 0 .9-.4.9-.9s-.4-.9-.9-.9zm0-5.7H27.5c-.5 0-.9.4-.9.9s.4.9.9.9h11.9c.5 0 .9-.4.9-.9s-.4-.9-.9-.9zm-19.8-2.2c-.5 0-.9.4-.9.9v4c0 .5.4.9.9.9s.9-.4.9-.9v-4c0-.5-.4-.9-.9-.9z"
    }, {
      "fill-rule": "nonzero",
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm-4 22.9c-2.3.4-4 2.4-4 4.8s1.7 4.3 4 4.8v5.1c0 .6-.5 1.1-1.1 1.1H20.5v-4.4c0-.5-.4-.9-.9-.9s-.9.4-.9.9v4.4H7.5c-.6 0-1.1-.5-1.1-1.1v-5.1c2.3-.4 4-2.4 4-4.8s-1.7-4.3-4-4.8v-5.1c0-.6.5-1.1 1.1-1.1h11.2v4c0 .5.4.9.9.9s.9-.4.9-.9v-4h28.8c.6 0 1.1.5 1.1 1.1v5.1z"
    }, {
      "d": "M39.4 20.7H27.5c-.5 0-.9.4-.9.9s.4.9.9.9h11.9c.5 0 .9-.4.9-.9s-.4-.9-.9-.9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumVoucherPos = {
  "id": "icon--wfp-hum--voucher-pos",
  "name": "icon--wfp-hum--voucher-pos",
  "tags": "icon--wfp-hum--voucher-pos",
  "styles": "",
  "viewBox": "0 0 45 23",
  "width": "45",
  "height": "23",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M44.4 6.9V1.8c0-.6-.5-1.1-1.1-1.1H14.5v4c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-4H1.5C.9.7.4 1.2.4 1.8v5.1c2.3.4 4 2.4 4 4.8s-1.7 4.3-4 4.8v5.1c0 .6.5 1.1 1.1 1.1h11.2v-4.4c0-.5.4-.9.9-.9s.9.4.9.9v4.4h28.8c.6 0 1.1-.5 1.1-1.1v-5.1c-2.3-.4-4-2.4-4-4.8s1.7-4.3 4-4.8zm-29.9 6.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-4c0-.5.4-.9.9-.9s.9.4.9.9v4zm18.9 4.8H21.5c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h11.9c.5 0 .9.4.9.9s-.4.9-.9.9zm0-5.7H21.5c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h11.9c.5 0 .9.4.9.9s-.4.9-.9.9zm0-6.2H21.5c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h11.9c.5 0 .9.4.9.9s-.4.9-.9.9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumWarehouseNeg = {
  "id": "icon--wfp-hum--warehouse-neg",
  "name": "icon--wfp-hum--warehouse-neg",
  "tags": "icon--wfp-hum--warehouse-neg",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M14.6 19.9v21.5h27.5V19.9l-13.8-7.1-13.7 7.1zm25 1.5v16.5c0 .5-.4.9-.9.9H18.1c-.5 0-.9-.4-.9-.9V21.4c0-.5.4-.9.9-.9h20.5c.5 0 1 .4 1 .9z"
    }, {
      "d": "M54.4 0h-52C1.1 0 0 1.1 0 2.4v51.3c0 1.3 1.1 2.4 2.4 2.4h52c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zM45 44.2H11.8V19.6c0-.6.3-1.2.7-1.7l.3-.2L27 10.4c.8-.6 1.9-.6 2.6 0L44.1 18c.5.4.7 1 .7 1.7v24.5h.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpHumWarehousePos = {
  "id": "icon--wfp-hum--warehouse-pos",
  "name": "icon--wfp-hum--warehouse-pos",
  "tags": "icon--wfp-hum--warehouse-pos",
  "styles": "",
  "viewBox": "0 0 34 36",
  "width": "34",
  "height": "36",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "fill-rule": "nonzero",
      "d": "M33.2 8.9L18.7 1.3c-.8-.6-1.9-.6-2.6 0L1.9 8.6l-.3.2c-.5.4-.7 1-.7 1.7v24.6H34V10.6c0-.7-.3-1.3-.8-1.7zm-2 23.5H3.6V10.9l13.8-7.1 13.8 7.1v21.5z"
    }, {
      "d": "M6.2 12.4v16.5c0 .5.4.9.9.9h20.5c.5 0 .9-.4.9-.9V12.4c0-.5-.4-.9-.9-.9H7.1c-.5 0-.9.4-.9.9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpLogoAcronym = {
  "id": "icon--wfp-logo--acronym",
  "name": "icon--wfp-logo--acronym",
  "tags": "icon--wfp-logo--acronym",
  "styles": "",
  "viewBox": "0 0 57 20",
  "width": "57",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M47.303 9.618h1.368c1.278 0 2.235-.253 2.871-.76.634-.505.952-1.241.952-2.206 0-.975-.267-1.694-.798-2.159-.533-.465-1.366-.7-2.502-.7h-1.891v5.825zm9.39-3.114c0 2.111-.66 3.726-1.979 4.842-1.319 1.12-3.195 1.678-5.627 1.678h-1.784V20h-4.159V.386h6.264c2.379 0 4.187.512 5.426 1.538 1.24 1.024 1.859 2.55 1.859 4.58zM33.185 20h-4.09V.386h11.241v3.407h-7.151v5.06h6.655v3.394h-6.655V20zm-11.613 0h-4.736L14.18 9.697c-.099-.367-.266-1.124-.503-2.274s-.374-1.921-.409-2.313c-.054.483-.188 1.259-.402 2.327a52.937 52.937 0 01-.497 2.288L9.726 20H5.005L0 .386h4.092l2.509 10.706c.438 1.977.755 3.69.952 5.139.054-.51.176-1.3.369-2.367.192-1.07.373-1.901.544-2.489L11.322.386h3.931l2.858 10.989c.125.491.282 1.243.47 2.253.187 1.011.33 1.878.429 2.603.088-.699.232-1.568.428-2.61a47.82 47.82 0 01.538-2.529L22.47.386h4.092L21.572 20z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpLogoEmblem = {
  "id": "icon--wfp-logo--emblem",
  "name": "icon--wfp-logo--emblem",
  "tags": "icon--wfp-logo--emblem",
  "styles": "",
  "viewBox": "0 0 57 57",
  "width": "57",
  "height": "57",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M35.956 3.715h.55c.515 0 .9-.101 1.156-.306.255-.203.384-.5.384-.887 0-.392-.108-.682-.322-.87-.214-.187-.55-.282-1.007-.282h-.761v2.345zm3.78-1.253c0 .85-.265 1.5-.797 1.949-.531.451-1.285.675-2.264.675h-.72v2.809h-1.673V0h2.521c.958 0 1.686.205 2.185.618.499.413.748 1.027.748 1.844zm-9.589 5.433h-1.646V0h4.526v1.37h-2.88v2.037h2.68v1.367h-2.68v3.12zm-4.55 0h-1.905l-1.07-4.148a19.26 19.26 0 01-.202-.915c-.095-.463-.15-.773-.164-.932a12.35 12.35 0 01-.162.937c-.087.43-.154.738-.2.921L20.83 7.895h-1.9L16.915 0h1.647l1.01 4.308c.176.797.304 1.486.383 2.07.021-.206.07-.523.15-.954.076-.43.149-.764.217-1.001L21.472 0h1.583l1.15 4.423a23.745 23.745 0 01.362 1.955c.035-.282.094-.632.172-1.051.08-.418.152-.758.216-1.019L25.96 0h1.647l-2.01 7.895zm-4.093 27.461c-3.068 0-5.037.728-5.574.954-.033.014-.058-.031-.035-.056 3.373-3.504 7.319-3.311 8.268-3.311h11.223c.565 0 1.023.54 1.023 1.208 0 .665-.458 1.205-1.023 1.205H21.504zm2.527 3.102c-3.304 0-4.268-1.878-9.27-.639-.036.01-.059-.038-.03-.058 2.79-1.913 5.823-1.74 7.05-1.74h13.605c.565 0 1.023.54 1.023 1.206 0 .666-.458 1.206-1.023 1.206 0 0-8.738.025-11.355.025zm.236 3.053c-3.394 0-3.665-2.503-8.694-3.067-.035-.004-.04-.057-.005-.065 4.132-1.033 5.67.72 8.081.72h11.737c.565 0 1.023.54 1.023 1.206 0 .666-.458 1.206-1.023 1.206h-11.12zm-.737-9.233c-2.731 0-4.995 1.192-5.525 1.492-.03.017-.06-.019-.04-.046.443-.652 2.835-3.858 6.948-3.858h10.473c.565 0 1.023.54 1.023 1.207 0 .665-.458 1.205-1.023 1.205H23.53zm15.022-6.66a.76.76 0 00-.446-.207.743.743 0 00-.364.044 1.09 1.09 0 00.103-.331.866.866 0 00-.085-.516c-.337-.74.629-2.221.507-2.287-.117-.065-.665 1.568-1.198 2.228a.93.93 0 00-.2.491.92.92 0 00.086.516c.074.134.188.227.32.235a.28.28 0 00.108-.006.271.271 0 00-.019.06.456.456 0 00.143.39c.106.111.26.187.443.208a.774.774 0 00.496-.094c.723-.395 2.222-.785 2.19-.924-.028-.138-1.49.72-2.084.192zm1.106-1.08a.635.635 0 00-.41-.2.66.66 0 00-.27.043c.014-.047.033-.086.038-.132a.736.736 0 00-.102-.464c-.367-.681.59-1.967.466-2.03-.124-.065-.65 1.375-1.181 1.944a.694.694 0 00-.2.427.776.776 0 00.101.468.501.501 0 00.341.23.54.54 0 00.18-.021c-.003.008-.011.018-.009.026a.533.533 0 00.14.401.643.643 0 00.407.195.621.621 0 00.435-.117c.623-.45 2.047-.716 2.01-.86-.033-.14-1.397.614-1.946.09zm.968-.999a.553.553 0 00-.39-.104.539.539 0 00-.198.05c.01-.03.029-.053.039-.083a.704.704 0 00-.024-.432c-.233-.668.797-1.656.696-1.737-.1-.075-.767 1.123-1.316 1.545a.645.645 0 00-.232.355.639.639 0 00.021.43c.056.126.145.22.267.257.092.029.184.01.271-.027a.413.413 0 00-.024.17c.014.137.08.252.188.332a.572.572 0 00.757-.067c.494-.5 1.723-.966 1.673-1.087-.053-.12-1.158.77-1.728.398zm1.905-2.145c-.103-.152-.963.79-1.6.881a.666.666 0 00-.36.18.704.704 0 00-.223.362.381.381 0 00.056.326c.071.087.18.124.301.11a.654.654 0 00.367-.181.748.748 0 00.215-.358c.193-.647 1.32-1.222 1.244-1.32zm-17.79 1.277c-.026.093-.211.82-.211.82-.052.03-.274-.02-.333-.024-.424-.04-.803-.41-.64-.85.132-.36.406-.398.752-.414.143-.006.402.028.53.118 0 0-.05.166-.098.35zm-.487 2.193a6.794 6.794 0 00-.04.249c-.264-.166-.42-.545-.293-.845.097-.227.339-.286.517-.296-.064.296-.127.593-.184.892zm-.38 2.712c-.035.186-.286.21-.458.261-.499.15-.97.086-1.124-.51-.166-.638.317-.905.834-1.03.283-.067.543-.012.736.226.049.06.106.113.12.17 0 0-.077.707-.109.883zm-1.571-3.14c.385-.092.783-.237 1.079.143.312.397.209 1.035-.293 1.204-.33.112-.728.208-1.01-.061-.37-.353-.343-1.154.224-1.286zm-.377-2.067c.406-.099.825-.248 1.137.15.325.416.216 1.09-.309 1.266-.347.114-.768.216-1.063-.067-.388-.369-.36-1.21.235-1.35zm-.377 4.469c-.106.372-.412.427-.734.506-.211-.26-.778-.915-.788-.993a.206.206 0 01.012-.09c.026-.078.116-.152.182-.194.193-.126.604-.22.826-.174.398.085.608.572.502.945zm-2.017-1.91c-.29-1.029 1.436-1.477 1.702-.468.275 1.038-1.467 1.478-1.702.469zm-.253-2.054c-.296-1.023 1.438-1.472 1.705-.468.274 1.04-1.47 1.48-1.705.468zm-.243-2.02c-.282-.953 1.346-1.376 1.594-.436.256.968-1.372 1.385-1.594.436zm-.165 3.888c-.08.047-.111.072-.137.072l-.775-.842c.01-.024.249-.198.328-.244.644-.358 1.174.666.584 1.014zm-1.47-1.898c-.383-.844 1.01-1.76 1.432-.85.388.84-1.005 1.771-1.432.85zm1.17-2.674c.442.783-.886 1.657-1.266.814-.338-.726.843-1.573 1.267-.814zm-1.112-1.825c.195-.173.422-.266.654-.155.372.18.382.737.058.96-.148.101-.398.227-.58.181-.399-.101-.475-.682-.132-.986zm.05-1.678c.161-.109.375-.206.56-.13.335.137.323.625.051.82-.123.088-.347.198-.498.158-.34-.086-.425-.638-.113-.848zm.892-2.39c.2-.108.488-.153.667.047a.47.47 0 01-.134.738c-.214.107-.502.147-.67-.05a.483.483 0 01.137-.736zm-.159 1.816c-.16-.598.847-.88 1.01-.273.183.592-.849.885-1.01.273zm1.626 1.045c.234.646-.86 1.013-1.075.374-.218-.647.882-1.016 1.075-.374zm.137-3.15c.209-.084.477-.173.71 0 .29.217.227.705-.106.857-.22.1-.499.166-.694-.007-.248-.222-.261-.709.09-.85zm-.192 5.41c-.296.07-.606.187-.851-.067-.314-.323-.223-.89.201-1.044.275-.105.622-.163.847.066.287.295.256.935-.197 1.045zm.005-3.302c-.19-.641.854-.97 1.055-.348.205.64-.876.978-1.055.348zm1.75 1.175c.244.732-.993 1.122-1.22.401-.23-.736 1.015-1.128 1.22-.4zm.065-1.96c.218-.059.449-.037.615.14.253.273.166.738-.21.808-.175.032-.447.019-.585-.102-.248-.219-.236-.735.18-.846zm1.055 1.536c.398 0 .6.585.367.876-.14.177-.44.187-.646.156-.38-.06-.624-.548-.367-.88.155-.2.422-.152.646-.152zm-1.912 2.41c-.247-.842 1.184-1.219 1.403-.383.222.85-1.216 1.225-1.403.383zm.876 1.076c.39-.04.797-.13 1.036.278.25.433.063 1.034-.442 1.136-.334.069-.737.101-.975-.194-.311-.389-.187-1.167.38-1.22zm1.985-1.874c.482.199.645.768.305 1.086-.182.166-.515.133-.74.088-.448-.088-.741-.762-.348-1.082.202-.164.563-.184.783-.092zm.758 2.029c.304.372.19 1.028-.34 1.06-.277.017-.639-.016-.826-.243-.3-.363-.187-1.044.343-1.063.277-.01.636.02.823.246zm2.05-6.7a.121.121 0 00-.134-.05c-.064.02-.106.09-.082.151 1.212 3.255-.335 4.857-.981 7.136-.776-1.851 1.794-3.593.47-6.967a.136.136 0 00-.101-.085c-.065-.01-.129.018-.14.106-.034.238-.19 2.107-1.707 3.203a3.031 3.031 0 00-.707-1.026c-.14-.63-.55-1.496-1.417-1.752-.13-.326-.39-.794-.891-1.045-.473-.235-1.02-.213-1.626.062-.734.085-1.238.371-1.504.849-.25.451-.206.943-.122 1.278-.617.66-.646 1.636-.63 2.02-.367.88-.161 1.909-.045 2.336-.438 1.198-.01 2.359.16 2.744 0 .104.006.203.011.303-1.435-1.572-4.702-3.517-5.95-4.26a.15.15 0 00-.182.022.155.155 0 00-.008.219c2.784 2.715 5.268 6.065 7.653 13.016 1.189-1.238 3.34-2.864 6.401-2.864h3.58c-2.274-8.474 1.037-11.506-2.048-15.396zm16.928 4.381c-.655-.17-4.834-.91-9.518 7.705.683-3.209 2.76-7.09 3.33-8.218v-.008a.155.155 0 00-.042-.192.135.135 0 00-.19.035c-3.096 5.161-4.183 8.134-4.823 11.693h1.938c.33-3.43 4.663-11.512 9.28-10.91h.007c.026.005.049-.017.052-.04a.048.048 0 00-.034-.065zM34.06 46.555l-1.047-4.38h-1.784c.283 1.112.687 2.243 1.21 3.233.033.059.096.095.16.084.084-.011.15-.1.134-.191-.121-.926-.266-1.821-.403-2.714.377 1.403.887 2.773 1.573 4.035.018.04.058.058.094.045.05-.01.077-.064.063-.112zm1.803-1.988c-.182-.732-.372-1.63-.536-2.391h-.677c.263.812.62 1.718.936 2.493.032.075.103.112.172.093a.16.16 0 00.105-.195zm.226 2.575l-.005-.01c-.219-.613-.521-1.16-.762-1.748a22.902 22.902 0 01-.71-1.767c-.172-.453-.354-.97-.493-1.441h-.655c.185.548.425 1.138.65 1.667.492 1.194 1.062 2.365 1.788 3.411a.102.102 0 00.124.036.116.116 0 00.063-.148zm.98-21.014c-.05-.075-.171-.091-.23-.03a13.419 13.419 0 00-2.158 3.086h.707c.353-.83 1.15-2.298 1.663-2.827l.005-.005a.181.181 0 00.013-.224zm-5.382-6.078c.653-1.074 1.624-1.897 2.448-2.89a.1.1 0 00-.008-.129.084.084 0 00-.119-.003 11.65 11.65 0 01-.583.575c-.087-.043-.309.042-.533.218-.177.14-.304.295-.349.406-.113-.026-.327.108-.519.353-.158.207-.25.423-.249.556-.12.01-.298.166-.447.412-.099.163-.162.32-.183.451a1.234 1.234 0 00-.311.355c-.135.225-.203.452-.182.583-.032.056-.063.11-.09.166l.016-.134c.193-1.52.472-3.027.897-4.48.427-1.449.94-2.91 1.818-4.082l.005-.006a.167.167 0 00-.016-.211.138.138 0 00-.206-.003 6.66 6.66 0 00-.788 1.056c-.1-.054-.312.144-.473.454-.147.28-.2.539-.145.638 0 0-.002.009-.008.005-.105-.045-.3.19-.419.505-.116.297-.138.57-.058.66-.005.006-.005.009-.008.014-.119-.043-.312.227-.43.61-.098.323-.108.602-.038.715.006.005 0 .02-.005.016-.121-.043-.305.235-.414.614-.108.366-.1.69.003.753-.119-.013-.285.265-.372.642-.08.326-.071.606.005.719-.117.034-.245.306-.312.66-.063.344-.03.63.054.721-.109.056-.22.336-.26.684-.039.345.011.627.1.719-.089.1-.176.342-.212.63-.037.275-.014.513.039.647-.098.082-.172.36-.174.695-.008.266.031.493.1.624-.053.134-.09.329-.09.545-.005.281.04.52.11.646a42.41 42.41 0 00.046 3.025h2.13c.015-.77.065-1.608.142-2.37.151-1.356.374-2.735 1.053-3.895l.005-.008a.114.114 0 00-.013-.128c-.04-.035-.096-.035-.132.008-.92 1.069-1.325 2.52-1.562 3.911a20.57 20.57 0 00-.108.82c.057-1.116.16-2.228.416-3.286.294-1.288.879-2.514 1.995-3.2a.1.1 0 00.04-.113.093.093 0 00-.111-.066c-.07.02-.137.059-.205.088-.075-.091-.346-.024-.626.155-.266.173-.443.387-.425.505 0 .005-.013.013-.013.002-.002-.013-.005-.026-.013-.034-.1-.083-.37.104-.596.422-.23.318-.32.65-.223.735.006.002.003.01-.002.01-.118-.047-.316.222-.44.6-.09.263-.112.507-.08.646 0 .005-.004.01-.004.01-.093.304-.17.612-.24.924.025-.44.065-.884.128-1.322.188-1.261.568-2.495 1.244-3.548zm6.699-3.516a.75.75 0 00-.489-.038.805.805 0 00-.327.171.93.93 0 00-.018-.347.842.842 0 00-.253-.451c-.576-.574-.18-2.304-.315-2.325-.132-.018-.084 1.705-.356 2.512a.916.916 0 00-.018.532c.047.19.142.35.26.453.114.1.252.145.38.105a.223.223 0 00.098-.043c0 .022 0 .043.003.064.03.142.13.251.267.315.14.067.311.083.49.038a.787.787 0 00.43-.262c.541-.628 1.813-1.523 1.737-1.643-.076-.117-1.15 1.202-1.89.92zm2.458-2.177c-.081-.118-1.1 1.07-1.794.775a.639.639 0 00-.453-.043.707.707 0 00-.238.133c-.002-.048 0-.09-.01-.133a.715.715 0 00-.256-.4c-.581-.508-.125-2.053-.261-2.069-.14-.016-.138 1.52-.439 2.242a.69.69 0 00-.037.47c.042.17.138.313.257.403a.487.487 0 00.396.094.474.474 0 00.16-.083c0 .008-.002.018 0 .026a.532.532 0 00.272.329.65.65 0 00.815-.224c.43-.644 1.67-1.397 1.588-1.52zm.251-1.488c-.09-.094-.82 1.13-1.483.983a.554.554 0 00-.4.04.548.548 0 00-.17.118c0-.03.008-.06.008-.09a.68.68 0 00-.172-.397c-.445-.545.175-1.835.057-1.875-.122-.035-.333 1.322-.702 1.913a.626.626 0 00-.096.414c.01.157.077.3.17.398a.428.428 0 00.337.144.373.373 0 00.245-.12.44.44 0 00.325.411c.124.04.272.03.403-.034a.607.607 0 00.286-.294c.29-.644 1.279-1.518 1.192-1.611zm-.438-1.7c-.15-.106-.627 1.082-1.195 1.392a.693.693 0 00-.277.296.722.722 0 00-.08.418.367.367 0 00.165.286.323.323 0 00.316-.003.749.749 0 00.36-.714c-.041-.672.817-1.607.711-1.675zM30.243 42.176h-5.976a6.192 6.192 0 01-1.11-.092c.983 1.46 2.521 2.566 4.08 3.308.24 1.33.542 2.562.65 2.659.11.095 1.641-.345 1.688-.487.044-.14-.625-2.42-.625-2.42.804-1.382 1.053-2.196 1.293-2.968zM45.278 52.4c-1.51.596-3.478.647-5.085.22-3.681-1.147-7.768-3.319-11.692-1.516-3.924-1.803-8.01.37-11.692 1.515-1.606.428-3.575.377-5.084-.219a.038.038 0 00-.037.067c2.171 1.68 5.214 2.453 7.953 1.463 2.63-.819 4.855-3.605 7.97-2.417-2.466.965-4.772 2.744-6.554 4.424L22.353 57c1.618-1.883 3.438-3.766 5.499-4.913.282-.165.451-.232.65-.243.197.011.365.078.646.243 2.063 1.147 3.884 3.03 5.502 4.913l1.295-1.063c-1.781-1.68-4.087-3.46-6.555-4.424 3.117-1.188 5.341 1.598 7.972 2.417 2.739.99 5.781.217 7.952-1.463.034-.03.006-.083-.036-.067zm-24.26-2.538c-3.847-.933-4.9-4.54-8.117-6.105-.034-.018-.071.023-.05.054 1.014 1.667 1.562 4.22 4.483 5.795.024.012.011.05-.015.042-4.19-.806-5.95.315-10.342-1.67-.036-.016-.076.024-.052.06 1.444 2.094 4.868 3.526 9.56 3.13 1.689-.143 2.912-.854 4.533-1.233.04-.011.04-.066 0-.073zM12.96 47.65c-1.462-1.915-1.045-6.004-4.346-9.747-.027-.03-.074-.006-.066.031.63 2.757.443 5.889 2.169 8.183.016.024-.008.048-.032.032-3.404-2.68-6.903-3.486-8.46-5.655-.023-.03-.07-.013-.066.024.386 2.808 5.78 7.184 10.771 7.192.03 0 .049-.034.03-.06zm-5.11-5.091c-1.568-2.907.305-7.342-1.474-11.651-.018-.045-.087-.034-.087.014-.053 2.353-1.514 5.867-.63 8.52.01.023-.022.036-.035.015C3.373 36.167 1.587 35.481.1 32.47c-.02-.045-.09-.033-.092.016-.095 2.046.81 3.714 1.83 5.263A17.484 17.484 0 007.8 42.611c.034.016.065-.019.05-.053zM6.784 24.856c-.003-.048-.066-.064-.09-.022-1.195 2.237-3.324 4.016-3.392 6.969-.003.029-.036.031-.04.005-.389-2.28-2.322-4.833-2.407-8.133 0-.05-.071-.063-.09-.015-1.59 4.29.698 8.358 3.133 11.72.026.033.078.013.078-.033-.1-3.561 2.987-6.22 2.808-10.49zm1.52-5.552c-1.13 1.569-3.67 2.678-4.6 4.94-.012.032-.052.024-.047-.013.37-2.536-.609-5.48.31-8.848.012-.048-.048-.08-.077-.043-1.388 1.707-1.858 3.708-1.935 5.87-.094 2.655.84 4.591 1.301 6.392.01.043.067.04.077-.003.665-2.36 4.002-3.782 5.048-8.256.013-.049-.048-.079-.076-.039zm3.064-5.273c-1.858 1.456-4.694 2.858-5.305 3.87-.01.022-.04.006-.036-.015l.689-3.305c.309-1.403.575-2.746 1.35-4.002.024-.037-.02-.08-.055-.053-3.535 2.8-3.018 6.85-3.174 10.165-.002.035.04.051.063.027 2.082-2.257 5.476-3.572 6.525-6.642.013-.037-.026-.07-.057-.045zM14 8.955c-3.124.099-5.419 2.73-6.403 6.08-.006.02.02.035.036.024 4.304-3.155 4.064-4.507 6.393-6.008.043-.027.025-.096-.026-.096zm36.022 39.023c-4.387 1.985-6.15.864-10.34 1.67-.026.008-.04-.03-.015-.042 2.92-1.574 3.47-4.128 4.483-5.795.02-.031-.017-.072-.05-.054-3.215 1.566-4.267 5.172-8.117 6.105-.04.007-.04.062 0 .073 1.62.379 2.844 1.09 4.533 1.233 4.692.396 8.119-1.036 9.56-3.13.024-.036-.016-.076-.054-.06zm4.753-7.485c-1.556 2.169-5.055 2.976-8.46 5.655-.02.016-.047-.008-.029-.032 1.724-2.294 1.536-5.426 2.167-8.183.008-.037-.04-.06-.066-.031-3.298 3.743-2.884 7.832-4.343 9.747-.019.026-.003.06.028.06 4.993-.008 10.384-4.384 10.768-7.192.006-.037-.042-.053-.065-.024zm2.22-8.007c-.003-.049-.072-.06-.093-.016-1.488 3.01-3.275 3.697-5.522 6.986-.017.021-.045.008-.038-.016.884-2.652-.575-6.166-.63-8.519 0-.048-.07-.06-.087-.014-1.779 4.31.094 8.744-1.47 11.651-.018.034.013.07.047.053a17.494 17.494 0 005.961-4.862c1.02-1.55 1.927-3.217 1.831-5.263zm-.761-8.826c-.018-.048-.09-.035-.09.015-.084 3.3-2.018 5.854-2.405 8.133-.007.026-.038.024-.038-.005-.068-2.953-2.2-4.732-3.396-6.969a.046.046 0 00-.086.022c-.18 4.271 2.904 6.93 2.804 10.491 0 .046.055.066.082.032 2.432-3.361 4.72-7.429 3.129-11.72zm-1.19-2.45c-.077-2.162-.545-4.163-1.934-5.87-.029-.037-.087-.005-.076.043.918 3.368-.062 6.312.311 8.848.005.037-.037.045-.05.013-.929-2.262-3.47-3.371-4.6-4.94-.026-.04-.086-.01-.076.039 1.045 4.474 4.383 5.895 5.047 8.256.011.043.066.046.078.003.461-1.8 1.395-3.737 1.3-6.392zm-6.055-10.684c-.035-.027-.08.016-.056.053.776 1.256 1.042 2.6 1.35 4.002l.69 3.305c.006.02-.027.037-.037.016-.61-1.013-3.443-2.415-5.304-3.871-.03-.024-.072.008-.058.045 1.05 3.07 4.443 4.385 6.526 6.642.023.024.065.008.063-.027-.156-3.315.361-7.365-3.174-10.165zM43 8.956c-.05 0-.067.068-.027.095 2.33 1.501 2.09 2.853 6.394 6.008.018.011.042-.005.036-.024-.984-3.35-3.28-5.981-6.403-6.08z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpLogoExtendedEn = {
  "id": "icon--wfp-logo--extended--en",
  "name": "icon--wfp-logo--extended--en",
  "tags": "icon--wfp-logo--extended--en",
  "styles": "",
  "viewBox": "0 0 223 58",
  "width": "223",
  "height": "58",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M35.934 4.664h.548c.511 0 .894-.101 1.149-.304.254-.202.381-.497.381-.883 0-.39-.107-.678-.319-.865-.214-.186-.547-.28-1.002-.28h-.757v2.332zm3.76-1.246c0 .845-.265 1.491-.793 1.938-.528.449-1.279.672-2.253.672h-.714v2.793h-1.665V.969h2.508c.952 0 1.676.204 2.172.615.497.41.745 1.021.745 1.834zm-9.537 5.403h-1.638V.969h4.501v1.363h-2.863v2.026h2.664v1.359h-2.664v3.104zm-4.525 0h-1.896l-1.063-4.125c-.04-.147-.107-.45-.202-.91-.095-.461-.149-.77-.164-.927-.021.194-.075.505-.161.932-.086.428-.152.734-.198.916l-1.059 4.114h-1.89L16.995.969h1.638l1.005 4.285c.175.792.302 1.478.381 2.058.022-.204.071-.52.148-.948.077-.429.149-.761.217-.996L21.529.969h1.573l1.144 4.399c.051.196.113.498.188.902.075.405.133.752.172 1.042.036-.28.093-.628.172-1.045.079-.417.15-.754.215-1.013l.999-4.285h1.638l-1.998 7.852zm-4.073 27.313c-3.051 0-5.009.724-5.544.949-.031.014-.057-.031-.033-.056 3.353-3.485 7.278-3.293 8.223-3.293h11.161c.563 0 1.018.537 1.018 1.201 0 .662-.455 1.199-1.018 1.199H21.559zm2.515 3.085c-3.288 0-4.246-1.868-9.222-.635-.034.009-.057-.038-.028-.058 2.774-1.903 5.791-1.73 7.011-1.73h13.531c.563 0 1.018.537 1.018 1.199s-.455 1.199-1.018 1.199c0 0-8.689.025-11.292.025zm.233 3.037c-3.374 0-3.645-2.49-8.646-3.051-.035-.004-.039-.056-.005-.064 4.109-1.028 5.638.715 8.037.715h11.673c.563 0 1.018.537 1.018 1.2 0 .663-.455 1.2-1.018 1.2H24.307zm-.732-9.183c-2.717 0-4.968 1.185-5.496 1.484-.028.016-.058-.019-.039-.046.44-.649 2.82-3.837 6.91-3.837h10.416c.563 0 1.018.537 1.018 1.2 0 .662-.455 1.199-1.018 1.199H23.575zm14.941-6.625a.756.756 0 00-.444-.205.74.74 0 00-.362.043c.047-.099.087-.205.102-.33a.843.843 0 00-.084-.512c-.336-.736.625-2.209.504-2.275-.115-.064-.661 1.56-1.191 2.216a.926.926 0 00-.2.489.915.915 0 00.087.513c.073.132.186.226.317.234a.3.3 0 00.108-.006.222.222 0 00-.018.059.455.455 0 00.141.388.72.72 0 00.441.207.771.771 0 00.494-.093c.719-.393 2.209-.781 2.178-.919-.029-.138-1.483.715-2.073.191zm1.1-1.074a.638.638 0 00-.407-.199.657.657 0 00-.268.043c.013-.046.031-.085.037-.131a.726.726 0 00-.103-.462c-.364-.677.588-1.956.465-2.019-.123-.064-.646 1.368-1.176 1.934a.69.69 0 00-.197.425.765.765 0 00.1.465c.084.123.199.21.338.229a.53.53 0 00.179-.021c-.003.007-.01.018-.008.026a.524.524 0 00.139.398c.1.107.244.181.404.195a.626.626 0 00.434-.117c.619-.447 2.036-.712 1.999-.856-.034-.138-1.391.611-1.936.09zm.962-.993a.548.548 0 00-.388-.104.536.536 0 00-.197.051c.011-.03.029-.054.04-.083a.7.7 0 00-.024-.43c-.231-.665.792-1.648.693-1.728-.1-.074-.764 1.117-1.31 1.536a.648.648 0 00-.231.354.642.642 0 00.021.428.436.436 0 00.265.255c.092.029.184.01.27-.027a.425.425 0 00-.023.17c.013.136.079.25.186.33a.572.572 0 00.753-.067c.491-.497 1.714-.962 1.665-1.081-.053-.12-1.153.765-1.72.396zm1.895-2.134c-.102-.151-.958.787-1.59.877a.665.665 0 00-.36.178.688.688 0 00-.22.361.376.376 0 00.055.324.325.325 0 00.299.109.64.64 0 00.365-.181.737.737 0 00.215-.356c.192-.643 1.313-1.214 1.236-1.312zm-17.694 1.27c-.026.093-.209.816-.209.816-.053.029-.273-.019-.331-.024-.423-.04-.8-.407-.638-.845.133-.358.404-.396.748-.412.143-.006.4.028.529.117 0 0-.051.165-.099.348zm-.485 2.182l-.039.247c-.263-.165-.418-.542-.292-.84.097-.226.338-.285.515-.295a49.8 49.8 0 00-.184.888zm-.378 2.696c-.033.185-.283.21-.454.261-.496.149-.966.085-1.118-.508-.165-.634.315-.901.83-1.025.28-.066.54-.011.731.226.049.059.105.112.119.168 0 0-.077.704-.108.878zm-1.561-3.122c.382-.092.779-.236 1.073.141.309.396.207 1.031-.292 1.199-.327.111-.724.207-1.004-.061-.368-.351-.342-1.148.223-1.279zm-.376-2.056c.404-.098.821-.247 1.132.149.322.414.214 1.084-.308 1.259-.346.114-.763.215-1.057-.067-.386-.366-.357-1.203.233-1.341zm-.375 4.445c-.105.37-.409.425-.73.502-.21-.257-.773-.909-.783-.986a.205.205 0 01.012-.09c.026-.077.116-.151.181-.194.191-.125.601-.217.821-.172.397.085.604.568.499.94zm-2.005-1.899c-.289-1.024 1.428-1.47 1.693-.466.273 1.032-1.459 1.47-1.693.466zm-.252-2.044c-.294-1.017 1.43-1.464 1.695-.465.273 1.033-1.462 1.472-1.695.465zm-.241-2.009c-.281-.948 1.338-1.368 1.585-.433.254.962-1.365 1.377-1.585.433zm-.166 3.867c-.08.047-.109.072-.136.072l-.77-.838c.009-.024.247-.196.326-.242.641-.356 1.168.662.58 1.008zm-1.462-1.887c-.38-.84 1.006-1.751 1.426-.845.385.834-1 1.761-1.426.845zm1.166-2.66c.438.779-.882 1.648-1.26.81-.336-.722.837-1.565 1.26-.81zm-1.108-1.815c.195-.172.42-.265.651-.154.37.178.381.733.058.954-.147.101-.397.226-.578.181-.396-.101-.472-.68-.131-.981zm.05-1.669c.16-.108.373-.205.556-.13.335.137.323.622.053.816-.124.088-.347.197-.496.157-.339-.085-.422-.634-.113-.843zm.887-2.378c.199-.107.486-.152.664.048a.468.468 0 01-.134.734c-.212.106-.498.146-.666-.051a.48.48 0 01.136-.731zm-.157 1.807c-.161-.595.842-.876 1.005-.271.181.587-.845.88-1.005.271zm1.616 1.039c.234.643-.855 1.007-1.068.372-.218-.643.877-1.01 1.068-.372zm.137-3.133c.208-.083.474-.173.706 0 .288.216.225.702-.105.853-.218.099-.496.165-.691-.008-.246-.22-.26-.705.09-.845zm-.192 5.381c-.294.069-.601.186-.845-.066-.312-.322-.223-.885.2-1.039.273-.104.619-.162.842.066.286.293.254.93-.197 1.039zm.006-3.284c-.189-.638.85-.965 1.049-.346.205.635-.871.973-1.049.346zm1.739 1.169c.244.728-.987 1.116-1.212.399-.229-.734 1.01-1.122 1.212-.399zm.066-1.95c.217-.058.446-.037.612.14.251.271.165.734-.208.803-.176.032-.446.019-.583-.101-.246-.218-.234-.731.179-.842zm1.049 1.528c.397 0 .596.582.366.871-.139.175-.439.186-.643.154-.378-.058-.62-.545-.365-.874.155-.199.419-.151.642-.151zm-1.902 2.396c-.244-.837 1.178-1.211 1.396-.38.221.845-1.21 1.217-1.396.38zm.871 1.071c.389-.04.793-.13 1.031.277.25.43.063 1.028-.44 1.129-.331.069-.732.101-.969-.192-.309-.387-.186-1.161.378-1.214zm1.975-1.864c.48.198.642.764.303 1.08-.181.165-.512.133-.734.088-.447-.088-.738-.758-.347-1.076.201-.163.56-.183.778-.092zm.755 2.018c.302.37.189 1.023-.339 1.055-.275.016-.635-.016-.821-.242-.299-.361-.186-1.039.341-1.057.275-.011.632.018.819.244zm2.039-6.664a.12.12 0 00-.134-.05c-.063.021-.105.09-.082.151 1.205 3.237-.333 4.831-.976 7.097-.771-1.841 1.785-3.573.468-6.929-.019-.043-.053-.078-.1-.085-.066-.009-.129.018-.139.106-.034.236-.189 2.096-1.698 3.186a3.029 3.029 0 00-.703-1.021c-.14-.627-.549-1.488-1.41-1.742-.128-.325-.388-.79-.887-1.04-.47-.234-1.013-.213-1.617.061-.729.085-1.23.37-1.496.845-.249.449-.204.938-.12 1.271-.614.656-.643 1.628-.628 2.009-.364.876-.159 1.899-.044 2.324-.436 1.191-.011 2.346.16 2.729 0 .104.005.202.01.3-1.427-1.562-4.676-3.497-5.918-4.235a.149.149 0 00-.181.021.155.155 0 00-.008.218c2.77 2.7 5.239 6.032 7.611 12.946 1.184-1.231 3.323-2.849 6.367-2.849h3.561c-2.262-8.428 1.032-11.444-2.036-15.313zM43.31 19.04c-.651-.17-4.807-.906-9.466 7.663.68-3.191 2.745-7.052 3.312-8.173v-.008a.155.155 0 00-.042-.192.135.135 0 00-.189.035c-3.078 5.133-4.16 8.091-4.797 11.63h1.929c.328-3.412 4.637-11.449 9.23-10.852h.005c.026.006.05-.016.053-.039.01-.03-.008-.059-.035-.064zm-9.261 28.232l-1.042-4.355h-1.774c.281 1.105.682 2.229 1.202 3.215a.16.16 0 00.16.083c.084-.011.149-.099.134-.19-.121-.922-.265-1.811-.402-2.699.375 1.395.882 2.758 1.564 4.013.019.039.058.057.095.045.05-.011.076-.064.063-.112zm1.793-1.977c-.182-.728-.371-1.621-.533-2.378h-.675c.263.808.617 1.709.932 2.479.031.075.102.112.171.093.081-.024.125-.111.105-.194zm.225 2.561l-.005-.01c-.218-.609-.52-1.154-.759-1.738a23.611 23.611 0 01-.706-1.758c-.17-.45-.351-.965-.49-1.433h-.651c.183.545.422 1.132.645 1.658.491 1.188 1.058 2.352 1.78 3.393a.103.103 0 00.123.035c.058-.022.084-.088.063-.147zm.974-20.9c-.05-.075-.171-.091-.229-.03a13.332 13.332 0 00-2.146 3.069h.703c.352-.826 1.144-2.285 1.653-2.811l.006-.005c.052-.059.063-.157.013-.223zm-5.354-6.045c.651-1.069 1.616-1.887 2.435-2.875.029-.038.027-.096-.008-.128a.082.082 0 00-.118-.003c-.186.199-.38.386-.58.571-.086-.042-.306.043-.53.218-.175.139-.301.293-.346.404-.113-.026-.325.106-.517.351-.157.205-.249.42-.247.553-.121.01-.296.164-.446.409-.097.162-.16.319-.181.449a1.243 1.243 0 00-.31.353c-.134.224-.202.449-.181.579-.031.057-.063.11-.089.165l.016-.132c.191-1.513.469-3.011.892-4.456.425-1.441.934-2.894 1.808-4.061l.005-.005a.166.166 0 00-.015-.21.138.138 0 00-.205-.003 6.57 6.57 0 00-.785 1.05c-.099-.053-.309.144-.469.452-.147.278-.2.536-.145.635 0 0-.002.008-.008.005-.105-.045-.299.189-.417.502-.115.295-.136.566-.058.657-.005.005-.005.008-.008.013-.118-.043-.309.226-.427.606-.098.321-.108.6-.037.712.005.005 0 .019-.005.016-.121-.043-.305.234-.412.611-.108.364-.1.686.002.749-.118-.013-.283.263-.37.638-.079.324-.07.603.005.715-.115.034-.243.305-.309.656-.063.343-.032.627.052.718-.108.055-.217.334-.257.68-.039.343.01.624.1.715-.09.1-.176.339-.213.627-.036.273-.013.51.039.643-.096.082-.17.359-.173.691-.007.265.032.491.1.621a1.53 1.53 0 00-.089.542c-.006.279.039.518.11.643-.021.981-.008 2.025.045 3.008h2.118c.015-.765.065-1.6.141-2.357.15-1.35.373-2.721 1.048-3.874l.005-.008a.112.112 0 00-.014-.127c-.039-.035-.094-.035-.131.008-.916 1.063-1.317 2.506-1.553 3.89-.042.271-.076.544-.108.816.058-1.111.16-2.217.415-3.269.291-1.281.874-2.5 1.984-3.183a.099.099 0 00.039-.112.091.091 0 00-.11-.066c-.071.021-.137.058-.205.088-.073-.091-.343-.024-.622.153-.265.173-.44.386-.423.503 0 .005-.012.013-.012.002-.003-.013-.005-.026-.013-.034-.1-.082-.368.104-.594.42-.228.316-.317.646-.22.731.005.002.003.01-.003.01-.118-.048-.315.221-.438.596-.089.262-.11.504-.079.643 0 .004-.005.01-.005.01-.092.303-.168.609-.239.919.026-.438.066-.879.129-1.315.186-1.254.564-2.482 1.236-3.528zm6.663-3.498a.749.749 0 00-.485-.037.811.811 0 00-.326.17.925.925 0 00-.018-.345.838.838 0 00-.252-.449c-.572-.571-.178-2.291-.312-2.312-.132-.018-.084 1.696-.355 2.498a.928.928 0 00-.018.529.882.882 0 00.26.451c.113.099.249.144.378.104a.217.217 0 00.097-.043c0 .022 0 .043.002.064.029.141.129.25.266.314a.722.722 0 00.488.037.792.792 0 00.428-.26c.538-.625 1.802-1.515 1.726-1.634-.076-.117-1.144 1.195-1.879.913zm2.446-2.165c-.081-.117-1.094 1.065-1.785.77a.634.634 0 00-.451-.042.69.69 0 00-.236.133c-.003-.048 0-.091-.01-.133a.707.707 0 00-.255-.398c-.577-.505-.123-2.041-.26-2.057-.139-.016-.136 1.512-.435 2.229a.678.678 0 00-.037.468.72.72 0 00.254.401.486.486 0 00.394.093.495.495 0 00.16-.082c0 .008-.002.018 0 .026a.53.53 0 00.27.327.64.64 0 00.446.037.631.631 0 00.366-.26c.427-.64 1.661-1.39 1.579-1.512zm.25-1.48c-.09-.093-.817 1.124-1.475.978a.55.55 0 00-.399.04.517.517 0 00-.168.117c0-.03.007-.059.007-.091a.669.669 0 00-.17-.393c-.443-.542.173-1.825.055-1.865-.12-.035-.33 1.315-.698 1.902a.632.632 0 00-.094.412c.01.157.076.298.168.396.094.098.21.152.336.144a.373.373 0 00.243-.12c0 .053.011.111.037.167a.444.444 0 00.287.242c.123.04.27.029.401-.035a.589.589 0 00.283-.292c.289-.64 1.273-1.509 1.187-1.602zm-.436-1.69c-.15-.106-.625 1.076-1.189 1.384a.683.683 0 00-.275.295.71.71 0 00-.079.415c.013.125.07.231.163.284a.317.317 0 00.314-.002.664.664 0 00.281-.298.746.746 0 00.079-.412c-.042-.669.811-1.6.706-1.666zM30.251 42.917h-5.944c-.404 0-.769-.032-1.105-.093.003 0 .003.002.003.002.976 1.451 2.506 2.552 4.057 3.29.239 1.323.538 2.548.646 2.644.11.095 1.632-.343 1.68-.484.044-.14-.622-2.407-.622-2.407.8-1.374 1.046-2.185 1.285-2.952zm14.954 10.169c-1.501.593-3.459.642-5.057.218-3.661-1.14-7.726-3.3-11.629-1.507-3.902-1.793-7.968.367-11.629 1.507-1.598.424-3.556.375-5.057-.218a.038.038 0 00-.036.066c2.159 1.671 5.186 2.44 7.91 1.456 2.616-.815 4.828-3.587 7.928-2.404-2.454.959-4.748 2.729-6.519 4.4l1.289 1.057c1.608-1.873 3.419-3.746 5.469-4.886.28-.165.449-.231.645-.242.197.011.365.077.643.242 2.053 1.14 3.864 3.013 5.472 4.886l1.289-1.057c-1.772-1.671-4.065-3.441-6.519-4.4 3.099-1.183 5.312 1.589 7.928 2.404 2.724.984 5.75.215 7.91-1.456.034-.029.005-.082-.037-.066zm-24.129-2.525c-3.826-.927-4.873-4.514-8.072-6.071-.035-.018-.071.022-.05.053 1.008 1.658 1.554 4.198 4.459 5.764.023.012.01.05-.016.042-4.167-.802-5.918.313-10.285-1.661-.037-.016-.076.024-.053.059 1.436 2.083 4.843 3.507 9.509 3.114 1.679-.143 2.897-.85 4.508-1.227.04-.011.04-.065 0-.073zm-8.014-2.2c-1.454-1.905-1.04-5.972-4.323-9.695-.026-.029-.073-.006-.065.031.627 2.742.441 5.857 2.157 8.139.015.024-.008.048-.031.032-3.386-2.665-6.866-3.468-8.415-5.625-.023-.029-.07-.014-.065.024.383 2.792 5.747 7.145 10.712 7.153.03 0 .048-.034.03-.059zm-5.084-5.064c-1.559-2.891.305-7.302-1.464-11.588-.019-.045-.087-.034-.087.014-.052 2.34-1.506 5.835-.627 8.473.01.024-.021.037-.034.016C3.527 36.941 1.75 36.258.27 33.264c-.021-.045-.089-.033-.092.015C.084 35.314.984 36.973 2 38.514a17.387 17.387 0 005.928 4.836c.034.016.066-.019.05-.053zM6.921 25.691c-.003-.048-.066-.064-.09-.022-1.189 2.224-3.306 3.994-3.375 6.931-.003.029-.034.031-.039.004-.386-2.266-2.31-4.806-2.394-8.088 0-.05-.071-.063-.089-.016-1.582 4.268.693 8.314 3.116 11.657.025.034.078.014.078-.032-.099-3.542 2.971-6.186 2.793-10.434zm1.511-5.522c-1.123 1.56-3.651 2.663-4.574 4.913-.014.032-.053.024-.047-.013.367-2.522-.607-5.45.306-8.8.014-.048-.046-.08-.076-.043-1.38 1.698-1.847 3.688-1.923 5.838-.095 2.641.834 4.567 1.294 6.358.01.043.065.04.075-.003.662-2.348 3.982-3.762 5.021-8.213.013-.047-.047-.077-.076-.037zm3.047-5.245c-1.847 1.448-4.669 2.843-5.275 3.85-.01.021-.042.005-.037-.016l.685-3.287c.307-1.395.572-2.731 1.344-3.98.023-.037-.021-.08-.055-.053-3.517 2.785-3.003 6.812-3.157 10.11-.003.035.039.051.063.027 2.07-2.246 5.445-3.553 6.49-6.606.013-.037-.027-.069-.058-.045zm2.616-5.049c-3.107.099-5.39 2.716-6.369 6.048-.005.019.021.035.037.024 4.28-3.138 4.041-4.483 6.359-5.976.042-.027.023-.096-.027-.096zm35.829 38.813c-4.365 1.974-6.118.859-10.285 1.661-.027.008-.04-.03-.016-.042 2.906-1.566 3.452-4.106 4.459-5.764.021-.031-.016-.071-.05-.053-3.196 1.557-4.244 5.144-8.072 6.071-.04.008-.04.062 0 .073 1.611.377 2.829 1.084 4.508 1.227 4.666.393 8.076-1.031 9.508-3.114.024-.035-.015-.075-.052-.059zm4.727-7.445c-1.549 2.157-5.029 2.96-8.414 5.625-.021.016-.048-.008-.029-.032 1.714-2.282 1.527-5.397 2.155-8.139.007-.037-.04-.06-.066-.031-3.281 3.723-2.869 7.79-4.32 9.695-.018.025-.003.059.029.059 4.965-.008 10.327-4.361 10.71-7.153.005-.038-.042-.053-.065-.024zm2.207-7.964c-.003-.048-.071-.06-.092-.015-1.481 2.994-3.257 3.677-5.493 6.948-.016.021-.045.008-.037-.016.879-2.638-.572-6.133-.627-8.473 0-.048-.068-.059-.087-.014-1.768 4.286.095 8.697-1.462 11.588-.018.034.014.069.048.053a17.387 17.387 0 005.928-4.836c1.016-1.541 1.916-3.2 1.822-5.235zm-.756-8.779c-.019-.047-.09-.034-.09.016-.084 3.282-2.007 5.822-2.393 8.088-.005.027-.037.025-.037-.004-.068-2.937-2.188-4.707-3.377-6.931-.024-.042-.087-.026-.087.022-.178 4.248 2.89 6.892 2.79 10.434 0 .046.055.066.081.032 2.42-3.343 4.695-7.389 3.113-11.657zm-1.184-2.436c-.076-2.15-.543-4.14-1.924-5.838-.028-.037-.086-.005-.076.043.914 3.35-.06 6.278.31 8.8.005.037-.037.045-.05.013-.923-2.25-3.451-3.353-4.574-4.913-.027-.04-.087-.01-.076.037 1.039 4.451 4.359 5.865 5.02 8.213.011.043.066.046.076.003.46-1.791 1.388-3.717 1.294-6.358zm-6.023-10.626c-.034-.027-.078.016-.055.053.772 1.249 1.037 2.585 1.344 3.98l.685 3.287c.005.021-.027.037-.037.016-.606-1.007-3.425-2.402-5.275-3.85-.029-.024-.071.008-.058.045 1.045 3.053 4.42 4.36 6.49 6.606.024.024.066.008.063-.027-.154-3.298.36-7.325-3.157-10.11zM42.94 9.875c-.05 0-.065.069-.026.096 2.318 1.493 2.079 2.838 6.359 5.976.019.011.042-.005.037-.024-.979-3.332-3.262-5.949-6.37-6.048zm29.423 25.108h-2.496l-1.399-5.427a25.252 25.252 0 01-.265-1.199c-.125-.606-.197-1.012-.215-1.219-.029.254-.099.664-.212 1.227-.114.562-.201.964-.262 1.205l-1.393 5.413h-2.488L60.996 24.65h2.157l1.321 5.64a33.77 33.77 0 01.502 2.707c.028-.268.094-.684.194-1.248.102-.563.197-1 .287-1.311l1.505-5.788h2.071l1.506 5.788c.066.26.149.657.247 1.188.1.533.175.99.227 1.371.047-.367.122-.826.227-1.375.103-.549.197-.992.282-1.332l1.314-5.64h2.156l-2.629 10.333m4.834-3.965c0 .782.128 1.373.385 1.774.257.4.675.602 1.255.602.574 0 .988-.2 1.24-.598.252-.399.378-.99.378-1.778 0-.782-.127-1.368-.382-1.759-.253-.392-.67-.588-1.25-.588-.576 0-.99.196-1.245.584-.253.389-.381.977-.381 1.763zm5.463 0c0 1.288-.339 2.293-1.017 3.018-.679.727-1.623 1.09-2.834 1.09-.759 0-1.429-.166-2.008-.5a3.315 3.315 0 01-1.336-1.43c-.311-.623-.467-1.347-.467-2.178 0-1.29.337-2.294 1.011-3.011.674-.717 1.621-1.074 2.842-1.074.759 0 1.428.166 2.008.494.579.33 1.024.805 1.336 1.422.31.617.465 1.34.465 2.169zm5.726-4.085c.292 0 .534.021.728.064l-.163 2.022a2.465 2.465 0 00-.636-.072c-.688 0-1.224.177-1.609.531-.383.353-.575.848-.575 1.484v4.021h-2.156v-7.902h1.633l.318 1.329h.105c.246-.442.577-.799.994-1.071a2.45 2.45 0 011.361-.406m1.67 8.051h2.156V23.986h-2.156zm7.271-1.577c.552 0 .956-.16 1.213-.48.257-.321.397-.865.42-1.633v-.233c0-.849-.131-1.456-.391-1.823-.262-.367-.688-.551-1.277-.551-.48 0-.854.203-1.12.611-.266.406-.399 1-.399 1.777 0 .777.133 1.362.402 1.75.269.389.653.582 1.152.582zm-.755 1.719c-.929 0-1.659-.361-2.189-1.082-.529-.721-.795-1.721-.795-2.998 0-1.295.27-2.304.81-3.027.539-.725 1.283-1.086 2.23-1.086.994 0 1.753.387 2.276 1.16h.071a8.774 8.774 0 01-.163-1.576v-2.531h2.163v10.997h-1.654l-.417-1.025h-.092c-.49.779-1.237 1.168-2.24 1.168zm11.933-.143h-2.155V24.65h5.923v1.795h-3.768v2.666h3.506v1.786h-3.506v4.086m6.847-3.965c0 .782.128 1.373.385 1.774.256.4.675.602 1.254.602.576 0 .989-.2 1.241-.598.252-.399.379-.99.379-1.778 0-.782-.128-1.368-.382-1.759-.255-.392-.672-.588-1.251-.588-.575 0-.99.196-1.244.584-.255.389-.382.977-.382 1.763zm5.464 0c0 1.288-.339 2.293-1.018 3.018-.679.727-1.624 1.09-2.835 1.09-.759 0-1.428-.166-2.008-.5a3.327 3.327 0 01-1.336-1.43c-.31-.623-.465-1.347-.465-2.178 0-1.29.336-2.294 1.01-3.011.674-.717 1.621-1.074 2.842-1.074.758 0 1.428.166 2.007.494.58.33 1.025.805 1.336 1.422.311.617.467 1.34.467 2.169zm3.081 0c0 .782.128 1.373.384 1.774.257.4.676.602 1.255.602.576 0 .989-.2 1.241-.598.252-.399.379-.99.379-1.778 0-.782-.128-1.368-.382-1.759-.255-.392-.672-.588-1.251-.588-.575 0-.991.196-1.244.584-.255.389-.382.977-.382 1.763zm5.464 0c0 1.288-.339 2.293-1.018 3.018-.679.727-1.624 1.09-2.835 1.09-.759 0-1.428-.166-2.008-.5a3.327 3.327 0 01-1.336-1.43c-.31-.623-.466-1.347-.466-2.178 0-1.29.337-2.294 1.011-3.011.674-.717 1.621-1.074 2.842-1.074.758 0 1.428.166 2.007.494.58.33 1.025.805 1.336 1.422.311.617.467 1.34.467 2.169zm4.655 2.389c.551 0 .955-.16 1.212-.48.257-.321.397-.865.421-1.633v-.233c0-.849-.131-1.456-.393-1.823s-.686-.551-1.275-.551c-.482 0-.855.203-1.121.611-.266.406-.4 1-.4 1.777 0 .777.135 1.362.404 1.75.268.389.652.582 1.152.582zm-.757 1.719c-.928 0-1.657-.361-2.187-1.082-.531-.721-.795-1.721-.795-2.998 0-1.295.269-2.304.808-3.027.54-.725 1.283-1.086 2.231-1.086.994 0 1.753.387 2.276 1.16h.07a8.857 8.857 0 01-.162-1.576v-2.531h2.163v10.997h-1.654l-.417-1.025h-.092c-.49.779-1.237 1.168-2.241 1.168zm11.969-5.613h.721c.674 0 1.178-.133 1.513-.398.334-.268.502-.655.502-1.164 0-.514-.141-.893-.421-1.137-.28-.246-.72-.369-1.318-.369h-.997v3.068zm4.948-1.641c0 1.114-.348 1.963-1.042 2.553-.695.59-1.684.883-2.966.883h-.94v3.675h-2.191V24.65h3.301c1.253 0 2.206.269 2.86.808.652.542.978 1.346.978 2.414zm5.628-.939c.292 0 .535.021.728.064l-.163 2.022a2.457 2.457 0 00-.635-.072c-.689 0-1.225.177-1.609.531-.384.353-.576.848-.576 1.484v4.021h-2.156v-7.902h1.633l.318 1.329h.106c.246-.442.577-.799.994-1.071.417-.271.87-.406 1.36-.406m3.41 4.085c0 .782.129 1.373.386 1.774.257.4.675.602 1.255.602.574 0 .988-.2 1.24-.598.252-.399.378-.99.378-1.778 0-.782-.127-1.368-.382-1.759-.254-.392-.671-.588-1.251-.588-.575 0-.989.196-1.244.584-.254.389-.382.977-.382 1.763zm5.464 0c0 1.288-.339 2.293-1.018 3.018-.678.727-1.623 1.09-2.834 1.09-.758 0-1.428-.166-2.007-.5a3.309 3.309 0 01-1.336-1.43c-.312-.623-.467-1.347-.467-2.178 0-1.29.337-2.294 1.011-3.011.673-.717 1.621-1.074 2.841-1.074.759 0 1.428.166 2.008.494.579.33 1.025.805 1.336 1.422.311.617.466 1.34.466 2.169zm2.917-1.349c0 .428.098.767.293 1.017.195.25.493.375.894.375.406 0 .703-.125.891-.375.189-.25.282-.589.282-1.017 0-.953-.39-1.427-1.173-1.427-.792 0-1.187.474-1.187 1.427zm-.785 6.431c0 .297.142.532.428.7.285.17.684.256 1.198.256.772 0 1.378-.108 1.816-.319.439-.213.657-.502.657-.869 0-.297-.128-.502-.388-.615-.259-.113-.659-.17-1.201-.17h-1.118c-.395 0-.726.094-.993.279-.266.186-.399.432-.399.738zm6.1-9.019v1.096l-1.237.319c.227.353.339.75.339 1.187 0 .847-.295 1.509-.887 1.982-.592.475-1.412.711-2.463.711l-.389-.022-.318-.035c-.221.17-.333.358-.333.565 0 .312.397.466 1.189.466h1.343c.867 0 1.527.188 1.982.559.455.373.683.92.683 1.641 0 .924-.386 1.638-1.157 2.148-.77.51-1.877.764-3.318.764-1.103 0-1.945-.192-2.527-.576-.582-.385-.873-.922-.873-1.616 0-.476.148-.875.445-1.195.297-.32.732-.549 1.308-.685a1.442 1.442 0 01-.58-.463 1.102 1.102 0 01-.248-.682c0-.301.088-.553.262-.752.175-.201.427-.398.757-.592a2.112 2.112 0 01-.986-.861c-.244-.397-.365-.863-.365-1.4 0-.861.281-1.529.842-2 .561-.471 1.361-.707 2.403-.707.221 0 .484.02.789.061.303.039.498.068.583.087h2.756zm5.285-.148c.292 0 .535.021.728.064l-.163 2.022a2.47 2.47 0 00-.636-.072c-.688 0-1.224.177-1.608.531-.384.353-.576.848-.576 1.484v4.021h-2.157v-7.902h1.633l.319 1.329h.106c.245-.442.576-.799.993-1.071.417-.271.87-.406 1.361-.406m5.93 4.39l-.834.027c-.627.02-1.093.133-1.4.34-.306.207-.459.524-.459.948 0 .607.349.912 1.046.912.5 0 .898-.145 1.198-.432.299-.287.449-.67.449-1.146v-.649zm.636 3.66l-.417-1.074h-.057c-.363.457-.736.774-1.12.951-.385.176-.885.266-1.502.266-.759 0-1.356-.217-1.792-.651-.436-.433-.654-1.05-.654-1.853 0-.838.294-1.457.88-1.856.587-.396 1.472-.616 2.654-.659l1.372-.043v-.346c0-.801-.41-1.201-1.23-1.201-.632 0-1.374.189-2.227.572l-.714-1.457c.91-.474 1.918-.713 3.026-.713 1.06 0 1.873.231 2.438.692.566.463.849 1.164.849 2.107v5.265h-1.506zm10.284 0h-2.156v-4.614c0-.571-.095-.999-.286-1.284-.191-.285-.491-.427-.902-.427-.55 0-.952.203-1.201.607-.25.406-.375 1.072-.375 2.001v3.717h-2.156v-7.902h1.647l.29 1.012h.121c.212-.363.517-.648.919-.853.4-.203.859-.307 1.377-.307 1.183 0 1.985.387 2.404 1.16h.191c.212-.369.524-.654.937-.855a3.115 3.115 0 011.395-.305c.896 0 1.573.231 2.032.689.46.46.69 1.196.69 2.209v5.152h-2.163v-4.614c0-.571-.096-.999-.286-1.284-.192-.285-.492-.427-.902-.427-.527 0-.923.189-1.183.566-.262.377-.393.975-.393 1.794v3.965m13.705 0h-2.155v-4.614c0-.571-.096-.999-.286-1.284-.192-.285-.491-.427-.902-.427-.551 0-.952.203-1.202.607-.25.406-.374 1.072-.374 2.001v3.717h-2.156v-7.902h1.647l.29 1.012h.12a2.19 2.19 0 01.919-.853c.4-.203.86-.307 1.379-.307 1.182 0 1.983.387 2.403 1.16h.19a2.12 2.12 0 01.937-.855 3.119 3.119 0 011.396-.305c.896 0 1.573.231 2.033.689.459.46.689 1.196.689 2.209v5.152h-2.163v-4.614c0-.571-.096-.999-.287-1.284-.191-.285-.491-.427-.901-.427-.528 0-.922.189-1.184.566-.262.377-.393.975-.393 1.794v3.965m9.951-6.517c-.457 0-.815.147-1.075.436-.259.289-.407.701-.445 1.234h3.025c-.008-.533-.148-.945-.417-1.234-.268-.289-.631-.436-1.088-.436zm.304 6.66c-1.272 0-2.266-.352-2.983-1.055-.716-.701-1.074-1.695-1.074-2.982 0-1.324.331-2.347.993-3.07.662-.725 1.577-1.086 2.746-1.086 1.117 0 1.986.318 2.608.955.622.635.934 1.514.934 2.636v1.045h-5.097c.024.614.205 1.092.544 1.436.34.344.815.515 1.428.515.476 0 .927-.048 1.35-.148.424-.1.868-.256 1.329-.473v1.668c-.377.188-.78.328-1.209.42-.428.092-.952.139-1.569.139z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpLogoStandardBlackEn = {
  "id": "icon--wfp-logo--standard-black-en",
  "name": "icon--wfp-logo--standard-black-en",
  "tags": "icon--wfp-logo--standard-black-en",
  "styles": "",
  "viewBox": "0 0 132 58",
  "width": "132",
  "height": "58",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M35.934 4.664h.548c.511 0 .895-.101 1.149-.304.254-.202.381-.497.381-.883 0-.39-.107-.678-.319-.865-.214-.186-.547-.28-1.002-.28h-.757v2.332zm3.76-1.246c0 .845-.265 1.491-.793 1.938-.528.449-1.279.672-2.253.672h-.714v2.793h-1.665V.969h2.508c.952 0 1.676.204 2.172.615.496.41.745 1.021.745 1.834zm-9.537 5.403h-1.638V.969h4.501v1.363h-2.863v2.026h2.664v1.359h-2.664v3.104zm-4.525 0h-1.896l-1.063-4.125c-.04-.147-.107-.45-.202-.91a10.34 10.34 0 01-.164-.927c-.021.194-.075.505-.16.932-.087.428-.153.734-.199.916l-1.059 4.114h-1.89L16.995.969h1.639l1.004 4.285c.176.792.302 1.478.381 2.058.022-.204.071-.52.148-.948.077-.429.15-.761.218-.996L21.529.969h1.573l1.144 4.399a23.19 23.19 0 01.36 1.944c.036-.28.093-.628.172-1.045.079-.417.15-.754.215-1.013l.999-4.285h1.638l-1.998 7.852zm-4.073 27.313c-3.051 0-5.009.724-5.544.949-.031.014-.057-.031-.032-.056 3.352-3.485 7.277-3.293 8.222-3.293h11.161c.563 0 1.019.537 1.019 1.201 0 .662-.456 1.199-1.019 1.199H21.559zm2.515 3.085c-3.288 0-4.246-1.868-9.222-.635-.034.009-.057-.038-.028-.058 2.774-1.903 5.791-1.73 7.011-1.73h13.531c.563 0 1.019.537 1.019 1.199s-.456 1.199-1.019 1.199c0 0-8.689.025-11.292.025zm.233 3.037c-3.374 0-3.644-2.49-8.646-3.051-.035-.004-.039-.056-.005-.064 4.109-1.028 5.638.715 8.037.715h11.673c.563 0 1.019.537 1.019 1.2 0 .663-.456 1.2-1.019 1.2H24.307zm-.732-9.183c-2.716 0-4.968 1.185-5.495 1.484-.03.016-.059-.019-.04-.046.441-.649 2.82-3.837 6.91-3.837h10.416c.563 0 1.019.537 1.019 1.2 0 .662-.456 1.199-1.019 1.199H23.575zm14.941-6.625a.753.753 0 00-.444-.205.74.74 0 00-.362.043c.047-.099.087-.205.102-.33a.85.85 0 00-.083-.512c-.336-.736.624-2.209.503-2.275-.115-.064-.661 1.56-1.191 2.216a.934.934 0 00-.2.489.923.923 0 00.087.513c.074.132.186.226.318.234a.295.295 0 00.107-.006.266.266 0 00-.018.059.453.453 0 00.142.388.718.718 0 00.441.207.77.77 0 00.493-.093c.719-.393 2.21-.781 2.178-.919-.029-.138-1.483.715-2.073.191zm1.099-1.074a.63.63 0 00-.406-.199.657.657 0 00-.268.043c.013-.046.031-.085.037-.131a.726.726 0 00-.103-.462c-.365-.677.588-1.956.465-2.019-.123-.064-.646 1.368-1.176 1.934a.69.69 0 00-.197.425.765.765 0 00.1.465c.084.123.199.21.338.229a.53.53 0 00.179-.021c-.003.007-.011.018-.008.026a.524.524 0 00.139.398c.1.107.244.181.404.195a.62.62 0 00.433-.117c.62-.447 2.037-.712 2-.856-.034-.138-1.391.611-1.937.09zm.964-.993a.552.552 0 00-.389-.104.541.541 0 00-.197.051c.011-.03.029-.054.04-.083a.7.7 0 00-.024-.43c-.231-.665.792-1.648.693-1.728-.1-.074-.764 1.117-1.31 1.536a.648.648 0 00-.231.354.648.648 0 00.021.428.438.438 0 00.265.255c.092.029.184.01.271-.027a.393.393 0 00-.024.17c.013.136.079.25.187.33a.567.567 0 00.752-.067c.491-.497 1.714-.962 1.665-1.081-.053-.12-1.152.765-1.719.396zm1.894-2.134c-.102-.151-.958.787-1.59.877a.66.66 0 00-.359.178.684.684 0 00-.221.361.38.38 0 00.055.324.325.325 0 00.299.109.64.64 0 00.365-.181.73.73 0 00.215-.356c.192-.643 1.312-1.214 1.236-1.312zm-17.694 1.27c-.025.093-.21.816-.21.816-.052.029-.272-.019-.33-.024-.422-.04-.8-.407-.638-.845.133-.358.404-.396.748-.412.143-.006.4.028.529.117 0 0-.051.165-.099.348zm-.485 2.182l-.039.247c-.263-.165-.417-.542-.291-.84.097-.226.337-.285.514-.295a49.8 49.8 0 00-.184.888zm-.378 2.696c-.033.185-.283.21-.454.261-.496.149-.966.085-1.118-.508-.165-.634.315-.901.83-1.025.28-.066.54-.011.732.226.048.059.105.112.118.168 0 0-.077.704-.108.878zm-1.561-3.122c.383-.092.779-.236 1.073.141.31.396.207 1.031-.291 1.199-.328.111-.725.207-1.005-.061-.368-.351-.341-1.148.223-1.279zm-.375-2.056c.403-.098.821-.247 1.131.149.322.414.215 1.084-.308 1.259-.346.114-.763.215-1.057-.067-.386-.366-.357-1.203.234-1.341zm-.376 4.445c-.105.37-.41.425-.729.502-.21-.257-.774-.909-.784-.986a.205.205 0 01.012-.09c.026-.077.115-.151.181-.194.192-.125.601-.217.822-.172.396.085.603.568.498.94zm-2.005-1.899c-.289-1.024 1.428-1.47 1.693-.466.273 1.032-1.459 1.47-1.693.466zm-.252-2.044c-.294-1.017 1.431-1.464 1.696-.465.273 1.033-1.462 1.472-1.696.465zm-.241-2.009c-.281-.948 1.338-1.368 1.585-.433.254.962-1.365 1.377-1.585.433zm-.166 3.867c-.079.047-.109.072-.136.072l-.77-.838c.009-.024.247-.196.327-.242.64-.356 1.167.662.579 1.008zm-1.461-1.887c-.381-.84 1.005-1.751 1.425-.845.385.834-1.001 1.761-1.425.845zm1.165-2.66c.438.779-.882 1.648-1.26.81-.336-.722.837-1.565 1.26-.81zm-1.108-1.815c.195-.172.42-.265.651-.154.37.178.381.733.058.954-.147.101-.396.226-.577.181-.397-.101-.473-.68-.132-.981zm.05-1.669c.16-.108.373-.205.557-.13.334.137.322.622.052.816-.124.088-.346.197-.496.157-.338-.085-.421-.634-.113-.843zm.887-2.378c.199-.107.486-.152.664.048a.468.468 0 01-.134.734c-.212.106-.498.146-.666-.051a.48.48 0 01.136-.731zm-.157 1.807c-.161-.595.842-.876 1.005-.271.181.587-.845.88-1.005.271zm1.616 1.039c.234.643-.855 1.007-1.068.372-.217-.643.877-1.01 1.068-.372zm.137-3.133c.208-.083.474-.173.706 0 .289.216.226.702-.105.853-.218.099-.496.165-.69-.008-.247-.22-.261-.705.089-.845zm-.192 5.381c-.294.069-.601.186-.845-.066-.312-.322-.223-.885.2-1.039.273-.104.619-.162.842.066.286.293.255.93-.197 1.039zm.005-3.284c-.188-.638.851-.965 1.05-.346.205.635-.871.973-1.05.346zm1.74 1.169c.244.728-.986 1.116-1.212.399-.228-.734 1.011-1.122 1.212-.399zm.066-1.95c.217-.058.446-.037.611.14.252.271.166.734-.207.803-.175.032-.446.019-.583-.101-.246-.218-.234-.731.179-.842zm1.05 1.528c.396 0 .596.582.365.871-.139.175-.439.186-.643.154-.378-.058-.62-.545-.365-.874.155-.199.42-.151.643-.151zm-1.903 2.396c-.244-.837 1.178-1.211 1.396-.38.221.845-1.209 1.217-1.396.38zm.872 1.071c.388-.04.792-.13 1.031.277.249.43.063 1.028-.441 1.129-.331.069-.732.101-.968-.192-.31-.387-.187-1.161.378-1.214zm1.974-1.864c.48.198.642.764.304 1.08-.182.165-.512.133-.735.088-.447-.088-.738-.758-.347-1.076.201-.163.56-.183.778-.092zm.755 2.018c.301.37.189 1.023-.339 1.055-.275.016-.635-.016-.821-.242-.299-.361-.186-1.039.341-1.057.276-.011.633.018.819.244zm2.039-6.664a.12.12 0 00-.134-.05c-.063.021-.105.09-.081.151 1.205 3.237-.334 4.831-.977 7.097-.771-1.841 1.785-3.573.468-6.929-.019-.043-.053-.078-.1-.085-.066-.009-.129.018-.139.106-.034.236-.189 2.096-1.698 3.186a3.015 3.015 0 00-.703-1.021c-.14-.627-.549-1.488-1.41-1.742-.129-.325-.388-.79-.887-1.04-.47-.234-1.013-.213-1.617.061-.729.085-1.231.37-1.495.845-.25.449-.205.938-.121 1.271-.614.656-.643 1.628-.627 2.009-.365.876-.16 1.899-.045 2.324-.436 1.191-.01 2.346.16 2.729 0 .104.005.202.011.3-1.428-1.562-4.677-3.497-5.918-4.235a.148.148 0 00-.181.021.154.154 0 00-.008.218c2.768 2.7 5.238 6.032 7.61 12.946 1.184-1.231 3.323-2.849 6.367-2.849h3.561c-2.262-8.428 1.032-11.444-2.036-15.313zm16.836 4.358c-.651-.17-4.808-.906-9.467 7.663.68-3.191 2.746-7.052 3.312-8.173v-.008a.153.153 0 00-.042-.192.136.136 0 00-.189.035c-3.078 5.133-4.159 8.091-4.797 11.63h1.929c.328-3.412 4.637-11.449 9.23-10.852h.005c.027.006.05-.016.053-.039.01-.03-.008-.059-.034-.064zm-9.262 28.232l-1.042-4.355h-1.774c.281 1.105.682 2.229 1.202 3.215a.16.16 0 00.16.083.165.165 0 00.134-.19c-.121-.922-.265-1.811-.402-2.699.376 1.395.882 2.758 1.565 4.013.018.039.057.057.094.045.05-.011.076-.064.063-.112zm1.793-1.977c-.182-.728-.371-1.621-.533-2.378h-.675c.263.808.617 1.709.932 2.479.031.075.102.112.17.093a.16.16 0 00.106-.194zm.225 2.561l-.005-.01c-.218-.609-.52-1.154-.759-1.738a23.462 23.462 0 01-.706-1.759c-.17-.449-.351-.964-.49-1.432h-.651c.184.545.423 1.132.646 1.658.49 1.188 1.057 2.352 1.779 3.393a.103.103 0 00.123.035c.058-.022.084-.088.063-.147zm.974-20.9c-.05-.075-.171-.091-.228-.03a13.313 13.313 0 00-2.147 3.069h.703c.352-.826 1.144-2.285 1.654-2.811l.005-.005a.183.183 0 00.013-.223zm-5.354-6.045c.651-1.069 1.617-1.887 2.436-2.875a.097.097 0 00-.009-.128.08.08 0 00-.117-.003c-.187.199-.381.386-.58.571-.087-.042-.307.043-.531.218-.175.139-.301.293-.346.404-.113-.026-.325.106-.517.351-.158.205-.249.42-.247.553-.121.01-.296.164-.446.409-.097.162-.16.319-.181.449a1.227 1.227 0 00-.309.353c-.134.224-.203.449-.182.579-.031.057-.063.11-.089.165l.016-.132c.192-1.513.469-3.011.892-4.456.425-1.441.934-2.894 1.808-4.061l.006-.005a.168.168 0 00-.016-.21.138.138 0 00-.205-.003 6.631 6.631 0 00-.785 1.05c-.099-.053-.309.144-.469.452-.147.278-.2.536-.144.635 0 0-.003.008-.009.005-.105-.045-.299.189-.417.502-.115.295-.136.566-.057.657-.006.005-.006.008-.009.013-.117-.043-.309.226-.427.606-.098.321-.108.6-.037.712.005.005 0 .019-.005.016-.121-.043-.305.234-.412.611-.108.364-.1.686.002.749-.118-.013-.283.263-.37.638-.078.324-.07.603.006.715-.116.034-.244.305-.31.656-.063.343-.032.627.052.718-.107.055-.217.334-.257.68-.039.343.011.624.1.715-.089.1-.176.339-.213.627-.036.273-.013.51.04.643-.097.082-.171.359-.174.691-.007.265.032.491.1.621a1.554 1.554 0 00-.089.542c-.005.279.039.518.11.643-.021.981-.008 2.025.045 3.008h2.118c.015-.765.066-1.6.141-2.357.15-1.35.373-2.721 1.048-3.874l.005-.008a.114.114 0 00-.013-.127c-.04-.035-.095-.035-.132.008-.916 1.063-1.317 2.506-1.553 3.89-.042.271-.076.544-.108.816.058-1.111.16-2.217.415-3.269.291-1.281.874-2.5 1.984-3.183a.097.097 0 00.039-.112.091.091 0 00-.11-.066c-.071.021-.136.058-.205.088-.073-.091-.343-.024-.622.153-.265.173-.441.386-.422.503 0 .005-.013.013-.013.002a.08.08 0 00-.013-.034c-.1-.082-.368.104-.594.42-.228.316-.317.646-.22.731.005.002.003.01-.002.01-.119-.048-.315.221-.439.596-.089.262-.11.504-.078.643 0 .004-.006.01-.006.01-.092.303-.168.609-.239.919.027-.438.066-.879.129-1.315.186-1.254.564-2.482 1.236-3.528zm6.663-3.498a.75.75 0 00-.485-.037.811.811 0 00-.326.17.925.925 0 00-.018-.345.838.838 0 00-.252-.449c-.572-.571-.179-2.291-.312-2.312-.131-.018-.084 1.696-.354 2.498a.92.92 0 00-.019.529.889.889 0 00.26.451c.113.099.249.144.378.104a.217.217 0 00.097-.043c0 .022 0 .043.002.064.03.141.129.25.266.314a.722.722 0 00.488.037.792.792 0 00.428-.26c.538-.625 1.803-1.515 1.727-1.634-.077-.117-1.145 1.195-1.88.913zm2.447-2.165c-.082-.117-1.095 1.065-1.785.77a.638.638 0 00-.452-.042.69.69 0 00-.236.133c-.003-.048 0-.091-.01-.133a.707.707 0 00-.255-.398c-.577-.505-.123-2.041-.26-2.057-.139-.016-.136 1.512-.436 2.229a.684.684 0 00-.036.468c.042.17.137.311.255.401a.482.482 0 00.393.093.495.495 0 00.16-.082c0 .008-.003.018 0 .026a.53.53 0 00.27.327.643.643 0 00.447.037.626.626 0 00.365-.26c.427-.64 1.661-1.39 1.58-1.512zm.249-1.48c-.09-.093-.816 1.124-1.475.978a.55.55 0 00-.399.04.517.517 0 00-.168.117c0-.03.008-.059.008-.091a.676.676 0 00-.171-.393c-.443-.542.173-1.825.055-1.865-.12-.035-.33 1.315-.698 1.902a.632.632 0 00-.094.412c.01.157.076.298.168.396.094.098.21.152.336.144a.377.377 0 00.244-.12c0 .053.01.111.036.167a.444.444 0 00.286.242c.124.04.271.029.402-.035a.595.595 0 00.284-.292c.288-.64 1.272-1.509 1.186-1.602zm-.436-1.69c-.149-.106-.624 1.076-1.189 1.384a.683.683 0 00-.275.295.718.718 0 00-.079.415c.013.125.071.231.163.284a.319.319 0 00.315-.002.668.668 0 00.28-.298.737.737 0 00.079-.412c-.042-.669.811-1.6.706-1.666zM30.252 42.917h-5.945c-.404 0-.769-.032-1.105-.093.003 0 .003.002.003.002.976 1.451 2.506 2.552 4.057 3.29.239 1.323.538 2.548.646 2.644.11.095 1.632-.343 1.68-.484.044-.14-.623-2.407-.623-2.407.801-1.374 1.048-2.185 1.287-2.952zm14.953 10.169c-1.501.593-3.459.642-5.057.218-3.661-1.14-7.726-3.3-11.629-1.507-3.902-1.793-7.967.367-11.628 1.507-1.598.424-3.556.375-5.057-.218a.038.038 0 00-.037.066c2.16 1.671 5.186 2.44 7.91 1.456 2.616-.815 4.829-3.587 7.928-2.404-2.454.959-4.748 2.729-6.519 4.399l1.288 1.058c1.609-1.873 3.42-3.746 5.47-4.886.28-.165.448-.231.645-.242.198.011.365.077.643.242 2.053 1.14 3.864 3.013 5.472 4.886l1.289-1.058c-1.771-1.67-4.065-3.44-6.519-4.399 3.099-1.183 5.312 1.589 7.928 2.404 2.724.984 5.75.215 7.91-1.456.034-.029.005-.082-.037-.066zm-24.129-2.525c-3.826-.927-4.873-4.514-8.072-6.071-.034-.018-.071.022-.05.053 1.008 1.658 1.554 4.198 4.459 5.764.024.012.011.05-.016.042-4.167-.802-5.918.313-10.285-1.661-.037-.016-.076.024-.052.059 1.435 2.083 4.841 3.507 9.508 3.114 1.68-.143 2.897-.85 4.508-1.227.04-.011.04-.065 0-.073zm-8.014-2.2c-1.454-1.905-1.04-5.972-4.323-9.695-.026-.029-.073-.006-.065.031.627 2.742.44 5.857 2.157 8.139.016.024-.008.048-.032.032-3.385-2.665-6.865-3.468-8.414-5.625-.023-.029-.07-.014-.065.024.383 2.792 5.747 7.145 10.713 7.153.029 0 .047-.034.029-.059zm-5.084-5.064c-1.559-2.891.304-7.302-1.464-11.588-.019-.045-.087-.034-.087.014-.052 2.34-1.506 5.835-.627 8.473.01.024-.021.037-.034.016-2.239-3.271-4.015-3.954-5.496-6.948-.021-.045-.089-.033-.092.015C.084 35.314.984 36.973 2 38.514a17.398 17.398 0 005.928 4.836c.035.016.066-.019.05-.053zM6.921 25.691c-.003-.048-.066-.064-.09-.022-1.189 2.224-3.306 3.994-3.375 6.931-.002.029-.034.031-.039.004-.386-2.266-2.309-4.806-2.393-8.088 0-.05-.071-.063-.09-.016-1.582 4.268.693 8.314 3.115 11.657.027.034.079.014.079-.032-.099-3.542 2.971-6.186 2.793-10.434zm1.511-5.522c-1.123 1.56-3.65 2.663-4.574 4.913-.013.032-.053.024-.047-.013.367-2.522-.607-5.45.307-8.8.013-.048-.047-.08-.076-.043-1.381 1.698-1.848 3.688-1.924 5.838-.094 2.641.834 4.567 1.294 6.358.01.043.065.04.076-.003.661-2.348 3.981-3.762 5.02-8.213.014-.047-.047-.077-.076-.037zm3.047-5.245c-1.847 1.448-4.669 2.843-5.275 3.85-.01.021-.042.005-.037-.016l.685-3.287c.307-1.395.572-2.731 1.344-3.98.024-.037-.021-.08-.055-.053-3.517 2.785-3.003 6.812-3.158 10.11-.002.035.04.051.064.027 2.07-2.246 5.445-3.553 6.49-6.606.013-.037-.027-.069-.058-.045zm2.617-5.049c-3.108.099-5.391 2.716-6.37 6.048-.005.019.021.035.037.024 4.281-3.138 4.041-4.483 6.359-5.976.042-.027.024-.096-.026-.096zm35.828 38.813c-4.364 1.974-6.117.859-10.285 1.661-.026.008-.039-.03-.016-.042 2.905-1.566 3.451-4.106 4.459-5.764.021-.031-.015-.071-.05-.053-3.196 1.557-4.243 5.144-8.072 6.071-.04.008-.04.062 0 .073 1.611.377 2.829 1.084 4.508 1.227 4.666.393 8.076-1.031 9.509-3.114.023-.035-.016-.075-.053-.059zm4.726-7.445c-1.548 2.157-5.028 2.96-8.413 5.625-.021.016-.047-.008-.029-.032 1.714-2.282 1.527-5.397 2.154-8.139.008-.037-.039-.06-.065-.031-3.281 3.723-2.869 7.79-4.32 9.695-.018.025-.003.059.029.059 4.965-.008 10.327-4.361 10.71-7.153.005-.038-.042-.053-.066-.024zm2.208-7.964c-.003-.048-.071-.06-.092-.015-1.48 2.994-3.257 3.677-5.493 6.948-.016.021-.045.008-.036-.016.878-2.638-.573-6.133-.628-8.473 0-.048-.068-.059-.086-.014-1.769 4.286.094 8.697-1.462 11.588-.019.034.013.069.047.053a17.389 17.389 0 005.928-4.836c1.016-1.541 1.916-3.2 1.822-5.235zm-.756-8.779c-.018-.047-.089-.034-.089.016-.084 3.282-2.008 5.822-2.394 8.088-.005.027-.036.025-.036-.004-.069-2.937-2.189-4.707-3.378-6.931-.024-.042-.087-.026-.087.022-.178 4.248 2.89 6.892 2.79 10.434 0 .046.055.066.081.032 2.42-3.343 4.695-7.389 3.113-11.657zm-1.184-2.436c-.076-2.15-.543-4.14-1.923-5.838-.029-.037-.087-.005-.076.043.913 3.35-.061 6.278.309 8.8.005.037-.036.045-.05.013-.923-2.25-3.451-3.353-4.574-4.913-.026-.04-.087-.01-.076.037 1.039 4.451 4.359 5.865 5.021 8.213.01.043.065.046.076.003.459-1.791 1.388-3.717 1.293-6.358zm-6.023-10.626c-.034-.027-.078.016-.055.053.772 1.249 1.037 2.585 1.344 3.98l.685 3.287c.005.021-.027.037-.037.016-.606-1.007-3.425-2.402-5.275-3.85-.029-.024-.071.008-.058.045 1.045 3.053 4.42 4.36 6.49 6.606.024.024.066.008.063-.027-.154-3.298.36-7.325-3.157-10.11zm-5.954-1.563c-.05 0-.066.069-.027.096 2.318 1.493 2.079 2.838 6.359 5.976.019.011.042-.005.037-.024-.979-3.332-3.262-5.949-6.369-6.048zm28.225 19.572h-2.232l-1.253-4.857c-.046-.173-.125-.53-.237-1.072a12.245 12.245 0 01-.193-1.091c-.025.227-.088.593-.189 1.097-.102.504-.18.864-.235 1.079l-1.245 4.844h-2.227l-2.359-9.246h1.929l1.183 5.047c.207.932.356 1.739.449 2.422.025-.24.083-.612.174-1.116.09-.504.176-.895.256-1.173l1.347-5.18h1.853l1.347 5.18c.059.231.133.586.222 1.062.088.477.156.885.202 1.227.042-.329.109-.738.203-1.231.092-.49.177-.887.253-1.191l1.176-5.047h1.929l-2.353 9.246m4.578-3.548c0 .701.114 1.229.345 1.587.229.359.603.538 1.122.538.514 0 .884-.178 1.11-.534.226-.356.338-.887.338-1.591 0-.7-.113-1.224-.341-1.575-.228-.349-.601-.524-1.12-.524-.514 0-.885.174-1.113.521-.227.348-.341.874-.341 1.578zm4.888 0c0 1.151-.303 2.051-.91 2.701-.607.649-1.453.974-2.536.974-.679 0-1.278-.149-1.796-.446a2.959 2.959 0 01-1.195-1.281c-.279-.556-.418-1.206-.418-1.948 0-1.155.301-2.053.904-2.694s1.451-.962 2.543-.962c.678 0 1.277.149 1.796.443.519.295.917.719 1.195 1.272.278.552.417 1.199.417 1.941zm5.376-3.656c.262 0 .479.02.652.058l-.146 1.808a2.208 2.208 0 00-.569-.063c-.615 0-1.095.158-1.438.474-.344.317-.516.759-.516 1.329v3.598h-1.929v-7.071h1.461l.284 1.189h.095c.22-.396.516-.715.889-.958a2.194 2.194 0 011.217-.364m1.749 7.204h1.929v-9.841h-1.929zm6.76-1.41c.493 0 .855-.144 1.085-.431.23-.286.355-.773.376-1.461v-.208c0-.759-.117-1.303-.351-1.631-.234-.33-.615-.494-1.142-.494-.43 0-.764.182-1.002.547-.238.365-.357.895-.357 1.591 0 .695.12 1.217.36 1.565.241.348.584.522 1.031.522zm-.677 1.537c-.831 0-1.483-.323-1.957-.968-.475-.645-.711-1.539-.711-2.681 0-1.16.241-2.064.724-2.71.482-.648 1.148-.972 1.995-.972.889 0 1.569.346 2.036 1.038h.064a7.897 7.897 0 01-.146-1.411v-2.264h1.935v9.841H96.3l-.373-.917h-.082c-.438.695-1.107 1.044-2.005 1.044zm11.17-.127h-1.929v-9.246h5.3v1.607h-3.371v2.383h3.137v1.601h-3.137v3.655m6.379-3.548c0 .701.115 1.229.345 1.587.229.359.604.538 1.122.538.514 0 .884-.178 1.11-.534.226-.356.338-.887.338-1.591 0-.7-.113-1.224-.341-1.575-.228-.349-.601-.524-1.12-.524-.514 0-.885.174-1.113.521-.227.348-.341.874-.341 1.578zm4.888 0c0 1.151-.303 2.051-.91 2.701-.607.649-1.453.974-2.536.974-.679 0-1.278-.149-1.796-.446a2.959 2.959 0 01-1.195-1.281c-.279-.556-.418-1.206-.418-1.948 0-1.155.301-2.053.904-2.694s1.451-.962 2.543-.962c.679 0 1.277.149 1.796.443.519.295.917.719 1.195 1.272.278.552.417 1.199.417 1.941zm3.01 0c0 .701.115 1.229.344 1.587.23.359.604.538 1.123.538.514 0 .884-.178 1.11-.534.225-.356.338-.887.338-1.591 0-.7-.113-1.224-.341-1.575-.228-.349-.601-.524-1.12-.524-.514 0-.885.174-1.113.521-.227.348-.341.874-.341 1.578zm4.888 0c0 1.151-.303 2.051-.91 2.701-.607.649-1.453.974-2.536.974-.679 0-1.278-.149-1.796-.446a2.967 2.967 0 01-1.196-1.281c-.278-.556-.417-1.206-.417-1.948 0-1.155.301-2.053.904-2.694s1.45-.962 2.543-.962c.678 0 1.277.149 1.796.443.519.295.917.719 1.195 1.272.278.552.417 1.199.417 1.941zm4.418 2.138c.493 0 .854-.144 1.084-.431.23-.286.355-.773.377-1.461v-.208c0-.759-.117-1.303-.351-1.631-.234-.33-.615-.494-1.142-.494-.43 0-.764.182-1.002.547-.239.365-.358.895-.358 1.591 0 .695.12 1.217.361 1.565.24.348.584.522 1.031.522zm-.677 1.537c-.831 0-1.483-.323-1.957-.968-.475-.645-.712-1.539-.712-2.681 0-1.16.241-2.064.724-2.71.483-.648 1.148-.972 1.995-.972.89 0 1.569.346 2.037 1.038h.064a7.805 7.805 0 01-.146-1.411v-2.264h1.935v9.841h-1.48l-.373-.917h-.082c-.438.695-1.107 1.044-2.005 1.044zM64.157 37.78h.645c.603 0 1.054-.119 1.354-.357.299-.238.449-.585.449-1.04 0-.46-.126-.799-.377-1.019-.251-.219-.643-.328-1.179-.328h-.892v2.744zm4.428-1.467c0 .995-.312 1.756-.933 2.284-.622.527-1.507.79-2.653.79h-.842v3.289h-1.96V33.43h2.953c1.122 0 1.975.241 2.559.723.584.484.876 1.203.876 2.16zm4.886-.841c.262 0 .479.019.653.057l-.146 1.809a2.215 2.215 0 00-.569-.064c-.616 0-1.096.159-1.44.475-.343.316-.514.759-.514 1.328v3.599h-1.93v-7.072h1.461l.285 1.19h.095c.219-.397.516-.716.889-.958a2.191 2.191 0 011.216-.364m2.905 3.656c0 .7.115 1.228.344 1.587.23.358.604.538 1.122.538.515 0 .885-.179 1.111-.534.225-.357.339-.887.339-1.591 0-.7-.115-1.225-.342-1.575-.228-.35-.601-.525-1.119-.525-.515 0-.886.174-1.114.522-.227.347-.341.874-.341 1.578zm4.888 0c0 1.15-.303 2.051-.91 2.7s-1.453.975-2.536.975c-.68 0-1.278-.15-1.797-.447a2.965 2.965 0 01-1.195-1.281c-.278-.555-.417-1.205-.417-1.947 0-1.155.301-2.054.904-2.694.603-.641 1.45-.962 2.542-.962.68 0 1.278.148 1.797.443a2.95 2.95 0 011.195 1.271c.279.552.417 1.2.417 1.942zm2.459-1.208c0 .384.088.687.263.91.175.224.441.336.801.336.362 0 .628-.112.797-.336.168-.223.253-.526.253-.91 0-.852-.351-1.278-1.05-1.278-.709 0-1.064.426-1.064 1.278zm-.701 5.755c0 .265.127.474.382.626.256.152.613.228 1.072.228.692 0 1.234-.096 1.626-.285.392-.189.588-.449.588-.777 0-.266-.116-.45-.348-.551-.232-.102-.59-.151-1.075-.151h-1c-.353 0-.65.083-.887.249-.239.167-.358.387-.358.661zm5.458-8.071v.981l-1.107.285c.203.316.303.67.303 1.063 0 .758-.264 1.349-.794 1.773-.528.424-1.263.636-2.204.636l-.347-.019-.284-.032c-.199.152-.298.321-.298.507 0 .277.354.417 1.062.417h1.202c.776 0 1.368.167 1.775.5.406.333.61.822.61 1.467 0 .826-.345 1.467-1.034 1.922-.69.455-1.68.683-2.97.683-.986 0-1.74-.172-2.261-.515-.521-.343-.781-.826-.781-1.445 0-.426.133-.782.399-1.069.265-.286.655-.492 1.17-.614a1.278 1.278 0 01-.519-.414.988.988 0 01-.222-.61c0-.27.078-.494.235-.674.156-.179.382-.355.677-.528a1.89 1.89 0 01-.883-.772c-.217-.353-.326-.771-.326-1.252 0-.771.251-1.368.753-1.79.501-.421 1.218-.632 2.151-.632.197 0 .432.018.705.053.271.036.445.063.521.079h2.467zm4.577-.132c.262 0 .479.019.653.057l-.146 1.809a2.215 2.215 0 00-.569-.064c-.616 0-1.096.159-1.44.475-.343.316-.514.759-.514 1.328v3.599h-1.93v-7.072h1.461l.285 1.19h.095c.219-.397.515-.716.888-.958a2.197 2.197 0 011.217-.364m5.159 3.927l-.747.026c-.56.016-.977.118-1.252.303-.274.186-.411.468-.411.848 0 .544.313.815.937.815.446 0 .804-.127 1.071-.385.268-.257.402-.599.402-1.025v-.582zm.569 3.277l-.373-.961h-.05c-.325.408-.659.692-1.003.85-.344.159-.792.238-1.344.238-.678 0-1.214-.195-1.603-.582-.39-.388-.585-.941-.585-1.658 0-.751.263-1.303.787-1.66.525-.356 1.316-.554 2.375-.592l1.227-.038v-.309c0-.717-.367-1.075-1.1-1.075-.566 0-1.23.17-1.992.512l-.639-1.302c.813-.426 1.716-.64 2.706-.64.949 0 1.677.207 2.183.62.506.413.758 1.042.758 1.885v4.712h-1.347zm9.053 0h-1.929v-4.13c0-.51-.086-.893-.257-1.149-.17-.255-.439-.381-.806-.381-.493 0-.851.18-1.075.544-.223.362-.335.958-.335 1.789v3.327h-1.93v-7.072h1.474l.26.906h.107c.19-.326.464-.579.823-.763a2.66 2.66 0 011.233-.275c1.058 0 1.774.345 2.15 1.038h.17c.191-.329.47-.584.839-.766a2.782 2.782 0 011.249-.272c.801 0 1.407.206 1.819.617.411.411.616 1.069.616 1.976v4.611h-1.936v-4.13c0-.51-.085-.893-.256-1.149-.171-.255-.439-.381-.806-.381-.472 0-.825.168-1.059.505-.234.337-.351.872-.351 1.607v3.548m12.114 0h-1.929v-4.13c0-.51-.086-.893-.257-1.149-.17-.255-.439-.381-.805-.381-.494 0-.852.18-1.076.544-.223.362-.335.958-.335 1.789v3.327h-1.929v-7.072h1.473l.26.906h.108c.189-.326.463-.579.822-.763a2.66 2.66 0 011.233-.275c1.058 0 1.775.345 2.151 1.038h.17c.19-.329.469-.584.838-.766a2.788 2.788 0 011.249-.272c.801 0 1.408.206 1.819.617.411.411.616 1.069.616 1.976v4.611h-1.936v-4.13c0-.51-.085-.893-.255-1.149-.171-.255-.44-.381-.807-.381-.472 0-.825.168-1.059.505-.234.337-.351.872-.351 1.607v3.548m8.755-5.831c-.409 0-.73.13-.962.388-.232.26-.364.627-.399 1.104h2.707c-.007-.477-.132-.844-.373-1.104-.24-.258-.564-.388-.973-.388zm.271 5.958c-1.138 0-2.028-.315-2.669-.943-.64-.629-.961-1.518-.961-2.669 0-1.185.296-2.101.889-2.748.592-.647 1.411-.971 2.457-.971.999 0 1.777.285 2.334.854.557.569.834 1.356.834 2.359v.936h-4.56c.022.548.184.977.488 1.284.303.308.729.461 1.277.461a5.28 5.28 0 001.208-.133c.38-.088.775-.229 1.189-.424v1.494a4.499 4.499 0 01-1.082.376 6.82 6.82 0 01-1.404.124z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWfpLogoVerticalEn = {
  "id": "icon--wfp-logo--vertical--en",
  "name": "icon--wfp-logo--vertical--en",
  "tags": "icon--wfp-logo--vertical--en",
  "styles": "",
  "viewBox": "0 0 57 86",
  "width": "57",
  "height": "86",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M2.535 79.1h.513c.479 0 .838-.095 1.076-.285.238-.189.357-.464.357-.827 0-.365-.1-.635-.3-.809-.199-.175-.512-.262-.937-.262h-.709V79.1zm3.52-1.167c0 .791-.247 1.396-.742 1.815-.494.419-1.197.629-2.11.629h-.668v2.615H.975V75.64h2.349c.892 0 1.57.191 2.035.575.464.385.696.957.696 1.718zm3.892-.669c.208 0 .38.015.518.045l-.116 1.438a1.783 1.783 0 00-.453-.05c-.489 0-.87.126-1.144.377-.273.252-.409.604-.409 1.057v2.861H6.809v-5.623H7.97l.227.945h.075c.174-.314.41-.568.706-.761.297-.193.62-.289.969-.289m2.306 2.907c0 .557.091.978.274 1.263.182.284.48.426.892.426.409 0 .704-.141.883-.424.179-.284.269-.706.269-1.265 0-.557-.09-.974-.271-1.253-.181-.277-.478-.417-.89-.417-.41 0-.705.139-.886.415-.181.276-.271.695-.271 1.255zm3.887 0c0 .915-.241 1.631-.724 2.147-.483.517-1.155.775-2.017.775-.539 0-1.015-.118-1.428-.355a2.367 2.367 0 01-.951-1.018c-.221-.443-.331-.959-.331-1.549 0-.919.239-1.633.719-2.143.479-.509 1.153-.764 2.022-.764.54 0 1.016.117 1.428.352.412.235.729.572.95 1.011.222.439.332.954.332 1.544zm1.954-.961c0 .306.069.547.209.725.139.177.351.266.636.266.288 0 .499-.089.633-.266.134-.178.201-.419.201-.725 0-.677-.278-1.016-.834-1.016-.564 0-.845.339-.845 1.016zm-.558 4.577c0 .211.101.377.304.498.203.12.487.181.852.181.55 0 .981-.075 1.293-.227.312-.15.467-.356.467-.618 0-.212-.092-.357-.276-.437-.184-.081-.47-.121-.855-.121h-.795c-.282 0-.517.066-.706.199a.609.609 0 00-.284.525zm4.34-6.418v.78l-.881.226c.162.252.242.533.242.846 0 .603-.21 1.073-.631 1.41-.421.337-1.005.506-1.753.506l-.276-.016-.226-.025c-.158.121-.237.255-.237.402 0 .222.281.332.845.332h.955c.617 0 1.087.133 1.411.398.324.264.485.654.485 1.167 0 .657-.273 1.167-.822 1.529-.548.361-1.335.543-2.361.543-.785 0-1.384-.137-1.798-.41-.414-.274-.621-.657-.621-1.15 0-.339.105-.622.317-.849.211-.228.521-.391.93-.489a1.007 1.007 0 01-.412-.329.777.777 0 01-.176-.485c0-.215.062-.393.186-.535.124-.143.303-.283.538-.42a1.514 1.514 0 01-.702-.614 1.875 1.875 0 01-.259-.996c0-.614.199-1.087.599-1.423.399-.335.969-.503 1.71-.503.157 0 .344.014.56.043.217.028.355.049.415.062h1.962zm3.638-.105c.208 0 .38.015.518.045l-.116 1.438a1.78 1.78 0 00-.452-.05c-.489 0-.871.126-1.144.377-.274.252-.41.604-.41 1.057v2.861h-1.534v-5.623h1.161l.227.945h.075c.175-.314.41-.568.707-.761a1.74 1.74 0 01.968-.289m4.103 3.123l-.593.02c-.447.014-.779.094-.996.241-.218.148-.327.373-.327.674 0 .433.248.65.744.65.356 0 .64-.103.853-.308.213-.204.319-.476.319-.814v-.463zm.453 2.605l-.297-.764h-.04c-.259.325-.524.55-.797.676-.274.126-.63.189-1.069.189-.54 0-.965-.155-1.275-.463-.31-.309-.465-.747-.465-1.318 0-.596.208-1.037.626-1.32.417-.283 1.047-.44 1.888-.471l.976-.029v-.247c0-.569-.291-.854-.875-.854-.449 0-.977.135-1.584.407l-.508-1.036a4.567 4.567 0 012.152-.508c.754 0 1.333.164 1.735.493.403.328.604.828.604 1.498v3.747H30.07zm7.197 0h-1.534v-3.284c0-.405-.068-.71-.203-.913-.136-.202-.35-.304-.642-.304-.392 0-.677.144-.855.433-.178.288-.266.763-.266 1.423v2.645h-1.534v-5.623h1.172l.206.72h.085c.151-.259.369-.46.654-.607.285-.145.612-.218.981-.218.841 0 1.412.275 1.71.825h.136c.15-.262.373-.465.666-.608.293-.145.624-.217.993-.217.637 0 1.12.164 1.446.49.327.327.49.852.49 1.572v3.666h-1.538v-3.284c0-.405-.068-.71-.204-.913-.136-.202-.349-.304-.641-.304-.376 0-.657.134-.843.403-.186.267-.279.693-.279 1.277v2.821m9.632 0h-1.534v-3.284c0-.405-.068-.71-.204-.913-.135-.202-.349-.304-.641-.304-.392 0-.677.144-.855.433-.178.288-.266.763-.266 1.423v2.645h-1.534v-5.623h1.171l.207.72h.085c.151-.259.369-.46.654-.607.285-.145.612-.218.981-.218.841 0 1.411.275 1.71.825h.135c.151-.262.373-.465.667-.608.293-.145.624-.217.993-.217.637 0 1.119.164 1.446.49.327.327.49.852.49 1.572v3.666h-1.538v-3.284c0-.405-.068-.71-.205-.913-.135-.202-.349-.304-.641-.304-.375 0-.656.134-.842.403-.186.267-.279.693-.279 1.277v2.821m6.96-4.637c-.325 0-.58.103-.764.309-.184.207-.29.499-.317.878h2.153c-.007-.379-.106-.671-.297-.878-.191-.206-.449-.309-.775-.309zm.217 4.738c-.906 0-1.613-.25-2.123-.749-.51-.5-.764-1.207-.764-2.123 0-.942.235-1.67.706-2.185.471-.515 1.123-.772 1.954-.772.795 0 1.414.226 1.856.678.442.454.664 1.079.664 1.876v.745h-3.626c.017.436.146.776.387 1.021.241.245.58.367 1.016.367.338 0 .659-.035.96-.105.302-.071.617-.183.946-.337v1.186a3.547 3.547 0 01-.86.3 5.376 5.376 0 01-1.116.098zM8.306 71.654H6.531l-.996-3.862c-.037-.138-.1-.422-.188-.853a9.897 9.897 0 01-.154-.867c-.019.181-.07.472-.15.872a19.25 19.25 0 01-.187.858l-.99 3.852h-1.77L.22 64.302h1.534l.94 4.012c.164.742.283 1.384.357 1.927.02-.191.066-.487.138-.887.073-.401.14-.712.203-.933l1.072-4.119h1.473l1.072 4.119c.047.184.105.466.176.845.071.379.123.704.161.975.034-.262.088-.588.161-.978.074-.391.14-.706.201-.949l.935-4.012h1.535l-1.872 7.352m3.586-2.821c0 .557.091.978.274 1.263.182.284.48.427.892.427.41 0 .705-.142.883-.425.18-.284.27-.705.27-1.265 0-.557-.091-.974-.272-1.253-.181-.277-.478-.417-.89-.417-.409 0-.704.139-.885.415-.182.276-.272.695-.272 1.255zm3.888 0c0 .915-.242 1.631-.724 2.147-.483.517-1.156.775-2.017.775-.54 0-1.016-.118-1.429-.355a2.365 2.365 0 01-.95-1.018c-.222-.442-.332-.959-.332-1.549 0-.919.239-1.633.719-2.143.479-.509 1.154-.764 2.022-.764.54 0 1.016.117 1.428.352.413.235.729.572.951 1.011.221.44.332.954.332 1.544zm4.211-2.907c.208 0 .38.015.518.045l-.116 1.438a1.783 1.783 0 00-.453-.05c-.489 0-.87.126-1.143.377-.274.252-.41.604-.41 1.057v2.861h-1.535v-5.623h1.163l.226.946h.075c.174-.315.41-.569.706-.762.297-.193.62-.289.969-.289m1.326 5.728h1.534v-7.825h-1.534zm5.311-1.121c.392 0 .679-.114.862-.343.183-.227.282-.615.3-1.161v-.166c0-.603-.094-1.036-.279-1.298-.187-.261-.49-.392-.909-.392a.9.9 0 00-.796.435c-.19.29-.285.712-.285 1.265 0 .554.096.968.286 1.245.192.277.465.415.821.415zm-.538 1.222c-.661 0-1.18-.257-1.557-.77-.377-.512-.565-1.223-.565-2.132 0-.922.191-1.64.575-2.155.384-.514.913-.772 1.587-.772.707 0 1.247.275 1.619.825h.051a6.294 6.294 0 01-.117-1.122v-1.8h1.54v7.825h-1.177l-.297-.729h-.066c-.348.554-.879.83-1.593.83zm8.593-.101h-1.534v-7.352h4.215v1.277h-2.681v1.896h2.496v1.272h-2.496v2.907m5.015-2.821c0 .557.092.978.275 1.263.182.284.48.427.892.427.409 0 .703-.142.883-.425.179-.284.268-.705.268-1.265 0-.557-.089-.974-.271-1.253-.181-.277-.477-.417-.89-.417-.409 0-.704.139-.885.415-.181.276-.272.695-.272 1.255zm3.888 0c0 .915-.241 1.631-.724 2.147-.483.517-1.155.775-2.017.775-.539 0-1.016-.118-1.428-.355a2.361 2.361 0 01-.951-1.018c-.221-.442-.331-.959-.331-1.549 0-.919.239-1.633.718-2.143.48-.509 1.154-.764 2.022-.764.54 0 1.016.117 1.429.352.412.235.729.572.95 1.011.221.44.332.954.332 1.544zm2.328 0c0 .557.091.978.273 1.263.183.284.481.427.893.427.409 0 .704-.142.883-.425.18-.284.269-.705.269-1.265 0-.557-.091-.974-.271-1.253-.182-.277-.479-.417-.891-.417-.409 0-.704.139-.884.415-.182.276-.272.695-.272 1.255zm3.888 0c0 .915-.242 1.631-.725 2.147-.482.517-1.155.775-2.016.775-.541 0-1.016-.118-1.429-.355a2.367 2.367 0 01-.951-1.018c-.221-.442-.332-.959-.332-1.549 0-.919.24-1.633.719-2.143.48-.509 1.155-.764 2.023-.764.54 0 1.015.117 1.428.352.412.235.729.572.951 1.011.22.44.332.954.332 1.544zm3.446 1.7c.392 0 .68-.114.863-.343.183-.227.283-.615.299-1.161v-.166c0-.603-.093-1.036-.279-1.298-.186-.261-.488-.392-.908-.392a.9.9 0 00-.797.435c-.19.29-.285.712-.285 1.265 0 .554.096.968.288 1.245.191.277.464.415.819.415zm-.538 1.222c-.66 0-1.179-.257-1.557-.77-.377-.512-.565-1.223-.565-2.132 0-.922.192-1.64.576-2.155.384-.514.912-.772 1.587-.772.707 0 1.247.275 1.619.825h.05a6.276 6.276 0 01-.115-1.122v-1.8h1.539v7.825h-1.177l-.297-.729h-.065c-.349.554-.88.83-1.595.83zM35.847 4.482h.548c.512 0 .895-.101 1.149-.303.254-.202.382-.497.382-.884 0-.39-.107-.678-.32-.864-.213-.186-.547-.28-1.002-.28h-.757v2.331zm3.76-1.246c0 .845-.264 1.492-.793 1.939-.528.448-1.278.672-2.253.672h-.714V8.64h-1.665V.787h2.508c.953 0 1.677.205 2.173.615.496.411.744 1.021.744 1.834zM30.071 8.64h-1.638V.787h4.5v1.364h-2.862v2.026h2.664v1.358h-2.664V8.64zm-4.526 0h-1.896l-1.063-4.126c-.04-.146-.107-.45-.201-.91a9.914 9.914 0 01-.164-.926c-.022.194-.076.504-.161.932-.086.427-.153.733-.199.915L20.803 8.64h-1.89L16.909.787h1.638l1.005 4.286c.175.791.302 1.477.38 2.057.022-.204.071-.52.148-.947a10.5 10.5 0 01.218-.997L21.442.787h1.573l1.145 4.399c.05.197.112.498.188.902.075.405.132.752.171 1.042.036-.279.094-.628.172-1.045.079-.416.151-.754.216-1.012l.998-4.286h1.638L25.545 8.64zm-4.072 27.312c-3.051 0-5.01.725-5.544.949-.032.014-.058-.031-.033-.055 3.352-3.486 7.278-3.293 8.222-3.293H35.28c.562 0 1.018.537 1.018 1.2 0 .662-.456 1.199-1.018 1.199H21.473zm2.514 3.085c-3.287 0-4.245-1.868-9.222-.635-.034.009-.057-.038-.028-.057 2.775-1.904 5.792-1.731 7.011-1.731H35.28c.562 0 1.018.537 1.018 1.199 0 .663-.456 1.2-1.018 1.2 0 0-8.69.024-11.293.024zm.234 3.037c-3.375 0-3.645-2.49-8.647-3.051-.035-.003-.039-.055-.005-.064 4.11-1.027 5.638.716 8.037.716H35.28c.562 0 1.018.537 1.018 1.199 0 .663-.456 1.2-1.018 1.2H24.221zm-.733-9.182c-2.716 0-4.968 1.184-5.495 1.483-.029.017-.059-.019-.04-.046.441-.648 2.82-3.837 6.911-3.837H35.28c.562 0 1.018.537 1.018 1.2 0 .662-.456 1.2-1.018 1.2H23.488zm14.941-6.625a.741.741 0 00-.443-.205.733.733 0 00-.363.042c.048-.098.087-.204.103-.329a.861.861 0 00-.084-.513c-.336-.736.624-2.208.504-2.275-.116-.063-.662 1.56-1.192 2.217a.922.922 0 00-.199.488.913.913 0 00.086.513c.074.133.187.226.318.234a.294.294 0 00.107-.005.322.322 0 00-.018.058.452.452 0 00.142.388.71.71 0 00.441.207.776.776 0 00.493-.092c.719-.394 2.21-.782 2.178-.92-.029-.138-1.483.715-2.073.192zm1.1-1.074a.63.63 0 00-.407-.199.64.64 0 00-.268.042c.014-.045.032-.085.037-.13a.721.721 0 00-.102-.463c-.365-.677.587-1.955.464-2.019-.123-.064-.645 1.368-1.176 1.934a.688.688 0 00-.196.426.768.768 0 00.099.465.5.5 0 00.339.228.512.512 0 00.179-.021c-.004.008-.011.019-.008.026a.526.526 0 00.139.399.628.628 0 00.404.194.613.613 0 00.433-.117c.619-.446 2.036-.712 2-.855-.035-.139-1.391.611-1.937.09zm.963-.994a.55.55 0 00-.389-.103.535.535 0 00-.196.05c.01-.029.029-.053.039-.083a.7.7 0 00-.024-.43c-.231-.664.793-1.647.693-1.727-.1-.074-.763 1.116-1.309 1.536a.64.64 0 00-.231.354.632.632 0 00.021.427.433.433 0 00.265.255.384.384 0 00.27-.026.408.408 0 00-.024.17c.013.135.079.25.187.329.102.08.241.12.386.109a.585.585 0 00.367-.175c.491-.497 1.714-.962 1.664-1.082-.052-.119-1.152.765-1.719.396zm1.895-2.134c-.102-.151-.958.787-1.591.877a.67.67 0 00-.359.178.704.704 0 00-.221.361.382.382 0 00.055.325.331.331 0 00.3.109.66.66 0 00.365-.181.742.742 0 00.215-.356c.191-.643 1.312-1.214 1.236-1.313zm-17.694 1.27c-.026.094-.21.816-.21.816-.052.03-.273-.018-.331-.024-.422-.04-.8-.406-.637-.845.132-.358.403-.396.748-.411.142-.007.399.027.528.116 0 0-.051.165-.098.348zm-.486 2.182l-.039.247c-.262-.164-.417-.542-.291-.84.097-.225.337-.285.514-.295a49.8 49.8 0 00-.184.888zm-.377 2.697c-.033.185-.284.21-.455.261-.495.148-.965.085-1.117-.508-.166-.635.315-.901.829-1.026.281-.066.54-.01.732.226.049.059.105.112.118.168 0 0-.076.705-.107.879zm-1.562-3.122c.383-.093.779-.237 1.073.141.31.395.208 1.031-.291 1.198-.328.111-.724.207-1.005-.061-.367-.351-.341-1.148.223-1.278zm-.375-2.057c.404-.098.821-.247 1.131.149.323.415.215 1.084-.307 1.259-.346.115-.764.216-1.058-.066-.386-.367-.357-1.204.234-1.342zm-.376 4.445c-.105.37-.409.426-.729.503-.21-.258-.773-.909-.784-.986a.202.202 0 01.012-.09c.026-.077.116-.152.181-.194.192-.125.601-.218.822-.173.396.085.603.569.498.94zm-2.004-1.899c-.29-1.023 1.427-1.47 1.692-.465.273 1.031-1.459 1.469-1.692.465zm-.252-2.043c-.294-1.018 1.43-1.465 1.695-.466.273 1.034-1.462 1.472-1.695.466zm-.242-2.009c-.281-.949 1.338-1.369 1.585-.433.255.962-1.364 1.376-1.585.433zm-.165 3.866c-.08.047-.11.072-.136.072l-.771-.838c.009-.023.248-.196.327-.241.64-.356 1.168.661.58 1.007zm-1.462-1.887c-.381-.84 1.005-1.751 1.425-.845.385.835-1 1.762-1.425.845zm1.165-2.659c.438.778-.882 1.647-1.26.81-.336-.723.838-1.565 1.26-.81zm-1.107-1.815c.194-.172.419-.266.65-.155.371.179.381.734.058.954-.147.102-.396.226-.577.181-.397-.101-.472-.679-.131-.98zm.049-1.669c.161-.108.373-.205.557-.13.334.136.323.621.052.815-.123.088-.346.197-.496.157-.338-.085-.421-.633-.113-.842zm.888-2.378c.198-.108.485-.152.664.048a.468.468 0 01-.134.733c-.213.107-.499.146-.667-.051a.48.48 0 01.137-.73zm-.158 1.806c-.16-.595.843-.876 1.005-.271.181.588-.845.88-1.005.271zm1.617 1.04c.233.643-.856 1.007-1.068.372-.218-.643.876-1.01 1.068-.372zm.136-3.133c.208-.084.474-.173.706 0 .289.216.226.701-.105.853-.218.098-.496.164-.69-.008-.247-.221-.26-.705.089-.845zm-.192 5.381c-.294.068-.6.186-.844-.067-.313-.322-.223-.885.199-1.039.273-.103.62-.162.843.066.285.293.254.931-.198 1.04zm.006-3.285c-.189-.637.85-.964 1.05-.345.204.635-.872.972-1.05.345zm1.74 1.169c.244.728-.987 1.117-1.213.399-.228-.733 1.011-1.121 1.213-.399zm.065-1.95c.217-.058.447-.037.612.141.252.271.165.733-.207.802-.176.032-.447.019-.583-.101-.247-.217-.235-.731.178-.842zm1.05 1.528c.396 0 .596.582.365.872-.139.175-.439.186-.643.154-.378-.059-.619-.545-.365-.875.155-.199.42-.151.643-.151zm-1.903 2.397c-.244-.837 1.179-1.212 1.397-.38.22.845-1.21 1.217-1.397.38zm.872 1.071c.388-.04.792-.131 1.031.276.25.43.063 1.028-.441 1.129-.33.069-.732.101-.968-.191-.31-.388-.186-1.162.378-1.214zm1.975-1.865c.479.198.641.765.303 1.081-.181.165-.512.132-.735.087-.446-.087-.738-.758-.346-1.076.2-.163.559-.182.778-.092zm.754 2.019c.302.369.189 1.022-.338 1.055-.276.015-.636-.016-.822-.242-.299-.362-.186-1.039.341-1.058.276-.01.633.019.819.245zm2.04-6.665a.122.122 0 00-.135-.05c-.063.021-.105.091-.081.152 1.205 3.236-.333 4.83-.976 7.097-.772-1.842 1.784-3.574.467-6.93a.135.135 0 00-.1-.085c-.065-.008-.128.019-.139.106-.034.237-.189 2.097-1.698 3.186a3.001 3.001 0 00-.703-1.02c-.139-.627-.548-1.488-1.409-1.743-.129-.324-.389-.79-.888-1.039-.469-.234-1.012-.213-1.616.061-.73.085-1.231.369-1.496.845-.249.449-.205.938-.121 1.27-.614.656-.643 1.629-.627 2.009-.365.876-.16 1.9-.045 2.325-.435 1.19-.01 2.346.16 2.729 0 .103.006.202.011.3-1.428-1.563-4.677-3.497-5.918-4.235a.148.148 0 00-.181.021.152.152 0 00-.008.217c2.769 2.7 5.238 6.032 7.611 12.946 1.184-1.23 3.322-2.849 6.367-2.849h3.561c-2.263-8.428 1.032-11.444-2.036-15.313zm16.835 4.358c-.651-.17-4.808-.906-9.466 7.663.679-3.191 2.745-7.052 3.312-8.173v-.008a.155.155 0 00-.042-.191.135.135 0 00-.189.034c-3.079 5.134-4.16 8.091-4.798 11.63h1.929c.328-3.411 4.638-11.449 9.23-10.851h.005c.027.005.05-.016.053-.04a.048.048 0 00-.034-.064zm-9.262 28.233l-1.042-4.356h-1.774c.281 1.106.682 2.23 1.202 3.215.035.059.098.094.161.083a.163.163 0 00.133-.189c-.121-.922-.265-1.812-.401-2.699.375 1.394.881 2.757 1.564 4.012.018.039.058.058.094.045.05-.011.076-.063.063-.111zm1.793-1.978c-.181-.727-.37-1.621-.533-2.378h-.674c.262.808.616 1.709.931 2.48.032.074.103.111.171.093a.161.161 0 00.105-.195zm.225 2.562l-.005-.011c-.218-.608-.519-1.153-.758-1.737a23.043 23.043 0 01-.706-1.759 21.001 21.001 0 01-.491-1.433h-.651c.184.545.423 1.132.646 1.659.491 1.187 1.058 2.351 1.779 3.392a.102.102 0 00.123.035c.058-.021.084-.088.063-.146zm.974-20.901c-.05-.074-.17-.09-.228-.029a13.347 13.347 0 00-2.147 3.068h.704c.351-.826 1.144-2.285 1.653-2.81l.005-.006a.18.18 0 00.013-.223zM31.6 20.729c.651-1.068 1.617-1.887 2.436-2.875a.099.099 0 00-.008-.128.083.083 0 00-.118-.002 12.49 12.49 0 01-.58.571c-.086-.043-.307.042-.53.218-.176.138-.302.292-.347.403-.112-.026-.325.107-.517.352-.157.204-.249.42-.246.552-.121.011-.297.165-.446.409a1.327 1.327 0 00-.182.449 1.247 1.247 0 00-.309.354c-.134.223-.202.449-.181.579-.032.056-.063.109-.09.165l.016-.133c.192-1.512.47-3.011.892-4.456.426-1.44.935-2.893 1.809-4.06l.005-.005a.166.166 0 00-.016-.21.138.138 0 00-.205-.003c-.302.321-.556.68-.784 1.049-.1-.053-.31.144-.47.452-.147.279-.199.537-.144.636 0 0-.003.007-.008.005-.105-.046-.299.188-.417.502-.116.295-.137.566-.058.656-.005.005-.005.008-.008.013-.118-.042-.31.226-.428.606-.097.322-.108.601-.037.713.006.004 0 .018-.005.015-.121-.042-.304.234-.412.611-.108.364-.1.686.003.749-.118-.013-.284.264-.37.638-.079.324-.071.604.005.715-.116.035-.244.306-.31.656-.063.343-.031.628.053.718-.108.056-.218.335-.258.68-.039.343.011.625.1.715-.089.101-.175.34-.212.627-.037.273-.014.51.039.643-.097.083-.17.359-.173.691-.008.266.031.491.1.622-.053.132-.09.327-.09.542-.005.279.04.518.11.643-.02.98-.007 2.025.045 3.007h2.118a30.77 30.77 0 01.142-2.356c.15-1.35.373-2.721 1.047-3.874l.005-.008a.115.115 0 00-.013-.128c-.039-.034-.095-.034-.131.008-.916 1.063-1.318 2.506-1.554 3.89-.042.271-.076.545-.107.816.057-1.111.16-2.216.414-3.268.292-1.281.874-2.501 1.984-3.184a.098.098 0 00.04-.111c-.014-.051-.066-.08-.111-.067-.071.022-.136.059-.204.088-.074-.09-.344-.024-.622.154-.265.173-.441.385-.423.502 0 .006-.013.014-.013.003-.002-.013-.005-.027-.013-.034-.1-.083-.367.103-.593.419-.228.316-.318.646-.221.731.006.002.003.011-.002.011-.118-.048-.315.22-.439.595-.089.263-.11.505-.078.643 0 .005-.006.01-.006.01-.091.304-.168.609-.238.92.026-.439.065-.88.128-1.315.187-1.255.565-2.482 1.236-3.529zm6.664-3.497a.74.74 0 00-.486-.037.8.8 0 00-.325.17.924.924 0 00-.018-.345.832.832 0 00-.253-.45c-.572-.571-.178-2.29-.312-2.311-.131-.019-.084 1.695-.354 2.497a.92.92 0 00-.019.529.896.896 0 00.26.452c.113.098.25.143.378.103a.227.227 0 00.097-.042c0 .021 0 .042.003.064.029.14.129.25.265.313a.71.71 0 00.488.037.777.777 0 00.428-.26c.538-.624 1.803-1.515 1.727-1.634-.076-.117-1.145 1.196-1.879.914zm2.446-2.166c-.082-.116-1.094 1.066-1.785.771a.637.637 0 00-.452-.043.685.685 0 00-.235.133c-.003-.048 0-.09-.011-.133a.706.706 0 00-.254-.398c-.578-.505-.124-2.041-.26-2.057-.139-.016-.137 1.512-.436 2.23a.687.687 0 00-.037.467.719.719 0 00.255.401.488.488 0 00.394.094.488.488 0 00.16-.083c0 .008-.003.019 0 .027.042.146.141.26.27.327a.64.64 0 00.446.037.634.634 0 00.365-.26c.427-.641 1.661-1.39 1.58-1.513zm.249-1.479c-.089-.093-.816 1.123-1.475.977a.561.561 0 00-.399.04.562.562 0 00-.168.117c0-.029.008-.058.008-.09a.672.672 0 00-.17-.394c-.444-.542.173-1.825.054-1.865-.12-.035-.33 1.316-.697 1.903a.625.625 0 00-.095.412.654.654 0 00.168.396c.095.098.21.151.336.143a.368.368 0 00.244-.12c0 .054.01.112.037.168.058.122.16.207.286.242.123.04.27.029.402-.035a.601.601 0 00.283-.292c.288-.641 1.273-1.509 1.186-1.602zm-.436-1.691c-.149-.106-.624 1.077-1.189 1.385a.683.683 0 00-.275.295.715.715 0 00-.079.414c.014.125.071.232.163.285a.316.316 0 00.315-.003.677.677 0 00.281-.297.747.747 0 00.078-.413c-.042-.669.811-1.599.706-1.666zM30.165 42.735h-5.944a6.256 6.256 0 01-1.102-.09c.976 1.451 2.506 2.551 4.057 3.29.239 1.323.538 2.547.645 2.643.11.096 1.632-.343 1.68-.483.044-.141-.622-2.408-.622-2.408.801-1.374 1.047-2.184 1.286-2.952zm14.954 10.169c-1.501.593-3.459.643-5.058.218-3.661-1.14-7.726-3.3-11.628-1.507-3.903-1.793-7.968.367-11.629 1.507-1.598.425-3.556.375-5.057-.218a.039.039 0 00-.037.067c2.16 1.671 5.186 2.439 7.91 1.456 2.617-.816 4.829-3.587 7.928-2.405-2.453.959-4.747 2.729-6.519 4.4l1.289 1.057c1.609-1.873 3.42-3.746 5.469-4.885.281-.165.449-.232.646-.242.197.01.365.077.643.242 2.052 1.139 3.863 3.012 5.472 4.885l1.288-1.057c-1.771-1.671-4.065-3.441-6.519-4.4 3.099-1.182 5.312 1.589 7.928 2.405 2.725.983 5.75.215 7.911-1.456.034-.03.005-.082-.037-.067zM20.99 50.38c-3.827-.928-4.873-4.515-8.073-6.071-.034-.019-.07.021-.049.052 1.007 1.659 1.553 4.199 4.458 5.764.024.013.011.051-.016.042-4.167-.802-5.918.313-10.285-1.66-.036-.017-.075.023-.052.058 1.436 2.083 4.842 3.507 9.508 3.115 1.68-.144 2.898-.851 4.509-1.228.039-.011.039-.064 0-.072zm-8.015-2.2c-1.454-1.906-1.039-5.973-4.322-9.696-.027-.029-.074-.005-.066.032.627 2.742.441 5.856 2.157 8.138.016.025-.008.048-.031.033-3.386-2.666-6.865-3.468-8.414-5.625-.024-.03-.071-.014-.066.023.384 2.793 5.748 7.145 10.713 7.153.029 0 .048-.034.029-.058zm-5.084-5.065c-1.558-2.89.305-7.302-1.464-11.588-.018-.045-.086-.034-.086.014-.053 2.341-1.507 5.835-.628 8.474.011.023-.021.037-.034.015-2.239-3.27-4.015-3.954-5.496-6.948-.02-.045-.088-.032-.091.016-.095 2.035.805 3.693 1.821 5.234a17.39 17.39 0 005.929 4.836c.034.017.065-.019.049-.053zM6.834 25.509c-.003-.048-.066-.064-.089-.021-1.189 2.224-3.307 3.993-3.375 6.93-.003.029-.035.031-.04.005-.385-2.267-2.309-4.807-2.393-8.089 0-.05-.071-.063-.089-.015-1.583 4.267.692 8.314 3.115 11.657.026.034.078.013.078-.033-.099-3.542 2.972-6.185 2.793-10.434zm1.512-5.522c-1.123 1.56-3.651 2.663-4.575 4.913-.013.033-.052.024-.047-.013.367-2.521-.606-5.45.307-8.8.013-.048-.047-.08-.076-.043-1.38 1.698-1.848 3.688-1.924 5.838-.094 2.641.835 4.568 1.294 6.359.01.042.065.039.076-.003.661-2.349 3.981-3.762 5.021-8.213.013-.048-.048-.077-.076-.038zm3.046-5.245c-1.847 1.448-4.669 2.843-5.274 3.851-.011.021-.042.005-.037-.016l.684-3.287c.308-1.395.573-2.732 1.344-3.981.024-.037-.021-.08-.055-.053-3.516 2.785-3.002 6.813-3.157 10.111-.003.034.039.05.063.026 2.071-2.245 5.446-3.553 6.49-6.605.013-.037-.026-.07-.058-.046zm2.617-5.048c-3.107.098-5.39 2.715-6.369 6.047-.006.019.021.035.036.024 4.281-3.138 4.042-4.482 6.359-5.975.042-.027.024-.096-.026-.096zm35.828 38.813c-4.364 1.973-6.117.858-10.285 1.66-.026.009-.039-.029-.016-.042 2.906-1.565 3.452-4.105 4.459-5.764.021-.031-.015-.071-.049-.052-3.197 1.556-4.244 5.143-8.073 6.071-.04.008-.04.061 0 .072 1.611.377 2.829 1.084 4.509 1.228 4.666.392 8.075-1.032 9.508-3.115.024-.035-.016-.075-.053-.058zm4.727-7.445c-1.549 2.157-5.028 2.959-8.414 5.625-.021.015-.047-.008-.029-.033 1.714-2.282 1.528-5.396 2.155-8.138.008-.037-.039-.061-.066-.032-3.28 3.723-2.868 7.79-4.32 9.696a.036.036 0 00.029.058c4.966-.008 10.327-4.36 10.711-7.153.005-.037-.042-.053-.066-.023zm2.207-7.964c-.002-.048-.071-.061-.092-.016-1.48 2.994-3.257 3.678-5.493 6.948-.015.022-.044.008-.036-.015.879-2.639-.573-6.133-.628-8.474 0-.048-.068-.059-.086-.014-1.769 4.286.094 8.698-1.462 11.588-.018.034.013.07.047.053a17.39 17.39 0 005.929-4.836c1.015-1.541 1.916-3.199 1.821-5.234zm-.756-8.779c-.018-.048-.089-.035-.089.015-.084 3.282-2.008 5.822-2.393 8.089-.006.026-.037.024-.037-.005-.068-2.937-2.189-4.706-3.378-6.93a.045.045 0 00-.086.021c-.179 4.249 2.889 6.892 2.789 10.434 0 .046.055.067.082.033 2.419-3.343 4.695-7.39 3.112-11.657zm-1.183-2.437c-.076-2.15-.544-4.14-1.924-5.838-.029-.037-.087-.005-.076.043.913 3.35-.061 6.279.309 8.8.006.037-.036.046-.049.013-.924-2.25-3.452-3.353-4.574-4.913-.027-.039-.087-.01-.077.038 1.039 4.451 4.359 5.864 5.021 8.213.01.042.065.045.076.003.459-1.791 1.388-3.718 1.294-6.359zm-6.024-10.626c-.034-.027-.078.016-.055.053.772 1.249 1.037 2.586 1.344 3.981l.685 3.287c.005.021-.026.037-.037.016-.606-1.008-3.424-2.403-5.274-3.851-.03-.024-.071.009-.059.046 1.045 3.052 4.42 4.36 6.491 6.605.024.024.066.008.063-.026-.155-3.298.36-7.326-3.158-10.111zm-5.954-1.562c-.05 0-.065.069-.027.096 2.318 1.493 2.079 2.837 6.359 5.975.019.011.042-.005.037-.024-.979-3.332-3.262-5.949-6.369-6.047z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};